var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLevel3Clothes(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 82,
    height: 70,
    viewBox: "0 0 82 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("path", {
    d: "M82.0004 42.9371H80.4131V44.5334H82.0004V42.9371Z",
    fill: "#FFE4CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.9548 42.9591H80.4346V44.488H81.9548V42.9591Z",
    fill: "#FFE4CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.0004 41.3845H80.4131V42.9808H82.0004V41.3845Z",
    fill: "#FFE4CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.9548 41.407H80.4346V42.958H81.9548V41.407Z",
    fill: "#FFE4CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.0004 39.8329H80.4131V41.4292H82.0004V39.8329Z",
    fill: "#FFE4CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.9548 39.8552H80.4346V41.4062H81.9548V39.8552Z",
    fill: "#FFE4CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.0004 38.3031H80.4131V39.8995H82.0004V38.3031Z",
    fill: "#FFE4CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.9548 38.3251H80.4346V39.8762H81.9548V38.3251Z",
    fill: "#FFE4CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.0004 36.751H80.4131V38.3474H82.0004V36.751Z",
    fill: "#FFE4CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.9548 36.773H80.4346V38.3019H81.9548V36.773Z",
    fill: "#FFE4CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.0004 35.2212H80.4131V36.8176H82.0004V35.2212Z",
    fill: "#FFE4CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.9548 35.2432H80.4346V36.7943H81.9548V35.2432Z",
    fill: "#FFE4CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.0004 33.6691H80.4131V35.2655H82.0004V33.6691Z",
    fill: "#FFE4CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.9548 33.6912H80.4346V35.2422H81.9548V33.6912Z",
    fill: "#FFE4CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.0004 32.1396H80.4131V33.736H82.0004V32.1396Z",
    fill: "#FFE4CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.9548 32.1614H80.4346V33.7124H81.9548V32.1614Z",
    fill: "#FFE4CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.0004 30.5872H80.4131V32.1836H82.0004V30.5872Z",
    fill: "#FFE4CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.9548 30.6095H80.4346V32.1384H81.9548V30.6095Z",
    fill: "#FFE4CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.0004 29.0572H80.4131V30.6536H82.0004V29.0572Z",
    fill: "#FFE4CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.9548 29.08H80.4346V30.631H81.9548V29.08Z",
    fill: "#FFE4CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.0004 27.5051H80.4131V29.1015H82.0004V27.5051Z",
    fill: "#FFE4CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.9548 27.5274H80.4346V29.0784H81.9548V27.5274Z",
    fill: "#FFE4CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.0004 25.9758H80.4131V27.5721H82.0004V25.9758Z",
    fill: "#FFE4CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.9548 25.9973H80.4346V27.5483H81.9548V25.9973Z",
    fill: "#FFE4CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.0004 24.4237H80.4131V26.0201H82.0004V24.4237Z",
    fill: "#FFE4CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.9548 24.4455H80.4346V25.9744H81.9548V24.4455Z",
    fill: "#FFE4CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.0004 22.8719H80.4131V24.4683H82.0004V22.8719Z",
    fill: "#FFE4CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.9548 22.916H80.4346V24.467H81.9548V22.916Z",
    fill: "#FFE4CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.0004 21.3418H80.4131V22.9382H82.0004V21.3418Z",
    fill: "#FFE4CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.9548 21.3638H80.4346V22.9149H81.9548V21.3638Z",
    fill: "#FFE4CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.4565 67.5919H78.8691V69.1882H80.4565V67.5919Z",
    fill: "#3D041F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.4339 67.6141H78.8916V69.1652H80.4339V67.6141Z",
    fill: "#3D041F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.4565 42.9371H78.8691V44.5334H80.4565V42.9371Z",
    fill: "#FFE4CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.4339 42.9591H78.8916V44.488H80.4339V42.9591Z",
    fill: "#FFE4CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.4565 41.3845H78.8691V42.9808H80.4565V41.3845Z",
    fill: "#FFE4CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.4339 41.407H78.8916V42.958H80.4339V41.407Z",
    fill: "#FFE4CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.4565 39.8329H78.8691V41.4292H80.4565V39.8329Z",
    fill: "#FFE4CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.4339 39.8552H78.8916V41.4062H80.4339V39.8552Z",
    fill: "#FFE4CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.4565 38.3031H78.8691V39.8995H80.4565V38.3031Z",
    fill: "#F57E77"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.4339 38.3251H78.8916V39.8762H80.4339V38.3251Z",
    fill: "#F57E77"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.4565 36.751H78.8691V38.3474H80.4565V36.751Z",
    fill: "#F57E77"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.4339 36.773H78.8916V38.3019H80.4339V36.773Z",
    fill: "#F57E77"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.4565 35.2212H78.8691V36.8176H80.4565V35.2212Z",
    fill: "#F57E77"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.4339 35.2432H78.8916V36.7943H80.4339V35.2432Z",
    fill: "#F57E77"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.4565 33.6691H78.8691V35.2655H80.4565V33.6691Z",
    fill: "#F57E77"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.4339 33.6912H78.8916V35.2422H80.4339V33.6912Z",
    fill: "#F57E77"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.4565 32.1396H78.8691V33.736H80.4565V32.1396Z",
    fill: "#F57E77"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.4339 32.1614H78.8916V33.7124H80.4339V32.1614Z",
    fill: "#F57E77"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.4565 30.5872H78.8691V32.1836H80.4565V30.5872Z",
    fill: "#F57E77"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.4339 30.6095H78.8916V32.1384H80.4339V30.6095Z",
    fill: "#F57E77"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.4565 29.0572H78.8691V30.6536H80.4565V29.0572Z",
    fill: "#F57E77"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.4339 29.08H78.8916V30.631H80.4339V29.08Z",
    fill: "#F57E77"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.4565 27.5051H78.8691V29.1015H80.4565V27.5051Z",
    fill: "#F57E77"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.4339 27.5274H78.8916V29.0784H80.4339V27.5274Z",
    fill: "#F57E77"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.4565 25.9758H78.8691V27.5721H80.4565V25.9758Z",
    fill: "#F57E77"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.4339 25.9973H78.8916V27.5483H80.4339V25.9973Z",
    fill: "#F57E77"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.4565 24.4237H78.8691V26.0201H80.4565V24.4237Z",
    fill: "#F57E77"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.4339 24.4455H78.8916V25.9744H80.4339V24.4455Z",
    fill: "#F57E77"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.4565 22.8719H78.8691V24.4683H80.4565V22.8719Z",
    fill: "#FFE4CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.4339 22.916H78.8916V24.467H80.4339V22.916Z",
    fill: "#FFE4CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.4565 21.3418H78.8691V22.9382H80.4565V21.3418Z",
    fill: "#FFE4CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.4339 21.3638H78.8916V22.9149H80.4339V21.3638Z",
    fill: "#FFE4CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.4565 19.7892H78.8691V21.3856H80.4565V19.7892Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.4339 19.812H78.8916V21.363H80.4339V19.812Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.4565 18.2599H78.8691V19.8563H80.4565V18.2599Z",
    fill: "#243454"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.4339 18.282H78.8916V19.8109H80.4339V18.282Z",
    fill: "#243454"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.4565 16.7079H78.8691V18.3043H80.4565V16.7079Z",
    fill: "#243454"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.4339 16.7294H78.8916V18.2805H80.4339V16.7294Z",
    fill: "#243454"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.9355 67.5919H77.3481V69.1882H78.9355V67.5919Z",
    fill: "#3D041F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.9129 67.6141H77.3706V69.1652H78.9129V67.6141Z",
    fill: "#3D041F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.9355 66.0621H77.3481V67.6584H78.9355V66.0621Z",
    fill: "#541136"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.9129 66.0846H77.3706V67.6135H78.9129V66.0846Z",
    fill: "#541136"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.9355 41.3845H77.3481V42.9808H78.9355V41.3845Z",
    fill: "#FFE4CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.9129 41.407H77.3706V42.958H78.9129V41.407Z",
    fill: "#FFE4CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.9355 39.8329H77.3481V41.4292H78.9355V39.8329Z",
    fill: "#F57E77"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.9129 39.8552H77.3706V41.4062H78.9129V39.8552Z",
    fill: "#F57E77"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.9355 22.8719H77.3481V24.4683H78.9355V22.8719Z",
    fill: "#877A86"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.9129 22.916H77.3706V24.467H78.9129V22.916Z",
    fill: "#877A86"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.9355 21.3418H77.3481V22.9382H78.9355V21.3418Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.9129 21.3638H77.3706V22.9149H78.9129V21.3638Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.9355 19.7892H77.3481V21.3856H78.9355V19.7892Z",
    fill: "#131E33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.9129 19.812H77.3706V21.363H78.9129V19.812Z",
    fill: "#131E33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.9355 18.2599H77.3481V19.8563H78.9355V18.2599Z",
    fill: "#243454"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.9129 18.282H77.3706V19.8109H78.9129V18.282Z",
    fill: "#243454"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.9355 16.7079H77.3481V18.3043H78.9355V16.7079Z",
    fill: "#243454"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.9129 16.7294H77.3706V18.2805H78.9129V16.7294Z",
    fill: "#243454"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.9355 12.0962H77.3481V13.6926H78.9355V12.0962Z",
    fill: "#621931"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.9129 12.1182H77.3706V13.6693H78.9129V12.1182Z",
    fill: "#621931"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.9355 10.5441H77.3481V12.1404H78.9355V10.5441Z",
    fill: "#621931"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.9129 10.5661H77.3706V12.1171H78.9129V10.5661Z",
    fill: "#621931"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.392 67.5919H75.8047V69.1882H77.392V67.5919Z",
    fill: "#3D041F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.3694 67.6141H75.8271V69.1652H77.3694V67.6141Z",
    fill: "#3D041F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.392 66.0621H75.8047V67.6584H77.392V66.0621Z",
    fill: "#541136"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.3694 66.0846H75.8271V67.6135H77.3694V66.0846Z",
    fill: "#541136"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.392 64.5105H75.8047V66.1069H77.392V64.5105Z",
    fill: "#541136"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.3694 64.5325H75.8271V66.0836H77.3694V64.5325Z",
    fill: "#541136"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.392 47.5482H75.8047V49.1446H77.392V47.5482Z",
    fill: "#131E33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.3694 47.571H75.8271V49.1221H77.3694V47.571Z",
    fill: "#131E33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.392 46.0189H75.8047V47.6153H77.392V46.0189Z",
    fill: "#131E33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.3694 46.041H75.8271V47.592H77.3694V46.041Z",
    fill: "#131E33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.392 44.4669H75.8047V46.0632H77.392V44.4669Z",
    fill: "#131E33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.3694 44.4891H75.8271V46.0402H77.3694V44.4891Z",
    fill: "#131E33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.392 42.9371H75.8047V44.5334H77.392V42.9371Z",
    fill: "#131E33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.3694 42.9591H75.8271V44.488H77.3694V42.9591Z",
    fill: "#131E33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.392 41.3845H75.8047V42.9808H77.392V41.3845Z",
    fill: "#131E33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.3694 41.407H75.8271V42.958H77.3694V41.407Z",
    fill: "#131E33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.392 39.8329H75.8047V41.4292H77.392V39.8329Z",
    fill: "#131E33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.3694 39.8552H75.8271V41.4062H77.3694V39.8552Z",
    fill: "#131E33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.392 38.3031H75.8047V39.8995H77.392V38.3031Z",
    fill: "#131E33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.3694 38.3251H75.8271V39.8762H77.3694V38.3251Z",
    fill: "#131E33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.392 36.751H75.8047V38.3474H77.392V36.751Z",
    fill: "#131E33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.3694 36.773H75.8271V38.3019H77.3694V36.773Z",
    fill: "#131E33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.392 35.2212H75.8047V36.8176H77.392V35.2212Z",
    fill: "#131E33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.3694 35.2432H75.8271V36.7943H77.3694V35.2432Z",
    fill: "#131E33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.392 33.6691H75.8047V35.2655H77.392V33.6691Z",
    fill: "#131E33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.3694 33.6912H75.8271V35.2422H77.3694V33.6912Z",
    fill: "#131E33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.392 21.3418H75.8047V22.9382H77.392V21.3418Z",
    fill: "#131E33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.3694 21.3638H75.8271V22.9149H77.3694V21.3638Z",
    fill: "#131E33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.392 19.7892H75.8047V21.3856H77.392V19.7892Z",
    fill: "#131E33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.3694 19.812H75.8271V21.363H77.3694V19.812Z",
    fill: "#131E33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.392 18.2599H75.8047V19.8563H77.392V18.2599Z",
    fill: "#243454"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.3694 18.282H75.8271V19.8109H77.3694V18.282Z",
    fill: "#243454"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.392 16.7079H75.8047V18.3043H77.392V16.7079Z",
    fill: "#243454"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.3694 16.7294H75.8271V18.2805H77.3694V16.7294Z",
    fill: "#243454"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.392 13.626H75.8047V15.2223H77.392V13.626Z",
    fill: "#3D041F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.3694 13.648H75.8271V15.1769H77.3694V13.648Z",
    fill: "#3D041F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.392 12.0962H75.8047V13.6926H77.392V12.0962Z",
    fill: "#621931"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.3694 12.1182H75.8271V13.6693H77.3694V12.1182Z",
    fill: "#621931"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.392 10.5441H75.8047V12.1404H77.392V10.5441Z",
    fill: "#621931"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.3694 10.5661H75.8271V12.1171H77.3694V10.5661Z",
    fill: "#621931"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.392 9.01404H75.8047V10.6104H77.392V9.01404Z",
    fill: "#621931"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.3694 9.03632H75.8271V10.5873H77.3694V9.03632Z",
    fill: "#621931"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.392 7.46222H75.8047V9.05859H77.392V7.46222Z",
    fill: "#621931"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.3694 7.48474H75.8271V9.01361H77.3694V7.48474Z",
    fill: "#621931"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.392 5.93213H75.8047V7.5285H77.392V5.93213Z",
    fill: "#621931"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.3694 5.95416H75.8271V7.50519H77.3694V5.95416Z",
    fill: "#621931"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.871 66.0621H74.2837V67.6584H75.871V66.0621Z",
    fill: "#3D041F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.8264 66.0846H74.3062V67.6135H75.8264V66.0846Z",
    fill: "#3D041F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.871 64.5105H74.2837V66.1069H75.871V64.5105Z",
    fill: "#541136"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.8264 64.5325H74.3062V66.0836H75.8264V64.5325Z",
    fill: "#541136"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.871 62.9807H74.2837V64.5771H75.871V62.9807Z",
    fill: "#541136"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.8264 63.0022H74.3062V64.5532H75.8264V63.0022Z",
    fill: "#541136"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.871 47.5482H74.2837V49.1446H75.871V47.5482Z",
    fill: "#243454"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.8264 47.571H74.3062V49.1221H75.8264V47.571Z",
    fill: "#243454"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.871 46.0189H74.2837V47.6153H75.871V46.0189Z",
    fill: "#243454"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.8264 46.041H74.3062V47.592H75.8264V46.041Z",
    fill: "#243454"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.871 44.4669H74.2837V46.0632H75.871V44.4669Z",
    fill: "#243454"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.8264 44.4891H74.3062V46.0402H75.8264V44.4891Z",
    fill: "#243454"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.871 42.9371H74.2837V44.5334H75.871V42.9371Z",
    fill: "#243454"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.8264 42.9591H74.3062V44.488H75.8264V42.9591Z",
    fill: "#243454"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.871 41.3845H74.2837V42.9808H75.871V41.3845Z",
    fill: "#243454"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.8264 41.407H74.3062V42.958H75.8264V41.407Z",
    fill: "#243454"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.871 39.8329H74.2837V41.4292H75.871V39.8329Z",
    fill: "#243454"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.8264 39.8552H74.3062V41.4062H75.8264V39.8552Z",
    fill: "#243454"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.871 38.3031H74.2837V39.8995H75.871V38.3031Z",
    fill: "#243454"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.8264 38.3251H74.3062V39.8762H75.8264V38.3251Z",
    fill: "#243454"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.871 36.751H74.2837V38.3474H75.871V36.751Z",
    fill: "#243454"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.8264 36.773H74.3062V38.3019H75.8264V36.773Z",
    fill: "#243454"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.871 35.2212H74.2837V36.8176H75.871V35.2212Z",
    fill: "#243454"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.8264 35.2432H74.3062V36.7943H75.8264V35.2432Z",
    fill: "#243454"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.871 33.6691H74.2837V35.2655H75.871V33.6691Z",
    fill: "#131E33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.8264 33.6912H74.3062V35.2422H75.8264V33.6912Z",
    fill: "#131E33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.871 32.1396H74.2837V33.736H75.871V32.1396Z",
    fill: "#131E33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.8264 32.1614H74.3062V33.7124H75.8264V32.1614Z",
    fill: "#131E33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.871 30.5872H74.2837V32.1836H75.871V30.5872Z",
    fill: "#131E33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.8264 30.6095H74.3062V32.1384H75.8264V30.6095Z",
    fill: "#131E33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.871 24.4237H74.2837V26.0201H75.871V24.4237Z",
    fill: "#243454"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.8264 24.4455H74.3062V25.9744H75.8264V24.4455Z",
    fill: "#243454"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.871 22.8719H74.2837V24.4683H75.871V22.8719Z",
    fill: "#243454"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.8264 22.916H74.3062V24.467H75.8264V22.916Z",
    fill: "#243454"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.871 21.3418H74.2837V22.9382H75.871V21.3418Z",
    fill: "#243454"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.8264 21.3638H74.3062V22.9149H75.8264V21.3638Z",
    fill: "#243454"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.871 19.7892H74.2837V21.3856H75.871V19.7892Z",
    fill: "#243454"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.8264 19.812H74.3062V21.363H75.8264V19.812Z",
    fill: "#243454"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.871 18.2599H74.2837V19.8563H75.871V18.2599Z",
    fill: "#243454"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.8264 18.282H74.3062V19.8109H75.8264V18.282Z",
    fill: "#243454"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.871 16.7079H74.2837V18.3043H75.871V16.7079Z",
    fill: "#374F80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.8264 16.7294H74.3062V18.2805H75.8264V16.7294Z",
    fill: "#374F80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.871 13.626H74.2837V15.2223H75.871V13.626Z",
    fill: "#3D041F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.8264 13.648H74.3062V15.1769H75.8264V13.648Z",
    fill: "#3D041F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.871 12.0962H74.2837V13.6926H75.871V12.0962Z",
    fill: "#3D041F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.8264 12.1182H74.3062V13.6693H75.8264V12.1182Z",
    fill: "#3D041F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.871 10.5441H74.2837V12.1404H75.871V10.5441Z",
    fill: "#FEB167"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.8264 10.5661H74.3062V12.1171H75.8264V10.5661Z",
    fill: "#FEB167"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.871 9.01404H74.2837V10.6104H75.871V9.01404Z",
    fill: "#FFE4CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.8264 9.03632H74.3062V10.5873H75.8264V9.03632Z",
    fill: "#FFE4CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.871 7.46222H74.2837V9.05859H75.871V7.46222Z",
    fill: "#3D041F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.8264 7.48474H74.3062V9.01361H75.8264V7.48474Z",
    fill: "#3D041F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.871 5.93213H74.2837V7.5285H75.871V5.93213Z",
    fill: "#3D041F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.8264 5.95416H74.3062V7.50519H75.8264V5.95416Z",
    fill: "#3D041F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.871 4.38007H74.2837V5.97644H75.871V4.38007Z",
    fill: "#621931"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.8264 4.40234H74.3062V5.95337H75.8264V4.40234Z",
    fill: "#621931"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.871 2.82776H74.2837V4.42413H75.871V2.82776Z",
    fill: "#621931"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.8264 2.85028H74.3062V4.40131H75.8264V2.85028Z",
    fill: "#621931"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.3281 66.0621H72.7407V67.6584H74.3281V66.0621Z",
    fill: "#3D041F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.305 66.0846H72.7627V67.6135H74.305V66.0846Z",
    fill: "#3D041F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.3281 64.5105H72.7407V66.1069H74.3281V64.5105Z",
    fill: "#541136"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.305 64.5325H72.7627V66.0836H74.305V64.5325Z",
    fill: "#541136"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.3281 62.9807H72.7407V64.5771H74.3281V62.9807Z",
    fill: "#541136"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.305 63.0022H72.7627V64.5532H74.305V63.0022Z",
    fill: "#541136"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.3281 61.4281H72.7407V63.0245H74.3281V61.4281Z",
    fill: "#FFE4CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.305 61.4501H72.7627V63.0012H74.305V61.4501Z",
    fill: "#FFE4CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.3281 59.8981H72.7407V61.4944H74.3281V59.8981Z",
    fill: "#FFE4CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.305 59.9208H72.7627V61.4497H74.305V59.9208Z",
    fill: "#FFE4CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.3281 58.3463H72.7407V59.9426H74.3281V58.3463Z",
    fill: "#FFE4CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.305 58.3688H72.7627V59.9198H74.305V58.3688Z",
    fill: "#FFE4CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.3281 56.7946H72.7407V58.391H74.3281V56.7946Z",
    fill: "#FFE4CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.305 56.8167H72.7627V58.3677H74.305V56.8167Z",
    fill: "#FFE4CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.3281 55.2643H72.7407V56.8607H74.3281V55.2643Z",
    fill: "#FFE4CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.305 55.2864H72.7627V56.8374H74.305V55.2864Z",
    fill: "#FFE4CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.3281 53.7123H72.7407V55.3087H74.3281V53.7123Z",
    fill: "#FFE4CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.305 53.7348H72.7627V55.2637H74.305V53.7348Z",
    fill: "#FFE4CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.3281 52.1822H72.7407V53.7786H74.3281V52.1822Z",
    fill: "#FFE4CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.305 52.205H72.7627V53.756H74.305V52.205Z",
    fill: "#FFE4CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.3281 50.6309H72.7407V52.2272H74.3281V50.6309Z",
    fill: "#FFE4CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.305 50.6529H72.7627V52.2039H74.305V50.6529Z",
    fill: "#FFE4CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.3281 49.1003H72.7407V50.6967H74.3281V49.1003Z",
    fill: "#FFE4CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.305 49.1224H72.7627V50.6513H74.305V49.1224Z",
    fill: "#FFE4CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.3281 47.5482H72.7407V49.1446H74.3281V47.5482Z",
    fill: "#131E33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.305 47.571H72.7627V49.1221H74.305V47.571Z",
    fill: "#131E33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.3281 46.0189H72.7407V47.6153H74.3281V46.0189Z",
    fill: "#131E33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.305 46.041H72.7627V47.592H74.305V46.041Z",
    fill: "#131E33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.3281 44.4669H72.7407V46.0632H74.3281V44.4669Z",
    fill: "#131E33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.305 44.4891H72.7627V46.0402H74.305V44.4891Z",
    fill: "#131E33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.3281 42.9371H72.7407V44.5334H74.3281V42.9371Z",
    fill: "#243454"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.305 42.9591H72.7627V44.488H74.305V42.9591Z",
    fill: "#243454"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.3281 41.3845H72.7407V42.9808H74.3281V41.3845Z",
    fill: "#243454"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.305 41.407H72.7627V42.958H74.305V41.407Z",
    fill: "#243454"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.3281 39.8329H72.7407V41.4292H74.3281V39.8329Z",
    fill: "#243454"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.305 39.8552H72.7627V41.4062H74.305V39.8552Z",
    fill: "#243454"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.3281 38.3031H72.7407V39.8995H74.3281V38.3031Z",
    fill: "#243454"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.305 38.3251H72.7627V39.8762H74.305V38.3251Z",
    fill: "#243454"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.3281 36.751H72.7407V38.3474H74.3281V36.751Z",
    fill: "#243454"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.305 36.773H72.7627V38.3019H74.305V36.773Z",
    fill: "#243454"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.3281 35.2212H72.7407V36.8176H74.3281V35.2212Z",
    fill: "#243454"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.305 35.2432H72.7627V36.7943H74.305V35.2432Z",
    fill: "#243454"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.3281 33.6691H72.7407V35.2655H74.3281V33.6691Z",
    fill: "#243454"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.305 33.6912H72.7627V35.2422H74.305V33.6912Z",
    fill: "#243454"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.3281 32.1396H72.7407V33.736H74.3281V32.1396Z",
    fill: "#243454"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.305 32.1614H72.7627V33.7124H74.305V32.1614Z",
    fill: "#243454"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.3281 30.5872H72.7407V32.1836H74.3281V30.5872Z",
    fill: "#243454"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.305 30.6095H72.7627V32.1384H74.305V30.6095Z",
    fill: "#243454"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.3281 29.0572H72.7407V30.6536H74.3281V29.0572Z",
    fill: "#243454"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.305 29.08H72.7627V30.631H74.305V29.08Z",
    fill: "#243454"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.3281 27.5051H72.7407V29.1015H74.3281V27.5051Z",
    fill: "#131E33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.305 27.5274H72.7627V29.0784H74.305V27.5274Z",
    fill: "#131E33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.3281 25.9758H72.7407V27.5721H74.3281V25.9758Z",
    fill: "#131E33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.305 25.9973H72.7627V27.5483H74.305V25.9973Z",
    fill: "#131E33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.3281 24.4237H72.7407V26.0201H74.3281V24.4237Z",
    fill: "#243454"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.305 24.4455H72.7627V25.9744H74.305V24.4455Z",
    fill: "#243454"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.3281 22.8719H72.7407V24.4683H74.3281V22.8719Z",
    fill: "#243454"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.305 22.916H72.7627V24.467H74.305V22.916Z",
    fill: "#243454"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.3281 21.3418H72.7407V22.9382H74.3281V21.3418Z",
    fill: "#243454"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.305 21.3638H72.7627V22.9149H74.305V21.3638Z",
    fill: "#243454"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.3281 19.7892H72.7407V21.3856H74.3281V19.7892Z",
    fill: "#243454"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.305 19.812H72.7627V21.363H74.305V19.812Z",
    fill: "#243454"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.3281 18.2599H72.7407V19.8563H74.3281V18.2599Z",
    fill: "#374F80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.305 18.282H72.7627V19.8109H74.305V18.282Z",
    fill: "#374F80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.3281 16.7079H72.7407V18.3043H74.3281V16.7079Z",
    fill: "#374F80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.305 16.7294H72.7627V18.2805H74.305V16.7294Z",
    fill: "#374F80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.3281 15.178H72.7407V16.7744H74.3281V15.178Z",
    fill: "#3D041F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.305 15.2001H72.7627V16.7511H74.305V15.2001Z",
    fill: "#3D041F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.3281 13.626H72.7407V15.2223H74.3281V13.626Z",
    fill: "#3D041F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.305 13.648H72.7627V15.1769H74.305V13.648Z",
    fill: "#3D041F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.3281 12.0962H72.7407V13.6926H74.3281V12.0962Z",
    fill: "#F57E77"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.305 12.1182H72.7627V13.6693H74.305V12.1182Z",
    fill: "#F57E77"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.3281 10.5441H72.7407V12.1404H74.3281V10.5441Z",
    fill: "#FFE4CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.305 10.5661H72.7627V12.1171H74.305V10.5661Z",
    fill: "#FFE4CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.3281 9.01404H72.7407V10.6104H74.3281V9.01404Z",
    fill: "#FFE4CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.305 9.03632H72.7627V10.5873H74.305V9.03632Z",
    fill: "#FFE4CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.3281 7.46222H72.7407V9.05859H74.3281V7.46222Z",
    fill: "#FFE4CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.305 7.48474H72.7627V9.01361H74.305V7.48474Z",
    fill: "#FFE4CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.3281 5.93213H72.7407V7.5285H74.3281V5.93213Z",
    fill: "#FFE4CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.305 5.95416H72.7627V7.50519H74.305V5.95416Z",
    fill: "#FFE4CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.3281 4.38007H72.7407V5.97644H74.3281V4.38007Z",
    fill: "#3D041F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.305 4.40234H72.7627V5.95337H74.305V4.40234Z",
    fill: "#3D041F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.3281 2.82776H72.7407V4.42413H74.3281V2.82776Z",
    fill: "#621931"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.305 2.85028H72.7627V4.40131H74.305V2.85028Z",
    fill: "#621931"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.3281 1.2981H72.7407V2.89446H74.3281V1.2981Z",
    fill: "#621931"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.305 1.32056H72.7627V2.84943H74.305V1.32056Z",
    fill: "#621931"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.8071 67.5919H71.2197V69.1882H72.8071V67.5919Z",
    fill: "#3D041F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.7835 67.6141H71.2412V69.1652H72.7835V67.6141Z",
    fill: "#3D041F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.8071 66.0621H71.2197V67.6584H72.8071V66.0621Z",
    fill: "#3D041F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.7835 66.0846H71.2412V67.6135H72.7835V66.0846Z",
    fill: "#3D041F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.8071 64.5105H71.2197V66.1069H72.8071V64.5105Z",
    fill: "#3D041F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.7835 64.5325H71.2412V66.0836H72.7835V64.5325Z",
    fill: "#3D041F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.8071 62.9807H71.2197V64.5771H72.8071V62.9807Z",
    fill: "#3D041F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.7835 63.0022H71.2412V64.5532H72.7835V63.0022Z",
    fill: "#3D041F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.8071 61.4281H71.2197V63.0245H72.8071V61.4281Z",
    fill: "#F57E77"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.7835 61.4501H71.2412V63.0012H72.7835V61.4501Z",
    fill: "#F57E77"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.8071 59.8981H71.2197V61.4944H72.8071V59.8981Z",
    fill: "#F57E77"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.7835 59.9208H71.2412V61.4497H72.7835V59.9208Z",
    fill: "#F57E77"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.8071 58.3463H71.2197V59.9426H72.8071V58.3463Z",
    fill: "#F57E77"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.7835 58.3688H71.2412V59.9198H72.7835V58.3688Z",
    fill: "#F57E77"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.8071 56.7946H71.2197V58.391H72.8071V56.7946Z",
    fill: "#F57E77"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.7835 56.8167H71.2412V58.3677H72.7835V56.8167Z",
    fill: "#F57E77"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.8071 55.2643H71.2197V56.8607H72.8071V55.2643Z",
    fill: "#F57E77"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.7835 55.2864H71.2412V56.8374H72.7835V55.2864Z",
    fill: "#F57E77"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.8071 53.7123H71.2197V55.3087H72.8071V53.7123Z",
    fill: "#F57E77"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.7835 53.7348H71.2412V55.2637H72.7835V53.7348Z",
    fill: "#F57E77"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.8071 52.1822H71.2197V53.7786H72.8071V52.1822Z",
    fill: "#F57E77"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.7835 52.205H71.2412V53.756H72.7835V52.205Z",
    fill: "#F57E77"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.8071 50.6309H71.2197V52.2272H72.8071V50.6309Z",
    fill: "#F57E77"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.7835 50.6529H71.2412V52.2039H72.7835V50.6529Z",
    fill: "#F57E77"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.8071 49.1003H71.2197V50.6967H72.8071V49.1003Z",
    fill: "#F57E77"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.7835 49.1224H71.2412V50.6513H72.7835V49.1224Z",
    fill: "#F57E77"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.8071 47.5482H71.2197V49.1446H72.8071V47.5482Z",
    fill: "#243454"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.7835 47.571H71.2412V49.1221H72.7835V47.571Z",
    fill: "#243454"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.8071 46.0189H71.2197V47.6153H72.8071V46.0189Z",
    fill: "#243454"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.7835 46.041H71.2412V47.592H72.7835V46.041Z",
    fill: "#243454"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.8071 44.4669H71.2197V46.0632H72.8071V44.4669Z",
    fill: "#243454"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.7835 44.4891H71.2412V46.0402H72.7835V44.4891Z",
    fill: "#243454"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.8071 42.9371H71.2197V44.5334H72.8071V42.9371Z",
    fill: "#243454"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.7835 42.9591H71.2412V44.488H72.7835V42.9591Z",
    fill: "#243454"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.8071 41.3845H71.2197V42.9808H72.8071V41.3845Z",
    fill: "#243454"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.7835 41.407H71.2412V42.958H72.7835V41.407Z",
    fill: "#243454"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.8071 39.8329H71.2197V41.4292H72.8071V39.8329Z",
    fill: "#243454"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.7835 39.8552H71.2412V41.4062H72.7835V39.8552Z",
    fill: "#243454"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.8071 38.3031H71.2197V39.8995H72.8071V38.3031Z",
    fill: "#243454"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.7835 38.3251H71.2412V39.8762H72.7835V38.3251Z",
    fill: "#243454"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.8071 36.751H71.2197V38.3474H72.8071V36.751Z",
    fill: "#243454"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.7835 36.773H71.2412V38.3019H72.7835V36.773Z",
    fill: "#243454"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.8071 35.2212H71.2197V36.8176H72.8071V35.2212Z",
    fill: "#243454"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.7835 35.2432H71.2412V36.7943H72.7835V35.2432Z",
    fill: "#243454"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.8071 33.6691H71.2197V35.2655H72.8071V33.6691Z",
    fill: "#243454"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.7835 33.6912H71.2412V35.2422H72.7835V33.6912Z",
    fill: "#243454"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.8071 32.1396H71.2197V33.736H72.8071V32.1396Z",
    fill: "#243454"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.7835 32.1614H71.2412V33.7124H72.7835V32.1614Z",
    fill: "#243454"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.8071 30.5872H71.2197V32.1836H72.8071V30.5872Z",
    fill: "#243454"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.7835 30.6095H71.2412V32.1384H72.7835V30.6095Z",
    fill: "#243454"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.8071 29.0572H71.2197V30.6536H72.8071V29.0572Z",
    fill: "#243454"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.7835 29.08H71.2412V30.631H72.7835V29.08Z",
    fill: "#243454"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.8071 27.5051H71.2197V29.1015H72.8071V27.5051Z",
    fill: "#243454"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.7835 27.5274H71.2412V29.0784H72.7835V27.5274Z",
    fill: "#243454"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.8071 25.9758H71.2197V27.5721H72.8071V25.9758Z",
    fill: "#131E33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.7835 25.9973H71.2412V27.5483H72.7835V25.9973Z",
    fill: "#131E33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.8071 24.4237H71.2197V26.0201H72.8071V24.4237Z",
    fill: "#243454"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.7835 24.4455H71.2412V25.9744H72.7835V24.4455Z",
    fill: "#243454"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.8071 22.8719H71.2197V24.4683H72.8071V22.8719Z",
    fill: "#243454"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.7835 22.916H71.2412V24.467H72.7835V22.916Z",
    fill: "#243454"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.8071 21.3418H71.2197V22.9382H72.8071V21.3418Z",
    fill: "#243454"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.7835 21.3638H71.2412V22.9149H72.7835V21.3638Z",
    fill: "#243454"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.8071 19.7892H71.2197V21.3856H72.8071V19.7892Z",
    fill: "#374F80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.7835 19.812H71.2412V21.363H72.7835V19.812Z",
    fill: "#374F80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.8071 18.2599H71.2197V19.8563H72.8071V18.2599Z",
    fill: "#F57E77"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.7835 18.282H71.2412V19.8109H72.7835V18.282Z",
    fill: "#F57E77"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.8071 16.7079H71.2197V18.3043H72.8071V16.7079Z",
    fill: "#F57E77"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.7835 16.7294H71.2412V18.2805H72.7835V16.7294Z",
    fill: "#F57E77"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.8071 15.178H71.2197V16.7744H72.8071V15.178Z",
    fill: "#F57E77"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.7835 15.2001H71.2412V16.7511H72.7835V15.2001Z",
    fill: "#F57E77"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.8071 13.626H71.2197V15.2223H72.8071V13.626Z",
    fill: "#F57E77"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.7835 13.648H71.2412V15.1769H72.7835V13.648Z",
    fill: "#F57E77"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.8071 12.0962H71.2197V13.6926H72.8071V12.0962Z",
    fill: "#FFE4CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.7835 12.1182H71.2412V13.6693H72.7835V12.1182Z",
    fill: "#FFE4CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.8071 10.5441H71.2197V12.1404H72.8071V10.5441Z",
    fill: "#FFE4CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.7835 10.5661H71.2412V12.1171H72.7835V10.5661Z",
    fill: "#FFE4CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.8071 9.01404H71.2197V10.6104H72.8071V9.01404Z",
    fill: "#FFE4CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.7835 9.03632H71.2412V10.5873H72.7835V9.03632Z",
    fill: "#FFE4CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.8071 7.46222H71.2197V9.05859H72.8071V7.46222Z",
    fill: "#66667C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.7835 7.48474H71.2412V9.01361H72.7835V7.48474Z",
    fill: "#66667C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.8071 5.93213H71.2197V7.5285H72.8071V5.93213Z",
    fill: "#FFE4CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.7835 5.95416H71.2412V7.50519H72.7835V5.95416Z",
    fill: "#FFE4CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.8071 4.38007H71.2197V5.97644H72.8071V4.38007Z",
    fill: "#3D041F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.7835 4.40234H71.2412V5.95337H72.7835V4.40234Z",
    fill: "#3D041F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.8071 2.82776H71.2197V4.42413H72.8071V2.82776Z",
    fill: "#621931"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.7835 2.85028H71.2412V4.40131H72.7835V2.85028Z",
    fill: "#621931"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.8066 1.2981H71.2192V2.89446H72.8066V1.2981Z",
    fill: "#621931"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.784 1.32056H71.2417V2.84943H72.784V1.32056Z",
    fill: "#621931"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.2631 47.5482H69.6758V49.1446H71.2631V47.5482Z",
    fill: "#243454"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.2405 47.571H69.6982V49.1221H71.2405V47.571Z",
    fill: "#243454"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.2631 46.0189H69.6758V47.6153H71.2631V46.0189Z",
    fill: "#243454"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.2405 46.041H69.6982V47.592H71.2405V46.041Z",
    fill: "#243454"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.2631 44.4669H69.6758V46.0632H71.2631V44.4669Z",
    fill: "#243454"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.2405 44.4891H69.6982V46.0402H71.2405V44.4891Z",
    fill: "#243454"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.2631 42.9371H69.6758V44.5334H71.2631V42.9371Z",
    fill: "#243454"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.2405 42.9591H69.6982V44.488H71.2405V42.9591Z",
    fill: "#243454"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.2631 41.3845H69.6758V42.9808H71.2631V41.3845Z",
    fill: "#243454"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.2405 41.407H69.6982V42.958H71.2405V41.407Z",
    fill: "#243454"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.2631 39.8329H69.6758V41.4292H71.2631V39.8329Z",
    fill: "#243454"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.2405 39.8552H69.6982V41.4062H71.2405V39.8552Z",
    fill: "#243454"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.2631 38.3031H69.6758V39.8995H71.2631V38.3031Z",
    fill: "#243454"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.2405 38.3251H69.6982V39.8762H71.2405V38.3251Z",
    fill: "#243454"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.2631 36.751H69.6758V38.3474H71.2631V36.751Z",
    fill: "#243454"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.2405 36.773H69.6982V38.3019H71.2405V36.773Z",
    fill: "#243454"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.2631 35.2212H69.6758V36.8176H71.2631V35.2212Z",
    fill: "#243454"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.2405 35.2432H69.6982V36.7943H71.2405V35.2432Z",
    fill: "#243454"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.2631 33.6691H69.6758V35.2655H71.2631V33.6691Z",
    fill: "#243454"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.2405 33.6912H69.6982V35.2422H71.2405V33.6912Z",
    fill: "#243454"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.2631 32.1396H69.6758V33.736H71.2631V32.1396Z",
    fill: "#243454"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.2405 32.1614H69.6982V33.7124H71.2405V32.1614Z",
    fill: "#243454"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.2631 30.5872H69.6758V32.1836H71.2631V30.5872Z",
    fill: "#243454"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.2405 30.6095H69.6982V32.1384H71.2405V30.6095Z",
    fill: "#243454"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.2631 29.0572H69.6758V30.6536H71.2631V29.0572Z",
    fill: "#243454"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.2405 29.08H69.6982V30.631H71.2405V29.08Z",
    fill: "#243454"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.2631 27.5051H69.6758V29.1015H71.2631V27.5051Z",
    fill: "#243454"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.2405 27.5274H69.6982V29.0784H71.2405V27.5274Z",
    fill: "#243454"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.2631 25.9758H69.6758V27.5721H71.2631V25.9758Z",
    fill: "#243454"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.2405 25.9973H69.6982V27.5483H71.2405V25.9973Z",
    fill: "#243454"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.2631 24.4237H69.6758V26.0201H71.2631V24.4237Z",
    fill: "#131E33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.2405 24.4455H69.6982V25.9744H71.2405V24.4455Z",
    fill: "#131E33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.2631 22.8719H69.6758V24.4683H71.2631V22.8719Z",
    fill: "#243454"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.2405 22.916H69.6982V24.467H71.2405V22.916Z",
    fill: "#243454"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.2631 21.3418H69.6758V22.9382H71.2631V21.3418Z",
    fill: "#374F80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.2405 21.3638H69.6982V22.9149H71.2405V21.3638Z",
    fill: "#374F80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.2631 19.7892H69.6758V21.3856H71.2631V19.7892Z",
    fill: "#FFE4CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.2405 19.812H69.6982V21.363H71.2405V19.812Z",
    fill: "#FFE4CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.2631 18.2599H69.6758V19.8563H71.2631V18.2599Z",
    fill: "#FFE4CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.2405 18.282H69.6982V19.8109H71.2405V18.282Z",
    fill: "#FFE4CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.2631 16.7079H69.6758V18.3043H71.2631V16.7079Z",
    fill: "#FFE4CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.2405 16.7294H69.6982V18.2805H71.2405V16.7294Z",
    fill: "#FFE4CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.2631 15.178H69.6758V16.7744H71.2631V15.178Z",
    fill: "#FFE4CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.2405 15.2001H69.6982V16.7511H71.2405V15.2001Z",
    fill: "#FFE4CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.2631 13.626H69.6758V15.2223H71.2631V13.626Z",
    fill: "#F57E77"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.2405 13.648H69.6982V15.1769H71.2405V13.648Z",
    fill: "#F57E77"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.2631 12.0962H69.6758V13.6926H71.2631V12.0962Z",
    fill: "#FFE4CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.2405 12.1182H69.6982V13.6693H71.2405V12.1182Z",
    fill: "#FFE4CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.2631 10.5441H69.6758V12.1404H71.2631V10.5441Z",
    fill: "#FFE4CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.2405 10.5661H69.6982V12.1171H71.2405V10.5661Z",
    fill: "#FFE4CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.2631 9.01404H69.6758V10.6104H71.2631V9.01404Z",
    fill: "#FFE4CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.2405 9.03632H69.6982V10.5873H71.2405V9.03632Z",
    fill: "#FFE4CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.2631 7.46222H69.6758V9.05859H71.2631V7.46222Z",
    fill: "#FFE4CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.2405 7.48474H69.6982V9.01361H71.2405V7.48474Z",
    fill: "#FFE4CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.2631 5.93213H69.6758V7.5285H71.2631V5.93213Z",
    fill: "#FFE4CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.2405 5.95416H69.6982V7.50519H71.2405V5.95416Z",
    fill: "#FFE4CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.2631 4.38007H69.6758V5.97644H71.2631V4.38007Z",
    fill: "#FFE4CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.2405 4.40234H69.6982V5.95337H71.2405V4.40234Z",
    fill: "#FFE4CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.2631 2.82776H69.6758V4.42413H71.2631V2.82776Z",
    fill: "#621931"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.2405 2.85028H69.6982V4.40131H71.2405V2.85028Z",
    fill: "#621931"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.2631 1.2981H69.6758V2.89446H71.2631V1.2981Z",
    fill: "#621931"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.2405 1.32056H69.6982V2.84943H71.2405V1.32056Z",
    fill: "#621931"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.7421 67.5919H68.1548V69.1882H69.7421V67.5919Z",
    fill: "#3D041F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.697 67.6141H68.1768V69.1652H69.697V67.6141Z",
    fill: "#3D041F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.7421 66.0621H68.1548V67.6584H69.7421V66.0621Z",
    fill: "#3D041F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.697 66.0846H68.1768V67.6135H69.697V66.0846Z",
    fill: "#3D041F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.7421 64.5105H68.1548V66.1069H69.7421V64.5105Z",
    fill: "#3D041F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.697 64.5325H68.1768V66.0836H69.697V64.5325Z",
    fill: "#3D041F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.7421 62.9807H68.1548V64.5771H69.7421V62.9807Z",
    fill: "#3D041F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.697 63.0022H68.1768V64.5532H69.697V63.0022Z",
    fill: "#3D041F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.7421 61.4281H68.1548V63.0245H69.7421V61.4281Z",
    fill: "#F57E77"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.697 61.4501H68.1768V63.0012H69.697V61.4501Z",
    fill: "#F57E77"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.7421 59.8981H68.1548V61.4944H69.7421V59.8981Z",
    fill: "#F57E77"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.697 59.9208H68.1768V61.4497H69.697V59.9208Z",
    fill: "#F57E77"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.7421 58.3463H68.1548V59.9426H69.7421V58.3463Z",
    fill: "#F57E77"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.697 58.3688H68.1768V59.9198H69.697V58.3688Z",
    fill: "#F57E77"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.7421 56.7946H68.1548V58.391H69.7421V56.7946Z",
    fill: "#F57E77"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.697 56.8167H68.1768V58.3677H69.697V56.8167Z",
    fill: "#F57E77"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.7421 55.2643H68.1548V56.8607H69.7421V55.2643Z",
    fill: "#F57E77"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.697 55.2864H68.1768V56.8374H69.697V55.2864Z",
    fill: "#F57E77"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.7421 53.7123H68.1548V55.3087H69.7421V53.7123Z",
    fill: "#F57E77"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.697 53.7348H68.1768V55.2637H69.697V53.7348Z",
    fill: "#F57E77"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.7421 52.1822H68.1548V53.7786H69.7421V52.1822Z",
    fill: "#F57E77"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.697 52.205H68.1768V53.756H69.697V52.205Z",
    fill: "#F57E77"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.7421 50.6309H68.1548V52.2272H69.7421V50.6309Z",
    fill: "#F57E77"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.697 50.6529H68.1768V52.2039H69.697V50.6529Z",
    fill: "#F57E77"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.7421 49.1003H68.1548V50.6967H69.7421V49.1003Z",
    fill: "#F57E77"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.697 49.1224H68.1768V50.6513H69.697V49.1224Z",
    fill: "#F57E77"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.7421 47.5482H68.1548V49.1446H69.7421V47.5482Z",
    fill: "#243454"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.697 47.571H68.1768V49.1221H69.697V47.571Z",
    fill: "#243454"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.7421 46.0189H68.1548V47.6153H69.7421V46.0189Z",
    fill: "#243454"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.697 46.041H68.1768V47.592H69.697V46.041Z",
    fill: "#243454"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.7421 44.4669H68.1548V46.0632H69.7421V44.4669Z",
    fill: "#243454"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.697 44.4891H68.1768V46.0402H69.697V44.4891Z",
    fill: "#243454"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.7421 42.9371H68.1548V44.5334H69.7421V42.9371Z",
    fill: "#243454"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.697 42.9591H68.1768V44.488H69.697V42.9591Z",
    fill: "#243454"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.7421 41.3845H68.1548V42.9808H69.7421V41.3845Z",
    fill: "#243454"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.697 41.407H68.1768V42.958H69.697V41.407Z",
    fill: "#243454"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.7421 39.8329H68.1548V41.4292H69.7421V39.8329Z",
    fill: "#243454"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.697 39.8552H68.1768V41.4062H69.697V39.8552Z",
    fill: "#243454"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.7421 38.3031H68.1548V39.8995H69.7421V38.3031Z",
    fill: "#243454"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.697 38.3251H68.1768V39.8762H69.697V38.3251Z",
    fill: "#243454"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.7421 36.751H68.1548V38.3474H69.7421V36.751Z",
    fill: "#243454"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.697 36.773H68.1768V38.3019H69.697V36.773Z",
    fill: "#243454"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.7421 35.2212H68.1548V36.8176H69.7421V35.2212Z",
    fill: "#243454"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.697 35.2432H68.1768V36.7943H69.697V35.2432Z",
    fill: "#243454"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.7421 33.6691H68.1548V35.2655H69.7421V33.6691Z",
    fill: "#243454"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.697 33.6912H68.1768V35.2422H69.697V33.6912Z",
    fill: "#243454"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.7421 32.1396H68.1548V33.736H69.7421V32.1396Z",
    fill: "#243454"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.697 32.1614H68.1768V33.7124H69.697V32.1614Z",
    fill: "#243454"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.7421 30.5872H68.1548V32.1836H69.7421V30.5872Z",
    fill: "#243454"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.697 30.6095H68.1768V32.1384H69.697V30.6095Z",
    fill: "#243454"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.7421 29.0572H68.1548V30.6536H69.7421V29.0572Z",
    fill: "#243454"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.697 29.08H68.1768V30.631H69.697V29.08Z",
    fill: "#243454"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.7421 27.5051H68.1548V29.1015H69.7421V27.5051Z",
    fill: "#243454"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.697 27.5274H68.1768V29.0784H69.697V27.5274Z",
    fill: "#243454"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.7421 25.9758H68.1548V27.5721H69.7421V25.9758Z",
    fill: "#131E33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.697 25.9973H68.1768V27.5483H69.697V25.9973Z",
    fill: "#131E33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.7421 24.4237H68.1548V26.0201H69.7421V24.4237Z",
    fill: "#243454"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.697 24.4455H68.1768V25.9744H69.697V24.4455Z",
    fill: "#243454"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.7421 22.8719H68.1548V24.4683H69.7421V22.8719Z",
    fill: "#243454"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.697 22.916H68.1768V24.467H69.697V22.916Z",
    fill: "#243454"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.7421 21.3418H68.1548V22.9382H69.7421V21.3418Z",
    fill: "#243454"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.697 21.3638H68.1768V22.9149H69.697V21.3638Z",
    fill: "#243454"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.7421 19.7892H68.1548V21.3856H69.7421V19.7892Z",
    fill: "#374F80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.697 19.812H68.1768V21.363H69.697V19.812Z",
    fill: "#374F80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.7421 18.2599H68.1548V19.8563H69.7421V18.2599Z",
    fill: "#FFE4CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.697 18.282H68.1768V19.8109H69.697V18.282Z",
    fill: "#FFE4CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.7421 16.7079H68.1548V18.3043H69.7421V16.7079Z",
    fill: "#FFE4CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.697 16.7294H68.1768V18.2805H69.697V16.7294Z",
    fill: "#FFE4CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.7421 15.178H68.1548V16.7744H69.7421V15.178Z",
    fill: "#FFE4CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.697 15.2001H68.1768V16.7511H69.697V15.2001Z",
    fill: "#FFE4CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.7421 13.626H68.1548V15.2223H69.7421V13.626Z",
    fill: "#F57E77"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.697 13.648H68.1768V15.1769H69.697V13.648Z",
    fill: "#F57E77"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.7421 12.0962H68.1548V13.6926H69.7421V12.0962Z",
    fill: "#FFE4CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.697 12.1182H68.1768V13.6693H69.697V12.1182Z",
    fill: "#FFE4CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.7421 10.5441H68.1548V12.1404H69.7421V10.5441Z",
    fill: "#FFE4CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.697 10.5661H68.1768V12.1171H69.697V10.5661Z",
    fill: "#FFE4CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.7421 9.01404H68.1548V10.6104H69.7421V9.01404Z",
    fill: "#FFE4CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.697 9.03632H68.1768V10.5873H69.697V9.03632Z",
    fill: "#FFE4CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.7421 7.46222H68.1548V9.05859H69.7421V7.46222Z",
    fill: "#66667C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.697 7.48474H68.1768V9.01361H69.697V7.48474Z",
    fill: "#66667C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.7421 5.93213H68.1548V7.5285H69.7421V5.93213Z",
    fill: "#FFE4CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.697 5.95416H68.1768V7.50519H69.697V5.95416Z",
    fill: "#FFE4CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.7421 4.38007H68.1548V5.97644H69.7421V4.38007Z",
    fill: "#3D041F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.697 4.40234H68.1768V5.95337H69.697V4.40234Z",
    fill: "#3D041F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.7421 2.82776H68.1548V4.42413H69.7421V2.82776Z",
    fill: "#621931"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.697 2.85028H68.1768V4.40131H69.697V2.85028Z",
    fill: "#621931"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.7421 1.2981H68.1548V2.89446H69.7421V1.2981Z",
    fill: "#621931"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.697 1.32056H68.1768V2.84943H69.697V1.32056Z",
    fill: "#621931"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.1992 66.0621H66.6118V67.6584H68.1992V66.0621Z",
    fill: "#3D041F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.176 66.0846H66.6338V67.6135H68.176V66.0846Z",
    fill: "#3D041F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.1992 64.5105H66.6118V66.1069H68.1992V64.5105Z",
    fill: "#541136"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.176 64.5325H66.6338V66.0836H68.176V64.5325Z",
    fill: "#541136"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.1992 62.9807H66.6118V64.5771H68.1992V62.9807Z",
    fill: "#541136"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.176 63.0022H66.6338V64.5532H68.176V63.0022Z",
    fill: "#541136"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.1992 61.4281H66.6118V63.0245H68.1992V61.4281Z",
    fill: "#FFE4CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.176 61.4501H66.6338V63.0012H68.176V61.4501Z",
    fill: "#FFE4CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.1992 59.8981H66.6118V61.4944H68.1992V59.8981Z",
    fill: "#FFE4CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.176 59.9208H66.6338V61.4497H68.176V59.9208Z",
    fill: "#FFE4CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.1992 58.3463H66.6118V59.9426H68.1992V58.3463Z",
    fill: "#FFE4CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.176 58.3688H66.6338V59.9198H68.176V58.3688Z",
    fill: "#FFE4CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.1992 56.7946H66.6118V58.391H68.1992V56.7946Z",
    fill: "#FFE4CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.176 56.8167H66.6338V58.3677H68.176V56.8167Z",
    fill: "#FFE4CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.1992 55.2643H66.6118V56.8607H68.1992V55.2643Z",
    fill: "#FFE4CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.176 55.2864H66.6338V56.8374H68.176V55.2864Z",
    fill: "#FFE4CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.1992 53.7123H66.6118V55.3087H68.1992V53.7123Z",
    fill: "#FFE4CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.176 53.7348H66.6338V55.2637H68.176V53.7348Z",
    fill: "#FFE4CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.1992 52.1822H66.6118V53.7786H68.1992V52.1822Z",
    fill: "#FFE4CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.176 52.205H66.6338V53.756H68.176V52.205Z",
    fill: "#FFE4CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.1992 50.6309H66.6118V52.2272H68.1992V50.6309Z",
    fill: "#FFE4CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.176 50.6529H66.6338V52.2039H68.176V50.6529Z",
    fill: "#FFE4CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.1992 49.1003H66.6118V50.6967H68.1992V49.1003Z",
    fill: "#FFE4CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.176 49.1224H66.6338V50.6513H68.176V49.1224Z",
    fill: "#FFE4CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.1992 47.5482H66.6118V49.1446H68.1992V47.5482Z",
    fill: "#243454"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.176 47.571H66.6338V49.1221H68.176V47.571Z",
    fill: "#243454"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.1992 46.0189H66.6118V47.6153H68.1992V46.0189Z",
    fill: "#243454"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.176 46.041H66.6338V47.592H68.176V46.041Z",
    fill: "#243454"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.1992 44.4669H66.6118V46.0632H68.1992V44.4669Z",
    fill: "#243454"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.176 44.4891H66.6338V46.0402H68.176V44.4891Z",
    fill: "#243454"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.1992 42.9371H66.6118V44.5334H68.1992V42.9371Z",
    fill: "#243454"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.176 42.9591H66.6338V44.488H68.176V42.9591Z",
    fill: "#243454"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.1992 41.3845H66.6118V42.9808H68.1992V41.3845Z",
    fill: "#243454"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.176 41.407H66.6338V42.958H68.176V41.407Z",
    fill: "#243454"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.1992 39.8329H66.6118V41.4292H68.1992V39.8329Z",
    fill: "#243454"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.176 39.8552H66.6338V41.4062H68.176V39.8552Z",
    fill: "#243454"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.1992 38.3031H66.6118V39.8995H68.1992V38.3031Z",
    fill: "#243454"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.176 38.3251H66.6338V39.8762H68.176V38.3251Z",
    fill: "#243454"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.1992 36.751H66.6118V38.3474H68.1992V36.751Z",
    fill: "#243454"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.176 36.773H66.6338V38.3019H68.176V36.773Z",
    fill: "#243454"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.1992 35.2212H66.6118V36.8176H68.1992V35.2212Z",
    fill: "#243454"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.176 35.2432H66.6338V36.7943H68.176V35.2432Z",
    fill: "#243454"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.1992 33.6691H66.6118V35.2655H68.1992V33.6691Z",
    fill: "#243454"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.176 33.6912H66.6338V35.2422H68.176V33.6912Z",
    fill: "#243454"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.1992 32.1396H66.6118V33.736H68.1992V32.1396Z",
    fill: "#243454"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.176 32.1614H66.6338V33.7124H68.176V32.1614Z",
    fill: "#243454"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.1992 30.5872H66.6118V32.1836H68.1992V30.5872Z",
    fill: "#243454"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.176 30.6095H66.6338V32.1384H68.176V30.6095Z",
    fill: "#243454"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.1992 29.0572H66.6118V30.6536H68.1992V29.0572Z",
    fill: "#243454"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.176 29.08H66.6338V30.631H68.176V29.08Z",
    fill: "#243454"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.1992 27.5051H66.6118V29.1015H68.1992V27.5051Z",
    fill: "#243454"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.176 27.5274H66.6338V29.0784H68.176V27.5274Z",
    fill: "#243454"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.1992 25.9758H66.6118V27.5721H68.1992V25.9758Z",
    fill: "#131E33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.176 25.9973H66.6338V27.5483H68.176V25.9973Z",
    fill: "#131E33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.1992 24.4237H66.6118V26.0201H68.1992V24.4237Z",
    fill: "#243454"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.176 24.4455H66.6338V25.9744H68.176V24.4455Z",
    fill: "#243454"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.1992 22.8719H66.6118V24.4683H68.1992V22.8719Z",
    fill: "#243454"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.176 22.916H66.6338V24.467H68.176V22.916Z",
    fill: "#243454"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.1992 21.3418H66.6118V22.9382H68.1992V21.3418Z",
    fill: "#243454"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.176 21.3638H66.6338V22.9149H68.176V21.3638Z",
    fill: "#243454"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.1992 19.7892H66.6118V21.3856H68.1992V19.7892Z",
    fill: "#243454"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.176 19.812H66.6338V21.363H68.176V19.812Z",
    fill: "#243454"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.1992 18.2599H66.6118V19.8563H68.1992V18.2599Z",
    fill: "#374F80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.176 18.282H66.6338V19.8109H68.176V18.282Z",
    fill: "#374F80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.1992 16.7079H66.6118V18.3043H68.1992V16.7079Z",
    fill: "#374F80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.176 16.7294H66.6338V18.2805H68.176V16.7294Z",
    fill: "#374F80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.1992 15.178H66.6118V16.7744H68.1992V15.178Z",
    fill: "#3D041F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.176 15.2001H66.6338V16.7511H68.176V15.2001Z",
    fill: "#3D041F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.1992 13.626H66.6118V15.2223H68.1992V13.626Z",
    fill: "#3D041F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.176 13.648H66.6338V15.1769H68.176V13.648Z",
    fill: "#3D041F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.1992 12.0962H66.6118V13.6926H68.1992V12.0962Z",
    fill: "#FFE4CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.176 12.1182H66.6338V13.6693H68.176V12.1182Z",
    fill: "#FFE4CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.1992 10.5441H66.6118V12.1404H68.1992V10.5441Z",
    fill: "#FFE4CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.176 10.5661H66.6338V12.1171H68.176V10.5661Z",
    fill: "#FFE4CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.1992 9.01404H66.6118V10.6104H68.1992V9.01404Z",
    fill: "#FFE4CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.176 9.03632H66.6338V10.5873H68.176V9.03632Z",
    fill: "#FFE4CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.1992 7.46222H66.6118V9.05859H68.1992V7.46222Z",
    fill: "#FFE4CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.176 7.48474H66.6338V9.01361H68.176V7.48474Z",
    fill: "#FFE4CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.1992 5.93213H66.6118V7.5285H68.1992V5.93213Z",
    fill: "#FFE4CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.176 5.95416H66.6338V7.50519H68.176V5.95416Z",
    fill: "#FFE4CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.1992 4.38007H66.6118V5.97644H68.1992V4.38007Z",
    fill: "#3D041F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.176 4.40234H66.6338V5.95337H68.176V4.40234Z",
    fill: "#3D041F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.1992 2.82776H66.6118V4.42413H68.1992V2.82776Z",
    fill: "#621931"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.176 2.85028H66.6338V4.40131H68.176V2.85028Z",
    fill: "#621931"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.1992 1.2981H66.6118V2.89446H68.1992V1.2981Z",
    fill: "#621931"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.176 1.32056H66.6338V2.84943H68.176V1.32056Z",
    fill: "#621931"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.6557 66.0621H65.0684V67.6584H66.6557V66.0621Z",
    fill: "#3D041F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.6326 66.0846H65.0903V67.6135H66.6326V66.0846Z",
    fill: "#3D041F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.6557 64.5105H65.0684V66.1069H66.6557V64.5105Z",
    fill: "#541136"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.6326 64.5325H65.0903V66.0836H66.6326V64.5325Z",
    fill: "#541136"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.6557 62.9807H65.0684V64.5771H66.6557V62.9807Z",
    fill: "#541136"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.6326 63.0022H65.0903V64.5532H66.6326V63.0022Z",
    fill: "#541136"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.6557 47.5482H65.0684V49.1446H66.6557V47.5482Z",
    fill: "#243454"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.6326 47.571H65.0903V49.1221H66.6326V47.571Z",
    fill: "#243454"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.6557 46.0189H65.0684V47.6153H66.6557V46.0189Z",
    fill: "#243454"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.6326 46.041H65.0903V47.592H66.6326V46.041Z",
    fill: "#243454"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.6557 44.4669H65.0684V46.0632H66.6557V44.4669Z",
    fill: "#243454"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.6326 44.4891H65.0903V46.0402H66.6326V44.4891Z",
    fill: "#243454"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.6557 42.9371H65.0684V44.5334H66.6557V42.9371Z",
    fill: "#243454"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.6326 42.9591H65.0903V44.488H66.6326V42.9591Z",
    fill: "#243454"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.6557 41.3845H65.0684V42.9808H66.6557V41.3845Z",
    fill: "#243454"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.6326 41.407H65.0903V42.958H66.6326V41.407Z",
    fill: "#243454"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.6557 39.8329H65.0684V41.4292H66.6557V39.8329Z",
    fill: "#243454"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.6326 39.8552H65.0903V41.4062H66.6326V39.8552Z",
    fill: "#243454"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.6557 38.3031H65.0684V39.8995H66.6557V38.3031Z",
    fill: "#243454"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.6326 38.3251H65.0903V39.8762H66.6326V38.3251Z",
    fill: "#243454"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.6557 36.751H65.0684V38.3474H66.6557V36.751Z",
    fill: "#243454"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.6326 36.773H65.0903V38.3019H66.6326V36.773Z",
    fill: "#243454"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.6557 35.2212H65.0684V36.8176H66.6557V35.2212Z",
    fill: "#243454"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.6326 35.2432H65.0903V36.7943H66.6326V35.2432Z",
    fill: "#243454"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.6557 33.6691H65.0684V35.2655H66.6557V33.6691Z",
    fill: "#131E33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.6326 33.6912H65.0903V35.2422H66.6326V33.6912Z",
    fill: "#131E33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.6557 32.1396H65.0684V33.736H66.6557V32.1396Z",
    fill: "#131E33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.6326 32.1614H65.0903V33.7124H66.6326V32.1614Z",
    fill: "#131E33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.6557 30.5872H65.0684V32.1836H66.6557V30.5872Z",
    fill: "#131E33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.6326 30.6095H65.0903V32.1384H66.6326V30.6095Z",
    fill: "#131E33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.6557 24.4237H65.0684V26.0201H66.6557V24.4237Z",
    fill: "#243454"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.6326 24.4455H65.0903V25.9744H66.6326V24.4455Z",
    fill: "#243454"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.6557 22.8719H65.0684V24.4683H66.6557V22.8719Z",
    fill: "#243454"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.6326 22.916H65.0903V24.467H66.6326V22.916Z",
    fill: "#243454"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.6557 21.3418H65.0684V22.9382H66.6557V21.3418Z",
    fill: "#243454"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.6326 21.3638H65.0903V22.9149H66.6326V21.3638Z",
    fill: "#243454"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.6557 19.7892H65.0684V21.3856H66.6557V19.7892Z",
    fill: "#243454"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.6326 19.812H65.0903V21.363H66.6326V19.812Z",
    fill: "#243454"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.6557 18.2599H65.0684V19.8563H66.6557V18.2599Z",
    fill: "#243454"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.6326 18.282H65.0903V19.8109H66.6326V18.282Z",
    fill: "#243454"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.6557 16.7079H65.0684V18.3043H66.6557V16.7079Z",
    fill: "#374F80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.6326 16.7294H65.0903V18.2805H66.6326V16.7294Z",
    fill: "#374F80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.6557 13.626H65.0684V15.2223H66.6557V13.626Z",
    fill: "#3D041F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.6326 13.648H65.0903V15.1769H66.6326V13.648Z",
    fill: "#3D041F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.6557 12.0962H65.0684V13.6926H66.6557V12.0962Z",
    fill: "#3D041F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.6326 12.1182H65.0903V13.6693H66.6326V12.1182Z",
    fill: "#3D041F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.6557 10.5441H65.0684V12.1404H66.6557V10.5441Z",
    fill: "#FEB167"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.6326 10.5661H65.0903V12.1171H66.6326V10.5661Z",
    fill: "#FEB167"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.6557 9.01404H65.0684V10.6104H66.6557V9.01404Z",
    fill: "#FFE4CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.6326 9.03632H65.0903V10.5873H66.6326V9.03632Z",
    fill: "#FFE4CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.6557 7.46222H65.0684V9.05859H66.6557V7.46222Z",
    fill: "#3D041F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.6326 7.48474H65.0903V9.01361H66.6326V7.48474Z",
    fill: "#3D041F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.6557 5.93213H65.0684V7.5285H66.6557V5.93213Z",
    fill: "#3D041F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.6326 5.95416H65.0903V7.50519H66.6326V5.95416Z",
    fill: "#3D041F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.6557 4.38007H65.0684V5.97644H66.6557V4.38007Z",
    fill: "#621931"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.6326 4.40234H65.0903V5.95337H66.6326V4.40234Z",
    fill: "#621931"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.6557 2.82776H65.0684V4.42413H66.6557V2.82776Z",
    fill: "#621931"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.6326 2.85028H65.0903V4.40131H66.6326V2.85028Z",
    fill: "#621931"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.1347 67.5919H63.5474V69.1882H65.1347V67.5919Z",
    fill: "#3D041F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.1116 67.6141H63.5693V69.1652H65.1116V67.6141Z",
    fill: "#3D041F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.1347 66.0621H63.5474V67.6584H65.1347V66.0621Z",
    fill: "#541136"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.1116 66.0846H63.5693V67.6135H65.1116V66.0846Z",
    fill: "#541136"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.1347 64.5105H63.5474V66.1069H65.1347V64.5105Z",
    fill: "#541136"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.1116 64.5325H63.5693V66.0836H65.1116V64.5325Z",
    fill: "#541136"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.1347 47.5482H63.5474V49.1446H65.1347V47.5482Z",
    fill: "#131E33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.1116 47.571H63.5693V49.1221H65.1116V47.571Z",
    fill: "#131E33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.1347 46.0189H63.5474V47.6153H65.1347V46.0189Z",
    fill: "#131E33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.1116 46.041H63.5693V47.592H65.1116V46.041Z",
    fill: "#131E33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.1347 44.4669H63.5474V46.0632H65.1347V44.4669Z",
    fill: "#131E33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.1116 44.4891H63.5693V46.0402H65.1116V44.4891Z",
    fill: "#131E33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.1347 42.9371H63.5474V44.5334H65.1347V42.9371Z",
    fill: "#131E33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.1116 42.9591H63.5693V44.488H65.1116V42.9591Z",
    fill: "#131E33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.1347 41.3845H63.5474V42.9808H65.1347V41.3845Z",
    fill: "#131E33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.1116 41.407H63.5693V42.958H65.1116V41.407Z",
    fill: "#131E33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.1347 39.8329H63.5474V41.4292H65.1347V39.8329Z",
    fill: "#131E33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.1116 39.8552H63.5693V41.4062H65.1116V39.8552Z",
    fill: "#131E33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.1347 38.3031H63.5474V39.8995H65.1347V38.3031Z",
    fill: "#131E33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.1116 38.3251H63.5693V39.8762H65.1116V38.3251Z",
    fill: "#131E33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.1347 36.751H63.5474V38.3474H65.1347V36.751Z",
    fill: "#131E33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.1116 36.773H63.5693V38.3019H65.1116V36.773Z",
    fill: "#131E33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.1347 35.2212H63.5474V36.8176H65.1347V35.2212Z",
    fill: "#131E33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.1116 35.2432H63.5693V36.7943H65.1116V35.2432Z",
    fill: "#131E33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.1347 33.6691H63.5474V35.2655H65.1347V33.6691Z",
    fill: "#131E33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.1116 33.6912H63.5693V35.2422H65.1116V33.6912Z",
    fill: "#131E33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.1347 21.3418H63.5474V22.9382H65.1347V21.3418Z",
    fill: "#131E33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.1116 21.3638H63.5693V22.9149H65.1116V21.3638Z",
    fill: "#131E33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.1347 19.7892H63.5474V21.3856H65.1347V19.7892Z",
    fill: "#131E33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.1116 19.812H63.5693V21.363H65.1116V19.812Z",
    fill: "#131E33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.1347 18.2599H63.5474V19.8563H65.1347V18.2599Z",
    fill: "#243454"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.1116 18.282H63.5693V19.8109H65.1116V18.282Z",
    fill: "#243454"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.1347 16.7079H63.5474V18.3043H65.1347V16.7079Z",
    fill: "#243454"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.1116 16.7294H63.5693V18.2805H65.1116V16.7294Z",
    fill: "#243454"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.1347 13.626H63.5474V15.2223H65.1347V13.626Z",
    fill: "#3D041F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.1116 13.648H63.5693V15.1769H65.1116V13.648Z",
    fill: "#3D041F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.1347 12.0962H63.5474V13.6926H65.1347V12.0962Z",
    fill: "#621931"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.1116 12.1182H63.5693V13.6693H65.1116V12.1182Z",
    fill: "#621931"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.1347 10.5441H63.5474V12.1404H65.1347V10.5441Z",
    fill: "#621931"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.1116 10.5661H63.5693V12.1171H65.1116V10.5661Z",
    fill: "#621931"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.1347 9.01404H63.5474V10.6104H65.1347V9.01404Z",
    fill: "#621931"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.1116 9.03632H63.5693V10.5873H65.1116V9.03632Z",
    fill: "#621931"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.1347 7.46222H63.5474V9.05859H65.1347V7.46222Z",
    fill: "#621931"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.1116 7.48474H63.5693V9.01361H65.1116V7.48474Z",
    fill: "#621931"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.1347 5.93213H63.5474V7.5285H65.1347V5.93213Z",
    fill: "#621931"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.1116 5.95416H63.5693V7.50519H65.1116V5.95416Z",
    fill: "#621931"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.5913 67.5919H62.0039V69.1882H63.5913V67.5919Z",
    fill: "#3D041F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.5461 67.6141H62.0259V69.1652H63.5461V67.6141Z",
    fill: "#3D041F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.5913 66.0621H62.0039V67.6584H63.5913V66.0621Z",
    fill: "#541136"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.5461 66.0846H62.0259V67.6135H63.5461V66.0846Z",
    fill: "#541136"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.5913 41.3845H62.0039V42.9808H63.5913V41.3845Z",
    fill: "#FFE4CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.5461 41.407H62.0259V42.958H63.5461V41.407Z",
    fill: "#FFE4CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.5913 39.8329H62.0039V41.4292H63.5913V39.8329Z",
    fill: "#F57E77"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.5461 39.8552H62.0259V41.4062H63.5461V39.8552Z",
    fill: "#F57E77"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.5913 22.8719H62.0039V24.4683H63.5913V22.8719Z",
    fill: "#877A86"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.5461 22.916H62.0259V24.467H63.5461V22.916Z",
    fill: "#877A86"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.5913 21.3418H62.0039V22.9382H63.5913V21.3418Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.5461 21.3638H62.0259V22.9149H63.5461V21.3638Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.5913 19.7892H62.0039V21.3856H63.5913V19.7892Z",
    fill: "#131E33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.5461 19.812H62.0259V21.363H63.5461V19.812Z",
    fill: "#131E33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.5913 18.2599H62.0039V19.8563H63.5913V18.2599Z",
    fill: "#243454"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.5461 18.282H62.0259V19.8109H63.5461V18.282Z",
    fill: "#243454"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.5913 16.7079H62.0039V18.3043H63.5913V16.7079Z",
    fill: "#243454"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.5461 16.7294H62.0259V18.2805H63.5461V16.7294Z",
    fill: "#243454"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.5913 12.0962H62.0039V13.6926H63.5913V12.0962Z",
    fill: "#621931"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.5461 12.1182H62.0259V13.6693H63.5461V12.1182Z",
    fill: "#621931"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.5913 10.5441H62.0039V12.1404H63.5913V10.5441Z",
    fill: "#621931"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.5461 10.5661H62.0259V12.1171H63.5461V10.5661Z",
    fill: "#621931"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.0698 67.5919H60.4824V69.1882H62.0698V67.5919Z",
    fill: "#3D041F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.0471 67.6141H60.5049V69.1652H62.0471V67.6141Z",
    fill: "#3D041F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.0698 42.9371H60.4824V44.5334H62.0698V42.9371Z",
    fill: "#FFE4CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.0471 42.9591H60.5049V44.488H62.0471V42.9591Z",
    fill: "#FFE4CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.0698 41.3845H60.4824V42.9808H62.0698V41.3845Z",
    fill: "#FFE4CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.0471 41.407H60.5049V42.958H62.0471V41.407Z",
    fill: "#FFE4CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.0698 39.8329H60.4824V41.4292H62.0698V39.8329Z",
    fill: "#FFE4CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.0471 39.8552H60.5049V41.4062H62.0471V39.8552Z",
    fill: "#FFE4CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.0698 38.3031H60.4824V39.8995H62.0698V38.3031Z",
    fill: "#F57E77"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.0471 38.3251H60.5049V39.8762H62.0471V38.3251Z",
    fill: "#F57E77"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.0698 36.751H60.4824V38.3474H62.0698V36.751Z",
    fill: "#F57E77"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.0471 36.773H60.5049V38.3019H62.0471V36.773Z",
    fill: "#F57E77"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.0698 35.2212H60.4824V36.8176H62.0698V35.2212Z",
    fill: "#F57E77"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.0471 35.2432H60.5049V36.7943H62.0471V35.2432Z",
    fill: "#F57E77"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.0698 33.6691H60.4824V35.2655H62.0698V33.6691Z",
    fill: "#F57E77"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.0471 33.6912H60.5049V35.2422H62.0471V33.6912Z",
    fill: "#F57E77"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.0698 32.1396H60.4824V33.736H62.0698V32.1396Z",
    fill: "#F57E77"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.0471 32.1614H60.5049V33.7124H62.0471V32.1614Z",
    fill: "#F57E77"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.0698 30.5872H60.4824V32.1836H62.0698V30.5872Z",
    fill: "#F57E77"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.0471 30.6095H60.5049V32.1384H62.0471V30.6095Z",
    fill: "#F57E77"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.0698 29.0572H60.4824V30.6536H62.0698V29.0572Z",
    fill: "#F57E77"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.0471 29.08H60.5049V30.631H62.0471V29.08Z",
    fill: "#F57E77"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.0698 27.5051H60.4824V29.1015H62.0698V27.5051Z",
    fill: "#F57E77"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.0471 27.5274H60.5049V29.0784H62.0471V27.5274Z",
    fill: "#F57E77"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.0698 25.9758H60.4824V27.5721H62.0698V25.9758Z",
    fill: "#F57E77"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.0471 25.9973H60.5049V27.5483H62.0471V25.9973Z",
    fill: "#F57E77"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.0698 24.4237H60.4824V26.0201H62.0698V24.4237Z",
    fill: "#F57E77"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.0471 24.4455H60.5049V25.9744H62.0471V24.4455Z",
    fill: "#F57E77"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.0698 22.8719H60.4824V24.4683H62.0698V22.8719Z",
    fill: "#FFE4CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.0471 22.916H60.5049V24.467H62.0471V22.916Z",
    fill: "#FFE4CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.0698 21.3418H60.4824V22.9382H62.0698V21.3418Z",
    fill: "#FFE4CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.0471 21.3638H60.5049V22.9149H62.0471V21.3638Z",
    fill: "#FFE4CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.0698 19.7892H60.4824V21.3856H62.0698V19.7892Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.0471 19.812H60.5049V21.363H62.0471V19.812Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.0698 18.2599H60.4824V19.8563H62.0698V18.2599Z",
    fill: "#243454"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.0471 18.282H60.5049V19.8109H62.0471V18.282Z",
    fill: "#243454"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.0698 16.7079H60.4824V18.3043H62.0698V16.7079Z",
    fill: "#243454"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.0471 16.7294H60.5049V18.2805H62.0471V16.7294Z",
    fill: "#243454"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.5268 42.9371H58.9395V44.5334H60.5268V42.9371Z",
    fill: "#FFE4CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.5042 42.9591H58.9619V44.488H60.5042V42.9591Z",
    fill: "#FFE4CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.5268 41.3845H58.9395V42.9808H60.5268V41.3845Z",
    fill: "#FFE4CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.5042 41.407H58.9619V42.958H60.5042V41.407Z",
    fill: "#FFE4CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.5268 39.8329H58.9395V41.4292H60.5268V39.8329Z",
    fill: "#FFE4CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.5042 39.8552H58.9619V41.4062H60.5042V39.8552Z",
    fill: "#FFE4CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.5268 38.3031H58.9395V39.8995H60.5268V38.3031Z",
    fill: "#FFE4CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.5042 38.3251H58.9619V39.8762H60.5042V38.3251Z",
    fill: "#FFE4CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.5268 36.751H58.9395V38.3474H60.5268V36.751Z",
    fill: "#FFE4CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.5042 36.773H58.9619V38.3019H60.5042V36.773Z",
    fill: "#FFE4CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.5268 35.2212H58.9395V36.8176H60.5268V35.2212Z",
    fill: "#FFE4CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.5042 35.2432H58.9619V36.7943H60.5042V35.2432Z",
    fill: "#FFE4CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.5268 33.6691H58.9395V35.2655H60.5268V33.6691Z",
    fill: "#FFE4CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.5042 33.6912H58.9619V35.2422H60.5042V33.6912Z",
    fill: "#FFE4CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.5268 32.1396H58.9395V33.736H60.5268V32.1396Z",
    fill: "#FFE4CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.5042 32.1614H58.9619V33.7124H60.5042V32.1614Z",
    fill: "#FFE4CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.5268 30.5872H58.9395V32.1836H60.5268V30.5872Z",
    fill: "#FFE4CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.5042 30.6095H58.9619V32.1384H60.5042V30.6095Z",
    fill: "#FFE4CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.5268 29.0572H58.9395V30.6536H60.5268V29.0572Z",
    fill: "#FFE4CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.5042 29.08H58.9619V30.631H60.5042V29.08Z",
    fill: "#FFE4CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.5268 27.5051H58.9395V29.1015H60.5268V27.5051Z",
    fill: "#FFE4CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.5042 27.5274H58.9619V29.0784H60.5042V27.5274Z",
    fill: "#FFE4CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.5268 25.9758H58.9395V27.5721H60.5268V25.9758Z",
    fill: "#FFE4CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.5042 25.9973H58.9619V27.5483H60.5042V25.9973Z",
    fill: "#FFE4CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.5268 24.4237H58.9395V26.0201H60.5268V24.4237Z",
    fill: "#FFE4CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.5042 24.4455H58.9619V25.9744H60.5042V24.4455Z",
    fill: "#FFE4CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.5268 22.8719H58.9395V24.4683H60.5268V22.8719Z",
    fill: "#FFE4CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.5042 22.916H58.9619V24.467H60.5042V22.916Z",
    fill: "#FFE4CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.5268 21.3418H58.9395V22.9382H60.5268V21.3418Z",
    fill: "#FFE4CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.5042 21.3638H58.9619V22.9149H60.5042V21.3638Z",
    fill: "#FFE4CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.857 67.6295H50.3301V69.1651H51.857V67.6295Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.8148 67.6511H50.3516V69.144H51.8148V67.6511Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.857 43.9135H50.3301V45.4491H51.857V43.9135Z",
    fill: "#FFE4CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.8148 43.9346H50.3516V45.4062H51.8148V43.9346Z",
    fill: "#FFE4CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.857 42.4205H50.3301V43.9561H51.857V42.4205Z",
    fill: "#FFE4CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.8148 42.442H50.3516V43.935H51.8148V42.442Z",
    fill: "#FFE4CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.857 40.9274H50.3301V42.4629H51.857V40.9274Z",
    fill: "#FFE4CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.8148 40.9489H50.3516V42.4418H51.8148V40.9489Z",
    fill: "#FFE4CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.857 39.4558H50.3301V40.9914H51.857V39.4558Z",
    fill: "#FFE4CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.8148 39.4776H50.3516V40.9705H51.8148V39.4776Z",
    fill: "#FFE4CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.857 37.9628H50.3301V39.4984H51.857V37.9628Z",
    fill: "#FFE4CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.8148 37.984H50.3516V39.4556H51.8148V37.984Z",
    fill: "#FFE4CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.857 36.491H50.3301V38.0266H51.857V36.491Z",
    fill: "#FFE4CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.8148 36.5125H50.3516V38.0054H51.8148V36.5125Z",
    fill: "#FFE4CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.857 34.9984H50.3301V36.5339H51.857V34.9984Z",
    fill: "#FFE4CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.8148 35.0194H50.3516V36.5123H51.8148V35.0194Z",
    fill: "#FFE4CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.857 33.5263H50.3301V35.0619H51.857V33.5263Z",
    fill: "#FFE4CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.8148 33.5479H50.3516V35.0408H51.8148V33.5479Z",
    fill: "#FFE4CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.857 32.0338H50.3301V33.5693H51.857V32.0338Z",
    fill: "#FFE4CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.8148 32.0548H50.3516V33.5264H51.8148V32.0548Z",
    fill: "#FFE4CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.857 30.5624H50.3301V32.098H51.857V30.5624Z",
    fill: "#FFE4CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.8148 30.5835H50.3516V32.0764H51.8148V30.5835Z",
    fill: "#FFE4CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.857 29.0693H50.3301V30.6049H51.857V29.0693Z",
    fill: "#FFE4CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.8148 29.0904H50.3516V30.5833H51.8148V29.0904Z",
    fill: "#FFE4CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.857 27.5763H50.3301V29.1119H51.857V27.5763Z",
    fill: "#FFE4CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.8148 27.6189H50.3516V29.1118H51.8148V27.6189Z",
    fill: "#FFE4CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.857 26.1047H50.3301V27.6403H51.857V26.1047Z",
    fill: "#BCBCBC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.8148 26.1258H50.3516V27.5974H51.8148V26.1258Z",
    fill: "#BCBCBC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.857 24.6116H50.3301V26.1472H51.857V24.6116Z",
    fill: "#BCBCBC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.8148 24.6545H50.3516V26.1474H51.8148V24.6545Z",
    fill: "#BCBCBC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.857 23.1404H50.3301V24.676H51.857V23.1404Z",
    fill: "#BCBCBC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.8148 23.1614H50.3516V24.6544H51.8148V23.1614Z",
    fill: "#BCBCBC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.3936 67.6295H48.8667V69.1651H50.3936V67.6295Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.3722 67.6511H48.8877V69.144H50.3722V67.6511Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.3936 66.158H48.8667V67.6936H50.3936V66.158Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.3722 66.1793H48.8877V67.6509H50.3722V66.1793Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.3936 64.6652H48.8667V66.2008H50.3936V64.6652Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.3722 64.6867H48.8877V66.1796H50.3722V64.6867Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.3936 43.9135H48.8667V45.4491H50.3936V43.9135Z",
    fill: "#FFE4CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.3722 43.9346H48.8877V45.4062H50.3722V43.9346Z",
    fill: "#FFE4CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.3936 42.4205H48.8667V43.9561H50.3936V42.4205Z",
    fill: "#FFE4CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.3722 42.442H48.8877V43.935H50.3722V42.442Z",
    fill: "#FFE4CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.3936 40.9274H48.8667V42.4629H50.3936V40.9274Z",
    fill: "#FFE4CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.3722 40.9489H48.8877V42.4418H50.3722V40.9489Z",
    fill: "#FFE4CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.3936 39.4558H48.8667V40.9914H50.3936V39.4558Z",
    fill: "#F57E77"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.3722 39.4776H48.8877V40.9705H50.3722V39.4776Z",
    fill: "#F57E77"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.3936 37.9628H48.8667V39.4984H50.3936V37.9628Z",
    fill: "#F57E77"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.3722 37.984H48.8877V39.4556H50.3722V37.984Z",
    fill: "#F57E77"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.3936 36.491H48.8667V38.0266H50.3936V36.491Z",
    fill: "#F57E77"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.3722 36.5125H48.8877V38.0054H50.3722V36.5125Z",
    fill: "#F57E77"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.3936 34.9984H48.8667V36.5339H50.3936V34.9984Z",
    fill: "#F57E77"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.3722 35.0194H48.8877V36.5123H50.3722V35.0194Z",
    fill: "#F57E77"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.3936 33.5263H48.8667V35.0619H50.3936V33.5263Z",
    fill: "#F57E77"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.3722 33.5479H48.8877V35.0408H50.3722V33.5479Z",
    fill: "#F57E77"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.3936 32.0338H48.8667V33.5693H50.3936V32.0338Z",
    fill: "#F57E77"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.3722 32.0548H48.8877V33.5264H50.3722V32.0548Z",
    fill: "#F57E77"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.3936 30.5624H48.8667V32.098H50.3936V30.5624Z",
    fill: "#F57E77"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.3722 30.5835H48.8877V32.0764H50.3722V30.5835Z",
    fill: "#F57E77"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.3936 29.0693H48.8667V30.6049H50.3936V29.0693Z",
    fill: "#F57E77"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.3722 29.0904H48.8877V30.5833H50.3722V29.0904Z",
    fill: "#F57E77"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.3936 27.5763H48.8667V29.1119H50.3936V27.5763Z",
    fill: "#F57E77"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.3722 27.6189H48.8877V29.1118H50.3722V27.6189Z",
    fill: "#F57E77"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.3936 26.1047H48.8667V27.6403H50.3936V26.1047Z",
    fill: "#BCBCBC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.3722 26.1258H48.8877V27.5974H50.3722V26.1258Z",
    fill: "#BCBCBC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.3936 24.6116H48.8667V26.1472H50.3936V24.6116Z",
    fill: "#BCBCBC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.3722 24.6545H48.8877V26.1474H50.3722V24.6545Z",
    fill: "#BCBCBC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.3936 23.1404H48.8667V24.676H50.3936V23.1404Z",
    fill: "#BCBCBC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.3722 23.1614H48.8877V24.6544H50.3722V23.1614Z",
    fill: "#BCBCBC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.3936 21.6473H48.8667V23.1829H50.3936V21.6473Z",
    fill: "#BCBCBC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.3722 21.6688H48.8877V23.1618H50.3722V21.6688Z",
    fill: "#BCBCBC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.3936 20.176H48.8667V21.7116H50.3936V20.176Z",
    fill: "#BCBCBC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.3722 20.1968H48.8877V21.6684H50.3722V20.1968Z",
    fill: "#BCBCBC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.9092 67.6295H47.3823V69.1651H48.9092V67.6295Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.8878 67.6511H47.4033V69.144H48.8878V67.6511Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.9092 66.158H47.3823V67.6936H48.9092V66.158Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.8878 66.1793H47.4033V67.6509H48.8878V66.1793Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.9092 64.6652H47.3823V66.2008H48.9092V64.6652Z",
    fill: "#E7E0D4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.8878 64.6867H47.4033V66.1796H48.8878V64.6867Z",
    fill: "#E7E0D4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.9092 42.4205H47.3823V43.9561H48.9092V42.4205Z",
    fill: "#FFE4CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.8878 42.442H47.4033V43.935H48.8878V42.442Z",
    fill: "#FFE4CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.9092 40.9274H47.3823V42.4629H48.9092V40.9274Z",
    fill: "#F57E77"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.8878 40.9489H47.4033V42.4418H48.8878V40.9489Z",
    fill: "#F57E77"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.9092 26.1047H47.3823V27.6403H48.9092V26.1047Z",
    fill: "#686868"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.8878 26.1258H47.4033V27.5974H48.8878V26.1258Z",
    fill: "#686868"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.9092 24.6116H47.3823V26.1472H48.9092V24.6116Z",
    fill: "#686868"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.8878 24.6545H47.4033V26.1474H48.8878V24.6545Z",
    fill: "#686868"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.9092 23.1404H47.3823V24.676H48.9092V23.1404Z",
    fill: "#BCBCBC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.8878 23.1614H47.4033V24.6544H48.8878V23.1614Z",
    fill: "#BCBCBC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.9092 21.6473H47.3823V23.1829H48.9092V21.6473Z",
    fill: "#BCBCBC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.8878 21.6688H47.4033V23.1618H48.8878V21.6688Z",
    fill: "#BCBCBC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.9092 20.176H47.3823V21.7116H48.9092V20.176Z",
    fill: "#BCBCBC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.8878 20.1968H47.4033V21.6684H48.8878V20.1968Z",
    fill: "#BCBCBC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.4459 67.6295H45.9189V69.1651H47.4459V67.6295Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.4244 67.6511H45.9399V69.144H47.4244V67.6511Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.4459 66.158H45.9189V67.6936H47.4459V66.158Z",
    fill: "#E7E0D4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.4244 66.1793H45.9399V67.6509H47.4244V66.1793Z",
    fill: "#E7E0D4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.4459 64.6652H45.9189V66.2008H47.4459V64.6652Z",
    fill: "#416D6E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.4244 64.6867H45.9399V66.1796H47.4244V64.6867Z",
    fill: "#416D6E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.4459 61.7005H45.9189V63.2361H47.4459V61.7005Z",
    fill: "#416D6E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.4244 61.722H45.9399V63.215H47.4244V61.722Z",
    fill: "#416D6E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.4459 23.1404H45.9189V24.676H47.4459V23.1404Z",
    fill: "#686868"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.4244 23.1614H45.9399V24.6544H47.4244V23.1614Z",
    fill: "#686868"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.4459 21.6473H45.9189V23.1829H47.4459V21.6473Z",
    fill: "#BCBCBC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.4244 21.6688H45.9399V23.1618H47.4244V21.6688Z",
    fill: "#BCBCBC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.4459 20.176H45.9189V21.7116H47.4459V20.176Z",
    fill: "#BCBCBC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.4244 20.1968H45.9399V21.6684H47.4244V20.1968Z",
    fill: "#BCBCBC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.4459 18.6827H45.9189V20.2183H47.4459V18.6827Z",
    fill: "#BCBCBC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.4244 18.7042H45.9399V20.1972H47.4244V18.7042Z",
    fill: "#BCBCBC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.4459 11.2816H45.9189V12.8172H47.4459V11.2816Z",
    fill: "#F57E77"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.4244 11.3034H45.9399V12.7963H47.4244V11.3034Z",
    fill: "#F57E77"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.4459 9.78906H45.9189V11.3247H47.4459V9.78906Z",
    fill: "#FFE4CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.4244 9.81036H45.9399V11.282H47.4244V9.81036Z",
    fill: "#FFE4CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.4459 8.2962H45.9189V9.8318H47.4459V8.2962Z",
    fill: "#F8DB94"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.4244 8.33881H45.9399V9.83174H47.4244V8.33881Z",
    fill: "#F8DB94"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.9615 67.6295H44.4346V69.1651H45.9615V67.6295Z",
    fill: "#877A86"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.9189 67.6511H44.4556V69.144H45.9189V67.6511Z",
    fill: "#877A86"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.9615 66.158H44.4346V67.6936H45.9615V66.158Z",
    fill: "#343A52"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.9189 66.1793H44.4556V67.6509H45.9189V66.1793Z",
    fill: "#343A52"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.9615 64.6652H44.4346V66.2008H45.9615V64.6652Z",
    fill: "#416D6E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.9189 64.6867H44.4556V66.1796H45.9189V64.6867Z",
    fill: "#416D6E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.9615 63.1936H44.4346V64.7292H45.9615V63.1936Z",
    fill: "#416D6E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.9189 63.2147H44.4556V64.7076H45.9189V63.2147Z",
    fill: "#416D6E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.9615 61.7005H44.4346V63.2361H45.9615V61.7005Z",
    fill: "#343A52"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.9189 61.722H44.4556V63.215H45.9189V61.722Z",
    fill: "#343A52"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.9615 49.8425H44.4346V51.3781H45.9615V49.8425Z",
    fill: "#243454"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.9191 49.8636H43.0137V60.2302H45.9191V49.8636Z",
    fill: "#243454"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.9615 48.3494H44.4346V49.885H45.9615V48.3494Z",
    fill: "#243454"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.9189 48.3705H44.4556V49.8634H45.9189V48.3705Z",
    fill: "#243454"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.9615 46.8779H44.4346V48.4135H45.9615V46.8779Z",
    fill: "#243454"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.9189 46.8992H44.4556V48.3921H45.9189V46.8992Z",
    fill: "#243454"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.9615 45.3848H44.4346V46.9204H45.9615V45.3848Z",
    fill: "#243454"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.9189 45.4061H44.4556V46.8991H45.9189V45.4061Z",
    fill: "#243454"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.9615 43.9135H44.4346V45.4491H45.9615V43.9135Z",
    fill: "#243454"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.9189 43.9346H44.4556V45.4062H45.9189V43.9346Z",
    fill: "#243454"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.9615 42.4205H44.4346V43.9561H45.9615V42.4205Z",
    fill: "#243454"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.9189 42.442H44.4556V43.935H45.9189V42.442Z",
    fill: "#243454"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.9615 40.9274H44.4346V42.4629H45.9615V40.9274Z",
    fill: "#243454"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.9189 40.9489H44.4556V42.4418H45.9189V40.9489Z",
    fill: "#243454"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.9615 39.4558H44.4346V40.9914H45.9615V39.4558Z",
    fill: "#243454"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.9189 39.4776H44.4556V40.9705H45.9189V39.4776Z",
    fill: "#243454"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.9615 37.9628H44.4346V39.4984H45.9615V37.9628Z",
    fill: "#131E33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.9189 37.984H44.4556V39.4556H45.9189V37.984Z",
    fill: "#131E33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.9615 36.491H44.4346V38.0266H45.9615V36.491Z",
    fill: "#0A0F1A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.9189 36.5125H44.4556V38.0054H45.9189V36.5125Z",
    fill: "#0A0F1A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.9615 34.9984H44.4346V36.5339H45.9615V34.9984Z",
    fill: "#686868"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.9189 35.0194H44.4556V36.5123H45.9189V35.0194Z",
    fill: "#686868"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.9615 33.5263H44.4346V35.0619H45.9615V33.5263Z",
    fill: "#686868"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.9189 33.5479H44.4556V35.0408H45.9189V33.5479Z",
    fill: "#686868"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.9615 32.0338H44.4346V33.5693H45.9615V32.0338Z",
    fill: "#686868"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.9189 32.0548H44.4556V33.5264H45.9189V32.0548Z",
    fill: "#686868"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.9615 30.5624H44.4346V32.098H45.9615V30.5624Z",
    fill: "#686868"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.9189 30.5835H44.4556V32.0764H45.9189V30.5835Z",
    fill: "#686868"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.9615 29.0693H44.4346V30.6049H45.9615V29.0693Z",
    fill: "#686868"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.9189 29.0904H44.4556V30.5833H45.9189V29.0904Z",
    fill: "#686868"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.9615 27.5763H44.4346V29.1119H45.9615V27.5763Z",
    fill: "#686868"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.9189 27.6189H44.4556V29.1118H45.9189V27.6189Z",
    fill: "#686868"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.9615 26.1047H44.4346V27.6403H45.9615V26.1047Z",
    fill: "#686868"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.9189 26.1258H44.4556V27.5974H45.9189V26.1258Z",
    fill: "#686868"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.9615 24.6116H44.4346V26.1472H45.9615V24.6116Z",
    fill: "#686868"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.9189 24.6545H44.4556V26.1474H45.9189V24.6545Z",
    fill: "#686868"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.9615 23.1404H44.4346V24.676H45.9615V23.1404Z",
    fill: "#686868"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.9189 23.1614H44.4556V24.6544H45.9189V23.1614Z",
    fill: "#686868"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.9615 21.6473H44.4346V23.1829H45.9615V21.6473Z",
    fill: "#BCBCBC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.9189 21.6688H44.4556V23.1618H45.9189V21.6688Z",
    fill: "#BCBCBC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.9615 20.176H44.4346V21.7116H45.9615V20.176Z",
    fill: "#BCBCBC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.9189 20.1968H44.4556V21.6684H45.9189V20.1968Z",
    fill: "#BCBCBC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.9615 18.6827H44.4346V20.2183H45.9615V18.6827Z",
    fill: "#686868"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.9189 18.7042H44.4556V20.1972H45.9189V18.7042Z",
    fill: "#686868"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.9615 12.7537H44.4346V14.2893H45.9615V12.7537Z",
    fill: "#F57E77"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.9189 12.7747H44.4556V14.2677H45.9189V12.7747Z",
    fill: "#F57E77"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.9615 11.2816H44.4346V12.8172H45.9615V11.2816Z",
    fill: "#FFE4CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.9189 11.3034H44.4556V12.7963H45.9189V11.3034Z",
    fill: "#FFE4CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.9615 9.78906H44.4346V11.3247H45.9615V9.78906Z",
    fill: "#FBAE64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.9189 9.81036H44.4556V11.282H45.9189V9.81036Z",
    fill: "#FBAE64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.9615 8.2962H44.4346V9.8318H45.9615V8.2962Z",
    fill: "#FBAE64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.9189 8.33881H44.4556V9.83174H45.9189V8.33881Z",
    fill: "#FBAE64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.9615 6.82465H44.4346V8.36024H45.9615V6.82465Z",
    fill: "#F8DB94"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.9189 6.8457H44.4556V8.33864H45.9189V6.8457Z",
    fill: "#F8DB94"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.9615 5.3316H44.4346V6.8672H45.9615V5.3316Z",
    fill: "#F8DB94"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.9189 5.35266H44.4556V6.8456H45.9189V5.35266Z",
    fill: "#F8DB94"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.4976 67.6295H42.9707V69.1651H44.4976V67.6295Z",
    fill: "#877A86"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.4767 67.6511H42.9922V69.144H44.4767V67.6511Z",
    fill: "#877A86"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.4976 66.158H42.9707V67.6936H44.4976V66.158Z",
    fill: "#343A52"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.4767 66.1793H42.9922V67.6509H44.4767V66.1793Z",
    fill: "#343A52"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.4976 64.6652H42.9707V66.2008H44.4976V64.6652Z",
    fill: "#416D6E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.4767 64.6867H42.9922V66.1796H44.4767V64.6867Z",
    fill: "#416D6E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.4976 63.1936H42.9707V64.7292H44.4976V63.1936Z",
    fill: "#416D6E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.4767 63.2147H42.9922V64.7076H44.4767V63.2147Z",
    fill: "#416D6E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.4976 61.7005H42.9707V63.2361H44.4976V61.7005Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.4767 61.722H42.9922V63.215H44.4767V61.722Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.4976 60.229H42.9707V61.7646H44.4976V60.229Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.4767 60.2503H42.9922V61.7219H44.4767V60.2503Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.4976 58.7359H42.9707V60.2715H44.4976V58.7359Z",
    fill: "#FFE4CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.4767 58.7572H42.9922V60.2501H44.4767V58.7572Z",
    fill: "#FFE4CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.4976 57.2435H42.9707V58.7791H44.4976V57.2435Z",
    fill: "#FFE4CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.4767 57.2641H42.9922V58.757H44.4767V57.2641Z",
    fill: "#FFE4CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.4976 55.7715H42.9707V57.3071H44.4976V55.7715Z",
    fill: "#FFE4CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.4767 55.7926H42.9922V57.2855H44.4767V55.7926Z",
    fill: "#FFE4CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.4976 54.2784H42.9707V55.814H44.4976V54.2784Z",
    fill: "#FFE4CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.4767 54.2995H42.9922V55.7711H44.4767V54.2995Z",
    fill: "#FFE4CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.4976 52.8069H42.9707V54.3425H44.4976V52.8069Z",
    fill: "#FFE4CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.4767 52.8282H42.9922V54.3211H44.4767V52.8282Z",
    fill: "#FFE4CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.4976 51.3138H42.9707V52.8494H44.4976V51.3138Z",
    fill: "#FFE4CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.4767 51.3351H42.9922V52.8281H44.4767V51.3351Z",
    fill: "#FFE4CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.4976 49.8425H42.9707V51.3781H44.4976V49.8425Z",
    fill: "#243454"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.6213 49.8636H42.9922V60.2302H44.6213V49.8636Z",
    fill: "#243454"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.4976 48.3494H42.9707V49.885H44.4976V48.3494Z",
    fill: "#243454"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.4767 48.3705H42.9922V49.8634H44.4767V48.3705Z",
    fill: "#243454"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.4976 46.8779H42.9707V48.4135H44.4976V46.8779Z",
    fill: "#243454"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.4767 46.8992H42.9922V48.3921H44.4767V46.8992Z",
    fill: "#243454"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.4976 45.3848H42.9707V46.9204H44.4976V45.3848Z",
    fill: "#243454"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.4767 45.4061H42.9922V46.8991H44.4767V45.4061Z",
    fill: "#243454"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.4976 43.9135H42.9707V45.4491H44.4976V43.9135Z",
    fill: "#243454"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.4767 43.9346H42.9922V45.4062H44.4767V43.9346Z",
    fill: "#243454"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.4976 42.4205H42.9707V43.9561H44.4976V42.4205Z",
    fill: "#243454"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.4767 42.442H42.9922V43.935H44.4767V42.442Z",
    fill: "#243454"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.4976 40.9274H42.9707V42.4629H44.4976V40.9274Z",
    fill: "#243454"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.4767 40.9489H42.9922V42.4418H44.4767V40.9489Z",
    fill: "#243454"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.4976 39.4558H42.9707V40.9914H44.4976V39.4558Z",
    fill: "#243454"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.4767 39.4776H42.9922V40.9705H44.4767V39.4776Z",
    fill: "#243454"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.4976 37.9628H42.9707V39.4984H44.4976V37.9628Z",
    fill: "#243454"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.4767 37.984H42.9922V39.4556H44.4767V37.984Z",
    fill: "#243454"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.4976 36.491H42.9707V38.0266H44.4976V36.491Z",
    fill: "#0A0F1A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.4767 36.5125H42.9922V38.0054H44.4767V36.5125Z",
    fill: "#0A0F1A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.4976 34.9984H42.9707V36.5339H44.4976V34.9984Z",
    fill: "#222A3B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.4767 35.0194H42.9922V36.5123H44.4767V35.0194Z",
    fill: "#222A3B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.4976 33.5263H42.9707V35.0619H44.4976V33.5263Z",
    fill: "#BCBCBC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.4767 33.5479H42.9922V35.0408H44.4767V33.5479Z",
    fill: "#BCBCBC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.4976 32.0338H42.9707V33.5693H44.4976V32.0338Z",
    fill: "#BCBCBC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.4767 32.0548H42.9922V33.5264H44.4767V32.0548Z",
    fill: "#BCBCBC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.4976 30.5624H42.9707V32.098H44.4976V30.5624Z",
    fill: "#BCBCBC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.4767 30.5835H42.9922V32.0764H44.4767V30.5835Z",
    fill: "#BCBCBC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.4976 29.0693H42.9707V30.6049H44.4976V29.0693Z",
    fill: "#BCBCBC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.4767 29.0904H42.9922V30.5833H44.4767V29.0904Z",
    fill: "#BCBCBC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.4976 27.5763H42.9707V29.1119H44.4976V27.5763Z",
    fill: "#BCBCBC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.4767 27.6189H42.9922V29.1118H44.4767V27.6189Z",
    fill: "#BCBCBC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.4976 26.1047H42.9707V27.6403H44.4976V26.1047Z",
    fill: "#BCBCBC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.4767 26.1258H42.9922V27.5974H44.4767V26.1258Z",
    fill: "#BCBCBC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.4976 24.6116H42.9707V26.1472H44.4976V24.6116Z",
    fill: "#BCBCBC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.4767 24.6545H42.9922V26.1474H44.4767V24.6545Z",
    fill: "#BCBCBC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.4976 23.1404H42.9707V24.676H44.4976V23.1404Z",
    fill: "#BCBCBC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.4767 23.1614H42.9922V24.6544H44.4767V23.1614Z",
    fill: "#BCBCBC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.4976 21.6473H42.9707V23.1829H44.4976V21.6473Z",
    fill: "#BCBCBC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.4767 21.6688H42.9922V23.1618H44.4767V21.6688Z",
    fill: "#BCBCBC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.4976 20.176H42.9707V21.7116H44.4976V20.176Z",
    fill: "#686868"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.4767 20.1968H42.9922V21.6684H44.4767V20.1968Z",
    fill: "#686868"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.4976 18.6827H42.9707V20.2183H44.4976V18.6827Z",
    fill: "#686868"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.4767 18.7042H42.9922V20.1972H44.4767V18.7042Z",
    fill: "#686868"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.4976 17.2111H42.9707V18.7467H44.4976V17.2111Z",
    fill: "#686868"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.4767 17.2324H42.9922V18.7254H44.4767V17.2324Z",
    fill: "#686868"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.4976 14.2463H42.9707V15.7819H44.4976V14.2463Z",
    fill: "#F57E77"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.4767 14.2678H42.9922V15.7608H44.4767V14.2678Z",
    fill: "#F57E77"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.4976 12.7537H42.9707V14.2893H44.4976V12.7537Z",
    fill: "#FFE4CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.4767 12.7747H42.9922V14.2677H44.4767V12.7747Z",
    fill: "#FFE4CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.4976 11.2816H42.9707V12.8172H44.4976V11.2816Z",
    fill: "#FFE4CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.4767 11.3034H42.9922V12.7963H44.4767V11.3034Z",
    fill: "#FFE4CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.4976 9.78906H42.9707V11.3247H44.4976V9.78906Z",
    fill: "#FFE4CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.4767 9.81036H42.9922V11.282H44.4767V9.81036Z",
    fill: "#FFE4CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.4976 8.2962H42.9707V9.8318H44.4976V8.2962Z",
    fill: "#FFE4CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.4767 8.33881H42.9922V9.83174H44.4767V8.33881Z",
    fill: "#FFE4CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.4976 6.82465H42.9707V8.36024H44.4976V6.82465Z",
    fill: "#FBAE64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.4767 6.8457H42.9922V8.33864H44.4767V6.8457Z",
    fill: "#FBAE64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.4976 5.3316H42.9707V6.8672H44.4976V5.3316Z",
    fill: "#F8DB94"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.4767 5.35266H42.9922V6.8456H44.4767V5.35266Z",
    fill: "#F8DB94"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.4976 3.86005H42.9707V5.39563H44.4976V3.86005Z",
    fill: "#F8DB94"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.4767 3.88135H42.9922V5.35295H44.4767V3.88135Z",
    fill: "#F8DB94"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.0132 67.6295H41.4863V69.1651H43.0132V67.6295Z",
    fill: "#877A86"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.9923 67.6511H41.5078V69.144H42.9923V67.6511Z",
    fill: "#877A86"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.0132 66.158H41.4863V67.6936H43.0132V66.158Z",
    fill: "#343A52"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.9923 66.1793H41.5078V67.6509H42.9923V66.1793Z",
    fill: "#343A52"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.0132 64.6652H41.4863V66.2008H43.0132V64.6652Z",
    fill: "#343A52"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.9923 64.6867H41.5078V66.1796H42.9923V64.6867Z",
    fill: "#343A52"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.0132 63.1936H41.4863V64.7292H43.0132V63.1936Z",
    fill: "#343A52"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.9923 63.2147H41.5078V64.7076H42.9923V63.2147Z",
    fill: "#343A52"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.0132 61.7005H41.4863V63.2361H43.0132V61.7005Z",
    fill: "#E7E0D4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.9923 61.722H41.5078V63.215H42.9923V61.722Z",
    fill: "#E7E0D4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.0132 60.229H41.4863V61.7646H43.0132V60.229Z",
    fill: "#E7E0D4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.9923 60.2503H41.5078V61.7219H42.9923V60.2503Z",
    fill: "#E7E0D4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.0132 58.7359H41.4863V60.2715H43.0132V58.7359Z",
    fill: "#F57E77"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.9923 58.7572H41.5078V60.2501H42.9923V58.7572Z",
    fill: "#F57E77"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.0132 57.2435H41.4863V58.7791H43.0132V57.2435Z",
    fill: "#F57E77"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.9923 57.2641H41.5078V58.757H42.9923V57.2641Z",
    fill: "#F57E77"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.0132 55.7715H41.4863V57.3071H43.0132V55.7715Z",
    fill: "#F57E77"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.9923 55.7926H41.5078V57.2855H42.9923V55.7926Z",
    fill: "#F57E77"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.0132 54.2784H41.4863V55.814H43.0132V54.2784Z",
    fill: "#F57E77"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.9923 54.2995H41.5078V55.7711H42.9923V54.2995Z",
    fill: "#F57E77"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.0132 52.8069H41.4863V54.3425H43.0132V52.8069Z",
    fill: "#F57E77"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.9923 52.8282H41.5078V54.3211H42.9923V52.8282Z",
    fill: "#F57E77"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.0132 51.3138H41.4863V52.8494H43.0132V51.3138Z",
    fill: "#F57E77"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.9923 51.3351H41.5078V52.8281H42.9923V51.3351Z",
    fill: "#F57E77"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.0132 49.8425H41.4863V51.3781H43.0132V49.8425Z",
    fill: "#131E33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.0132 49.8636H41.4863V60.2302H43.0132V49.8636Z",
    fill: "#131E33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.0132 48.3494H41.4863V49.885H43.0132V48.3494Z",
    fill: "#131E33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.9923 48.3705H41.5078V49.8634H42.9923V48.3705Z",
    fill: "#131E33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.0132 46.8779H41.4863V48.4135H43.0132V46.8779Z",
    fill: "#131E33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.9923 46.8992H41.5078V48.3921H42.9923V46.8992Z",
    fill: "#131E33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.0132 45.3848H41.4863V46.9204H43.0132V45.3848Z",
    fill: "#131E33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.9923 45.4061H41.5078V46.8991H42.9923V45.4061Z",
    fill: "#131E33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.0132 43.9135H41.4863V45.4491H43.0132V43.9135Z",
    fill: "#131E33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.9923 43.9346H41.5078V45.4062H42.9923V43.9346Z",
    fill: "#131E33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.0132 42.4205H41.4863V43.9561H43.0132V42.4205Z",
    fill: "#131E33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.9923 42.442H41.5078V43.935H42.9923V42.442Z",
    fill: "#131E33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.0132 40.9274H41.4863V42.4629H43.0132V40.9274Z",
    fill: "#243454"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.9923 40.9489H41.5078V42.4418H42.9923V40.9489Z",
    fill: "#243454"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.0132 39.4558H41.4863V40.9914H43.0132V39.4558Z",
    fill: "#243454"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.9923 39.4776H41.5078V40.9705H42.9923V39.4776Z",
    fill: "#243454"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.0132 37.9628H41.4863V39.4984H43.0132V37.9628Z",
    fill: "#243454"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.9923 37.984H41.5078V39.4556H42.9923V37.984Z",
    fill: "#243454"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.0132 36.491H41.4863V38.0266H43.0132V36.491Z",
    fill: "#0A0F1A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.9923 36.5125H41.5078V38.0054H42.9923V36.5125Z",
    fill: "#0A0F1A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.0132 34.9984H41.4863V36.5339H43.0132V34.9984Z",
    fill: "#303C54"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.9923 35.0194H41.5078V36.5123H42.9923V35.0194Z",
    fill: "#303C54"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.0132 33.5263H41.4863V35.0619H43.0132V33.5263Z",
    fill: "#303C54"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.9923 33.5479H41.5078V35.0408H42.9923V33.5479Z",
    fill: "#303C54"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.0132 32.0338H41.4863V33.5693H43.0132V32.0338Z",
    fill: "#222A3B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.9923 32.0548H41.5078V33.5264H42.9923V32.0548Z",
    fill: "#222A3B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.0132 30.5624H41.4863V32.098H43.0132V30.5624Z",
    fill: "#222A3B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.9923 30.5835H41.5078V32.0764H42.9923V30.5835Z",
    fill: "#222A3B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.0132 29.0693H41.4863V30.6049H43.0132V29.0693Z",
    fill: "#222A3B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.9923 29.0904H41.5078V30.5833H42.9923V29.0904Z",
    fill: "#222A3B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.0132 27.5763H41.4863V29.1119H43.0132V27.5763Z",
    fill: "#222A3B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.9923 27.6189H41.5078V29.1118H42.9923V27.6189Z",
    fill: "#222A3B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.0132 26.1047H41.4863V27.6403H43.0132V26.1047Z",
    fill: "#222A3B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.9923 26.1258H41.5078V27.5974H42.9923V26.1258Z",
    fill: "#222A3B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.0132 24.6116H41.4863V26.1472H43.0132V24.6116Z",
    fill: "#222A3B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.9923 24.6545H41.5078V26.1474H42.9923V24.6545Z",
    fill: "#222A3B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.0132 23.1404H41.4863V24.676H43.0132V23.1404Z",
    fill: "#222A3B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.9923 23.1614H41.5078V24.6544H42.9923V23.1614Z",
    fill: "#222A3B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.0132 21.6473H41.4863V23.1829H43.0132V21.6473Z",
    fill: "#222A3B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.9923 21.6688H41.5078V23.1618H42.9923V21.6688Z",
    fill: "#222A3B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.0132 20.176H41.4863V21.7116H43.0132V20.176Z",
    fill: "#222A3B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.9923 20.1968H41.5078V21.6684H42.9923V20.1968Z",
    fill: "#222A3B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.0132 18.6827H41.4863V20.2183H43.0132V18.6827Z",
    fill: "#F57E77"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.9923 18.7042H41.5078V20.1972H42.9923V18.7042Z",
    fill: "#F57E77"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.0132 17.2111H41.4863V18.7467H43.0132V17.2111Z",
    fill: "#F57E77"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.9923 17.2324H41.5078V18.7254H42.9923V17.2324Z",
    fill: "#F57E77"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.0132 15.7183H41.4863V17.2538H43.0132V15.7183Z",
    fill: "#F57E77"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.9923 15.7398H41.5078V17.2114H42.9923V15.7398Z",
    fill: "#F57E77"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.0132 14.2463H41.4863V15.7819H43.0132V14.2463Z",
    fill: "#FFE4CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.9923 14.2678H41.5078V15.7608H42.9923V14.2678Z",
    fill: "#FFE4CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.0132 12.7537H41.4863V14.2893H43.0132V12.7537Z",
    fill: "#FFE4CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.9923 12.7747H41.5078V14.2677H42.9923V12.7747Z",
    fill: "#FFE4CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.0132 11.2816H41.4863V12.8172H43.0132V11.2816Z",
    fill: "#FFE4CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.9923 11.3034H41.5078V12.7963H42.9923V11.3034Z",
    fill: "#FFE4CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.0132 9.78906H41.4863V11.3247H43.0132V9.78906Z",
    fill: "#66667C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.9923 9.81036H41.5078V11.282H42.9923V9.81036Z",
    fill: "#66667C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.0132 8.2962H41.4863V9.8318H43.0132V8.2962Z",
    fill: "#FFE4CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.9923 8.33881H41.5078V9.83174H42.9923V8.33881Z",
    fill: "#FFE4CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.0132 6.82465H41.4863V8.36024H43.0132V6.82465Z",
    fill: "#FFE4CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.9923 6.8457H41.5078V8.33864H42.9923V6.8457Z",
    fill: "#FFE4CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.0132 5.3316H41.4863V6.8672H43.0132V5.3316Z",
    fill: "#FBAE64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.9923 5.35266H41.5078V6.8456H42.9923V5.35266Z",
    fill: "#FBAE64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.0132 3.86005H41.4863V5.39563H43.0132V3.86005Z",
    fill: "#FBAE64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.9923 3.88135H41.5078V5.35295H42.9923V3.88135Z",
    fill: "#FBAE64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.0132 2.36713H41.4863V3.90271H43.0132V2.36713Z",
    fill: "#FBAE64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.9923 2.38812H41.5078V3.88106H42.9923V2.38812Z",
    fill: "#FBAE64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.5504 40.9274H40.0234V42.4629H41.5504V40.9274Z",
    fill: "#131E33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.5289 40.9489H40.0444V42.4418H41.5289V40.9489Z",
    fill: "#131E33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.5504 39.4558H40.0234V40.9914H41.5504V39.4558Z",
    fill: "#131E33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.5289 39.4776H40.0444V40.9705H41.5289V39.4776Z",
    fill: "#131E33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.5504 37.9628H40.0234V39.4984H41.5504V37.9628Z",
    fill: "#131E33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.5289 37.984H40.0444V39.4556H41.5289V37.984Z",
    fill: "#131E33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.5504 36.491H40.0234V38.0266H41.5504V36.491Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.5289 36.5125H40.0444V38.0054H41.5289V36.5125Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.5504 34.9984H40.0234V36.5339H41.5504V34.9984Z",
    fill: "#303C54"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.5289 35.0194H40.0444V36.5123H41.5289V35.0194Z",
    fill: "#303C54"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.5504 33.5263H40.0234V35.0619H41.5504V33.5263Z",
    fill: "#303C54"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.5289 33.5479H40.0444V35.0408H41.5289V33.5479Z",
    fill: "#303C54"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.5504 32.0338H40.0234V33.5693H41.5504V32.0338Z",
    fill: "#303C54"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.5289 32.0548H40.0444V33.5264H41.5289V32.0548Z",
    fill: "#303C54"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.5504 30.5624H40.0234V32.098H41.5504V30.5624Z",
    fill: "#303C54"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.5289 30.5835H40.0444V32.0764H41.5289V30.5835Z",
    fill: "#303C54"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.5504 29.0693H40.0234V30.6049H41.5504V29.0693Z",
    fill: "#303C54"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.5289 29.0904H40.0444V30.5833H41.5289V29.0904Z",
    fill: "#303C54"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.5504 27.5763H40.0234V29.1119H41.5504V27.5763Z",
    fill: "#303C54"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.5289 27.6189H40.0444V29.1118H41.5289V27.6189Z",
    fill: "#303C54"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.5504 26.1047H40.0234V27.6403H41.5504V26.1047Z",
    fill: "#303C54"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.5289 26.1258H40.0444V27.5974H41.5289V26.1258Z",
    fill: "#303C54"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.5504 24.6116H40.0234V26.1472H41.5504V24.6116Z",
    fill: "#303C54"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.5289 24.6545H40.0444V26.1474H41.5289V24.6545Z",
    fill: "#303C54"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.5504 23.1404H40.0234V24.676H41.5504V23.1404Z",
    fill: "#303C54"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.5289 23.1614H40.0444V24.6544H41.5289V23.1614Z",
    fill: "#303C54"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.5504 21.6473H40.0234V23.1829H41.5504V21.6473Z",
    fill: "#222A3B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.5289 21.6688H40.0444V23.1618H41.5289V21.6688Z",
    fill: "#222A3B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.5504 20.176H40.0234V21.7116H41.5504V20.176Z",
    fill: "#F57E77"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.5289 20.1968H40.0444V21.6684H41.5289V20.1968Z",
    fill: "#F57E77"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.5504 18.6827H40.0234V20.2183H41.5504V18.6827Z",
    fill: "#FFE4CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.5289 18.7042H40.0444V20.1972H41.5289V18.7042Z",
    fill: "#FFE4CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.5504 17.2111H40.0234V18.7467H41.5504V17.2111Z",
    fill: "#FFE4CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.5289 17.2324H40.0444V18.7254H41.5289V17.2324Z",
    fill: "#FFE4CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.5504 15.7183H40.0234V17.2538H41.5504V15.7183Z",
    fill: "#F57E77"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.5289 15.7398H40.0444V17.2114H41.5289V15.7398Z",
    fill: "#F57E77"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.5504 14.2463H40.0234V15.7819H41.5504V14.2463Z",
    fill: "#FFE4CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.5289 14.2678H40.0444V15.7608H41.5289V14.2678Z",
    fill: "#FFE4CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.5504 12.7537H40.0234V14.2893H41.5504V12.7537Z",
    fill: "#FFE4CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.5289 12.7747H40.0444V14.2677H41.5289V12.7747Z",
    fill: "#FFE4CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.5504 11.2816H40.0234V12.8172H41.5504V11.2816Z",
    fill: "#FFE4CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.5289 11.3034H40.0444V12.7963H41.5289V11.3034Z",
    fill: "#FFE4CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.5504 9.78906H40.0234V11.3247H41.5504V9.78906Z",
    fill: "#FFE4CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.5289 9.81036H40.0444V11.282H41.5289V9.81036Z",
    fill: "#FFE4CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.5504 8.2962H40.0234V9.8318H41.5504V8.2962Z",
    fill: "#FFE4CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.5289 8.33881H40.0444V9.83174H41.5289V8.33881Z",
    fill: "#FFE4CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.5504 6.82465H40.0234V8.36024H41.5504V6.82465Z",
    fill: "#FFE4CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.5289 6.8457H40.0444V8.33864H41.5289V6.8457Z",
    fill: "#FFE4CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.5504 5.3316H40.0234V6.8672H41.5504V5.3316Z",
    fill: "#FBAE64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.5289 5.35266H40.0444V6.8456H41.5289V5.35266Z",
    fill: "#FBAE64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.5504 3.86005H40.0234V5.39563H41.5504V3.86005Z",
    fill: "#F8DB94"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.5289 3.88135H40.0444V5.35295H41.5289V3.88135Z",
    fill: "#F8DB94"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.5504 2.36713H40.0234V3.90271H41.5504V2.36713Z",
    fill: "#F8DB94"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.5289 2.38812H40.0444V3.88106H41.5289V2.38812Z",
    fill: "#F8DB94"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.066 67.6295H38.5391V69.1651H40.066V67.6295Z",
    fill: "#877A86"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.0233 67.6511H38.5601V69.144H40.0233V67.6511Z",
    fill: "#877A86"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.066 66.158H38.5391V67.6936H40.066V66.158Z",
    fill: "#343A52"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.0233 66.1793H38.5601V67.6509H40.0233V66.1793Z",
    fill: "#343A52"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.066 64.6652H38.5391V66.2008H40.066V64.6652Z",
    fill: "#343A52"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.0233 64.6867H38.5601V66.1796H40.0233V64.6867Z",
    fill: "#343A52"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.066 63.1936H38.5391V64.7292H40.066V63.1936Z",
    fill: "#343A52"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.0233 63.2147H38.5601V64.7076H40.0233V63.2147Z",
    fill: "#343A52"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.066 61.7005H38.5391V63.2361H40.066V61.7005Z",
    fill: "#E7E0D4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.0233 61.722H38.5601V63.215H40.0233V61.722Z",
    fill: "#E7E0D4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.066 60.229H38.5391V61.7646H40.066V60.229Z",
    fill: "#E7E0D4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.0233 60.2503H38.5601V61.7219H40.0233V60.2503Z",
    fill: "#E7E0D4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.066 58.7359H38.5391V60.2715H40.066V58.7359Z",
    fill: "#F57E77"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.0233 58.7572H38.5601V60.2501H40.0233V58.7572Z",
    fill: "#F57E77"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.066 57.2435H38.5391V58.7791H40.066V57.2435Z",
    fill: "#F57E77"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.0233 57.2641H38.5601V58.757H40.0233V57.2641Z",
    fill: "#F57E77"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.066 55.7715H38.5391V57.3071H40.066V55.7715Z",
    fill: "#F57E77"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.0233 55.7926H38.5601V57.2855H40.0233V55.7926Z",
    fill: "#F57E77"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.066 54.2784H38.5391V55.814H40.066V54.2784Z",
    fill: "#F57E77"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.0233 54.2995H38.5601V55.7711H40.0233V54.2995Z",
    fill: "#F57E77"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.066 52.8069H38.5391V54.3425H40.066V52.8069Z",
    fill: "#F57E77"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.0233 52.8282H38.5601V54.3211H40.0233V52.8282Z",
    fill: "#F57E77"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.066 51.3138H38.5391V52.8494H40.066V51.3138Z",
    fill: "#F57E77"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.0233 51.3351H38.5601V52.8281H40.0233V51.3351Z",
    fill: "#F57E77"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.066 49.8425H38.5391V51.3781H40.066V49.8425Z",
    fill: "#131E33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.0657 49.8636H38.5601V60.2302H40.0657V49.8636Z",
    fill: "#131E33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.066 48.3494H38.5391V49.885H40.066V48.3494Z",
    fill: "#131E33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.0233 48.3705H38.5601V49.8634H40.0233V48.3705Z",
    fill: "#131E33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.066 46.8779H38.5391V48.4135H40.066V46.8779Z",
    fill: "#131E33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.0233 46.8992H38.5601V48.3921H40.0233V46.8992Z",
    fill: "#131E33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.066 45.3848H38.5391V46.9204H40.066V45.3848Z",
    fill: "#131E33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.0233 45.4061H38.5601V46.8991H40.0233V45.4061Z",
    fill: "#131E33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.066 43.9135H38.5391V45.4491H40.066V43.9135Z",
    fill: "#131E33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.0233 43.9346H38.5601V45.4062H40.0233V43.9346Z",
    fill: "#131E33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.066 42.4205H38.5391V43.9561H40.066V42.4205Z",
    fill: "#131E33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.0233 42.442H38.5601V43.935H40.0233V42.442Z",
    fill: "#131E33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.066 40.9274H38.5391V42.4629H40.066V40.9274Z",
    fill: "#243454"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.0233 40.9489H38.5601V42.4418H40.0233V40.9489Z",
    fill: "#243454"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.066 39.4558H38.5391V40.9914H40.066V39.4558Z",
    fill: "#243454"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.0233 39.4776H38.5601V40.9705H40.0233V39.4776Z",
    fill: "#243454"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.066 37.9628H38.5391V39.4984H40.066V37.9628Z",
    fill: "#243454"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.0233 37.984H38.5601V39.4556H40.0233V37.984Z",
    fill: "#243454"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.066 36.491H38.5391V38.0266H40.066V36.491Z",
    fill: "#0A0F1A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.0233 36.5125H38.5601V38.0054H40.0233V36.5125Z",
    fill: "#0A0F1A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.066 34.9984H38.5391V36.5339H40.066V34.9984Z",
    fill: "#303C54"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.0233 35.0194H38.5601V36.5123H40.0233V35.0194Z",
    fill: "#303C54"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.066 33.5263H38.5391V35.0619H40.066V33.5263Z",
    fill: "#303C54"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.0233 33.5479H38.5601V35.0408H40.0233V33.5479Z",
    fill: "#303C54"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.066 32.0338H38.5391V33.5693H40.066V32.0338Z",
    fill: "#303C54"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.0233 32.0548H38.5601V33.5264H40.0233V32.0548Z",
    fill: "#303C54"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.066 30.5624H38.5391V32.098H40.066V30.5624Z",
    fill: "#303C54"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.0233 30.5835H38.5601V32.0764H40.0233V30.5835Z",
    fill: "#303C54"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.066 29.0693H38.5391V30.6049H40.066V29.0693Z",
    fill: "#303C54"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.0233 29.0904H38.5601V30.5833H40.0233V29.0904Z",
    fill: "#303C54"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.066 27.5763H38.5391V29.1119H40.066V27.5763Z",
    fill: "#303C54"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.0233 27.6189H38.5601V29.1118H40.0233V27.6189Z",
    fill: "#303C54"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.066 26.1047H38.5391V27.6403H40.066V26.1047Z",
    fill: "#303C54"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.0233 26.1258H38.5601V27.5974H40.0233V26.1258Z",
    fill: "#303C54"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.066 24.6116H38.5391V26.1472H40.066V24.6116Z",
    fill: "#303C54"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.0233 24.6545H38.5601V26.1474H40.0233V24.6545Z",
    fill: "#303C54"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.066 23.1404H38.5391V24.676H40.066V23.1404Z",
    fill: "#303C54"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.0233 23.1614H38.5601V24.6544H40.0233V23.1614Z",
    fill: "#303C54"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.066 21.6473H38.5391V23.1829H40.066V21.6473Z",
    fill: "#303C54"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.0233 21.6688H38.5601V23.1618H40.0233V21.6688Z",
    fill: "#303C54"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.066 20.176H38.5391V21.7116H40.066V20.176Z",
    fill: "#222A3B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.0233 20.1968H38.5601V21.6684H40.0233V20.1968Z",
    fill: "#222A3B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.066 18.6827H38.5391V20.2183H40.066V18.6827Z",
    fill: "#FFE4CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.0233 18.7042H38.5601V20.1972H40.0233V18.7042Z",
    fill: "#FFE4CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.066 17.2111H38.5391V18.7467H40.066V17.2111Z",
    fill: "#FFE4CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.0233 17.2324H38.5601V18.7254H40.0233V17.2324Z",
    fill: "#FFE4CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.066 15.7183H38.5391V17.2538H40.066V15.7183Z",
    fill: "#F57E77"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.0233 15.7398H38.5601V17.2114H40.0233V15.7398Z",
    fill: "#F57E77"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.066 14.2463H38.5391V15.7819H40.066V14.2463Z",
    fill: "#FFE4CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.0233 14.2678H38.5601V15.7608H40.0233V14.2678Z",
    fill: "#FFE4CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.066 12.7537H38.5391V14.2893H40.066V12.7537Z",
    fill: "#FFE4CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.0233 12.7747H38.5601V14.2677H40.0233V12.7747Z",
    fill: "#FFE4CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.066 11.2816H38.5391V12.8172H40.066V11.2816Z",
    fill: "#FFE4CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.0233 11.3034H38.5601V12.7963H40.0233V11.3034Z",
    fill: "#FFE4CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.066 9.78906H38.5391V11.3247H40.066V9.78906Z",
    fill: "#66667C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.0233 9.81036H38.5601V11.282H40.0233V9.81036Z",
    fill: "#66667C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.066 8.2962H38.5391V9.8318H40.066V8.2962Z",
    fill: "#FFE4CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.0233 8.33881H38.5601V9.83174H40.0233V8.33881Z",
    fill: "#FFE4CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.066 6.82465H38.5391V8.36024H40.066V6.82465Z",
    fill: "#FBAE64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.0233 6.8457H38.5601V8.33864H40.0233V6.8457Z",
    fill: "#FBAE64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.066 5.3316H38.5391V6.8672H40.066V5.3316Z",
    fill: "#FBAE64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.0233 5.35266H38.5601V6.8456H40.0233V5.35266Z",
    fill: "#FBAE64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.066 3.86005H38.5391V5.39563H40.066V3.86005Z",
    fill: "#F8DB94"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.0233 3.88135H38.5601V5.35295H40.0233V3.88135Z",
    fill: "#F8DB94"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.066 2.36713H38.5391V3.90271H40.066V2.36713Z",
    fill: "#F8DB94"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.0233 2.38812H38.5601V3.88106H40.0233V2.38812Z",
    fill: "#F8DB94"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.5811 67.6295H37.0542V69.1651H38.5811V67.6295Z",
    fill: "#877A86"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.5812 67.6511H37.0967V69.144H38.5812V67.6511Z",
    fill: "#877A86"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.5811 66.158H37.0542V67.6936H38.5811V66.158Z",
    fill: "#343A52"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.5812 66.1793H37.0967V67.6509H38.5812V66.1793Z",
    fill: "#343A52"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.5811 64.6652H37.0542V66.2008H38.5811V64.6652Z",
    fill: "#416D6E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.5812 64.6867H37.0967V66.1796H38.5812V64.6867Z",
    fill: "#416D6E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.5811 63.1936H37.0542V64.7292H38.5811V63.1936Z",
    fill: "#416D6E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.5812 63.2147H37.0967V64.7076H38.5812V63.2147Z",
    fill: "#416D6E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.5811 61.7005H37.0542V63.2361H38.5811V61.7005Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.5812 61.722H37.0967V63.215H38.5812V61.722Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.5811 60.229H37.0542V61.7646H38.5811V60.229Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.5812 60.2503H37.0967V61.7219H38.5812V60.2503Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.5811 58.7359H37.0542V60.2715H38.5811V58.7359Z",
    fill: "#FFE4CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.5812 58.7572H37.0967V60.2501H38.5812V58.7572Z",
    fill: "#FFE4CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.5811 57.2435H37.0542V58.7791H38.5811V57.2435Z",
    fill: "#FFE4CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.5812 57.2641H37.0967V58.757H38.5812V57.2641Z",
    fill: "#FFE4CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.5811 55.7715H37.0542V57.3071H38.5811V55.7715Z",
    fill: "#FFE4CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.5812 55.7926H37.0967V57.2855H38.5812V55.7926Z",
    fill: "#FFE4CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.5811 54.2784H37.0542V55.814H38.5811V54.2784Z",
    fill: "#FFE4CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.5812 54.2995H37.0967V55.7711H38.5812V54.2995Z",
    fill: "#FFE4CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.5811 52.8069H37.0542V54.3425H38.5811V52.8069Z",
    fill: "#FFE4CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.5812 52.8282H37.0967V54.3211H38.5812V52.8282Z",
    fill: "#FFE4CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.5811 51.3138H37.0542V52.8494H38.5811V51.3138Z",
    fill: "#FFE4CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.5812 51.3351H37.0967V52.8281H38.5812V51.3351Z",
    fill: "#FFE4CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.5811 49.8425H37.0542V51.3781H38.5811V49.8425Z",
    fill: "#243454"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.5812 49.8636H37.0967V60.2302H38.5812V49.8636Z",
    fill: "#243454"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.5811 48.3494H37.0542V49.885H38.5811V48.3494Z",
    fill: "#243454"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.5812 48.3705H37.0967V49.8634H38.5812V48.3705Z",
    fill: "#243454"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.5811 46.8779H37.0542V48.4135H38.5811V46.8779Z",
    fill: "#243454"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.5812 46.8992H37.0967V48.3921H38.5812V46.8992Z",
    fill: "#243454"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.5811 45.3848H37.0542V46.9204H38.5811V45.3848Z",
    fill: "#243454"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.5812 45.4061H37.0967V46.8991H38.5812V45.4061Z",
    fill: "#243454"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.5811 43.9135H37.0542V45.4491H38.5811V43.9135Z",
    fill: "#243454"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.5812 43.9346H37.0967V45.4062H38.5812V43.9346Z",
    fill: "#243454"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.5811 42.4205H37.0542V43.9561H38.5811V42.4205Z",
    fill: "#243454"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.5812 42.442H37.0967V43.935H38.5812V42.442Z",
    fill: "#243454"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.5811 40.9274H37.0542V42.4629H38.5811V40.9274Z",
    fill: "#243454"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.5812 40.9489H37.0967V42.4418H38.5812V40.9489Z",
    fill: "#243454"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.5811 39.4558H37.0542V40.9914H38.5811V39.4558Z",
    fill: "#243454"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.5812 39.4776H37.0967V40.9705H38.5812V39.4776Z",
    fill: "#243454"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.5811 37.9628H37.0542V39.4984H38.5811V37.9628Z",
    fill: "#243454"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.5812 37.984H37.0967V39.4556H38.5812V37.984Z",
    fill: "#243454"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.5811 36.491H37.0542V38.0266H38.5811V36.491Z",
    fill: "#0A0F1A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.5812 36.5125H37.0967V38.0054H38.5812V36.5125Z",
    fill: "#0A0F1A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.5811 34.9984H37.0542V36.5339H38.5811V34.9984Z",
    fill: "#303C54"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.5812 35.0194H37.0967V36.5123H38.5812V35.0194Z",
    fill: "#303C54"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.5811 33.5263H37.0542V35.0619H38.5811V33.5263Z",
    fill: "#BCBCBC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.5812 33.5479H37.0967V35.0408H38.5812V33.5479Z",
    fill: "#BCBCBC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.5811 32.0338H37.0542V33.5693H38.5811V32.0338Z",
    fill: "#BCBCBC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.5812 32.0548H37.0967V33.5264H38.5812V32.0548Z",
    fill: "#BCBCBC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.5811 30.5624H37.0542V32.098H38.5811V30.5624Z",
    fill: "#BCBCBC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.5812 30.5835H37.0967V32.0764H38.5812V30.5835Z",
    fill: "#BCBCBC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.5811 29.0693H37.0542V30.6049H38.5811V29.0693Z",
    fill: "#BCBCBC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.5812 29.0904H37.0967V30.5833H38.5812V29.0904Z",
    fill: "#BCBCBC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.5811 27.5763H37.0542V29.1119H38.5811V27.5763Z",
    fill: "#BCBCBC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.5812 27.6189H37.0967V29.1118H38.5812V27.6189Z",
    fill: "#BCBCBC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.5811 26.1047H37.0542V27.6403H38.5811V26.1047Z",
    fill: "#BCBCBC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.5812 26.1258H37.0967V27.5974H38.5812V26.1258Z",
    fill: "#BCBCBC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.5811 24.6116H37.0542V26.1472H38.5811V24.6116Z",
    fill: "#BCBCBC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.5812 24.6545H37.0967V26.1474H38.5812V24.6545Z",
    fill: "#BCBCBC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.5811 23.1404H37.0542V24.676H38.5811V23.1404Z",
    fill: "#BCBCBC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.5812 23.1614H37.0967V24.6544H38.5812V23.1614Z",
    fill: "#BCBCBC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.5811 21.6473H37.0542V23.1829H38.5811V21.6473Z",
    fill: "#BCBCBC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.5812 21.6688H37.0967V23.1618H38.5812V21.6688Z",
    fill: "#BCBCBC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.5811 20.176H37.0542V21.7116H38.5811V20.176Z",
    fill: "#686868"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.5812 20.1968H37.0967V21.6684H38.5812V20.1968Z",
    fill: "#686868"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.5811 18.6827H37.0542V20.2183H38.5811V18.6827Z",
    fill: "#686868"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.5812 18.7042H37.0967V20.1972H38.5812V18.7042Z",
    fill: "#686868"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.5811 17.2111H37.0542V18.7467H38.5811V17.2111Z",
    fill: "#686868"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.5812 17.2324H37.0967V18.7254H38.5812V17.2324Z",
    fill: "#686868"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.5811 14.2463H37.0542V15.7819H38.5811V14.2463Z",
    fill: "#FFE4CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.5812 14.2678H37.0967V15.7608H38.5812V14.2678Z",
    fill: "#FFE4CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.5811 12.7537H37.0542V14.2893H38.5811V12.7537Z",
    fill: "#FFE4CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.5812 12.7747H37.0967V14.2677H38.5812V12.7747Z",
    fill: "#FFE4CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.5811 11.2816H37.0542V12.8172H38.5811V11.2816Z",
    fill: "#FFE4CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.5812 11.3034H37.0967V12.7963H38.5812V11.3034Z",
    fill: "#FFE4CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.5811 9.78906H37.0542V11.3247H38.5811V9.78906Z",
    fill: "#FFE4CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.5812 9.81036H37.0967V11.282H38.5812V9.81036Z",
    fill: "#FFE4CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.5811 8.2962H37.0542V9.8318H38.5811V8.2962Z",
    fill: "#FFE4CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.5812 8.33881H37.0967V9.83174H38.5812V8.33881Z",
    fill: "#FFE4CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.5811 6.82465H37.0542V8.36024H38.5811V6.82465Z",
    fill: "#FBAE64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.5812 6.8457H37.0967V8.33864H38.5812V6.8457Z",
    fill: "#FBAE64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.5811 5.3316H37.0542V6.8672H38.5811V5.3316Z",
    fill: "#F8DB94"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.5812 5.35266H37.0967V6.8456H38.5812V5.35266Z",
    fill: "#F8DB94"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.5811 3.86005H37.0542V5.39563H38.5811V3.86005Z",
    fill: "#F8DB94"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.5812 3.88135H37.0967V5.35295H38.5812V3.88135Z",
    fill: "#F8DB94"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.1177 67.6295H35.5908V69.1651H37.1177V67.6295Z",
    fill: "#877A86"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.0968 67.6511H35.6123V69.144H37.0968V67.6511Z",
    fill: "#877A86"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.1177 66.158H35.5908V67.6936H37.1177V66.158Z",
    fill: "#343A52"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.0968 66.1793H35.6123V67.6509H37.0968V66.1793Z",
    fill: "#343A52"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.1177 64.6652H35.5908V66.2008H37.1177V64.6652Z",
    fill: "#416D6E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.0968 64.6867H35.6123V66.1796H37.0968V64.6867Z",
    fill: "#416D6E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.1177 63.1936H35.5908V64.7292H37.1177V63.1936Z",
    fill: "#416D6E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.0968 63.2147H35.6123V64.7076H37.0968V63.2147Z",
    fill: "#416D6E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.1177 61.7005H35.5908V63.2361H37.1177V61.7005Z",
    fill: "#343A52"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.0968 61.722H35.6123V63.215H37.0968V61.722Z",
    fill: "#343A52"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.1177 49.8425H35.5908V51.3781H37.1177V49.8425Z",
    fill: "#243454"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.0968 49.8636H35.6123V60.2302H37.0968V49.8636Z",
    fill: "#243454"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.1177 48.3494H35.5908V49.885H37.1177V48.3494Z",
    fill: "#243454"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.0968 48.3705H35.6123V49.8634H37.0968V48.3705Z",
    fill: "#243454"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.1177 46.8779H35.5908V48.4135H37.1177V46.8779Z",
    fill: "#243454"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.0968 46.8992H35.6123V48.3921H37.0968V46.8992Z",
    fill: "#243454"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.1177 45.3848H35.5908V46.9204H37.1177V45.3848Z",
    fill: "#243454"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.0968 45.4061H35.6123V46.8991H37.0968V45.4061Z",
    fill: "#243454"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.1177 43.9135H35.5908V45.4491H37.1177V43.9135Z",
    fill: "#243454"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.0968 43.9346H35.6123V45.4062H37.0968V43.9346Z",
    fill: "#243454"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.1177 42.4205H35.5908V43.9561H37.1177V42.4205Z",
    fill: "#243454"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.0968 42.442H35.6123V43.935H37.0968V42.442Z",
    fill: "#243454"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.1177 40.9274H35.5908V42.4629H37.1177V40.9274Z",
    fill: "#243454"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.0968 40.9489H35.6123V42.4418H37.0968V40.9489Z",
    fill: "#243454"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.1177 39.4558H35.5908V40.9914H37.1177V39.4558Z",
    fill: "#243454"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.0968 39.4776H35.6123V40.9705H37.0968V39.4776Z",
    fill: "#243454"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.1177 37.9628H35.5908V39.4984H37.1177V37.9628Z",
    fill: "#131E33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.0968 37.984H35.6123V39.4556H37.0968V37.984Z",
    fill: "#131E33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.1177 36.491H35.5908V38.0266H37.1177V36.491Z",
    fill: "#0A0F1A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.0968 36.5125H35.6123V38.0054H37.0968V36.5125Z",
    fill: "#0A0F1A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.1177 34.9984H35.5908V36.5339H37.1177V34.9984Z",
    fill: "#686868"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.0968 35.0194H35.6123V36.5123H37.0968V35.0194Z",
    fill: "#686868"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.1177 33.5263H35.5908V35.0619H37.1177V33.5263Z",
    fill: "#686868"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.0968 33.5479H35.6123V35.0408H37.0968V33.5479Z",
    fill: "#686868"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.1177 32.0338H35.5908V33.5693H37.1177V32.0338Z",
    fill: "#686868"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.0968 32.0548H35.6123V33.5264H37.0968V32.0548Z",
    fill: "#686868"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.1177 30.5624H35.5908V32.098H37.1177V30.5624Z",
    fill: "#686868"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.0968 30.5835H35.6123V32.0764H37.0968V30.5835Z",
    fill: "#686868"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.1177 29.0693H35.5908V30.6049H37.1177V29.0693Z",
    fill: "#686868"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.0968 29.0904H35.6123V30.5833H37.0968V29.0904Z",
    fill: "#686868"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.1177 27.5763H35.5908V29.1119H37.1177V27.5763Z",
    fill: "#686868"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.0968 27.6189H35.6123V29.1118H37.0968V27.6189Z",
    fill: "#686868"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.1177 26.1047H35.5908V27.6403H37.1177V26.1047Z",
    fill: "#686868"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.0968 26.1258H35.6123V27.5974H37.0968V26.1258Z",
    fill: "#686868"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.1177 24.6116H35.5908V26.1472H37.1177V24.6116Z",
    fill: "#686868"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.0968 24.6545H35.6123V26.1474H37.0968V24.6545Z",
    fill: "#686868"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.1177 23.1404H35.5908V24.676H37.1177V23.1404Z",
    fill: "#686868"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.0968 23.1614H35.6123V24.6544H37.0968V23.1614Z",
    fill: "#686868"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.1177 21.6473H35.5908V23.1829H37.1177V21.6473Z",
    fill: "#BCBCBC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.0968 21.6688H35.6123V23.1618H37.0968V21.6688Z",
    fill: "#BCBCBC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.1177 20.176H35.5908V21.7116H37.1177V20.176Z",
    fill: "#BCBCBC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.0968 20.1968H35.6123V21.6684H37.0968V20.1968Z",
    fill: "#BCBCBC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.1177 18.6827H35.5908V20.2183H37.1177V18.6827Z",
    fill: "#686868"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.0968 18.7042H35.6123V20.1972H37.0968V18.7042Z",
    fill: "#686868"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.1177 12.7537H35.5908V14.2893H37.1177V12.7537Z",
    fill: "#F57E77"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.0968 12.7747H35.6123V14.2677H37.0968V12.7747Z",
    fill: "#F57E77"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.1177 11.2816H35.5908V12.8172H37.1177V11.2816Z",
    fill: "#FFE4CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.0968 11.3034H35.6123V12.7963H37.0968V11.3034Z",
    fill: "#FFE4CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.1177 9.78906H35.5908V11.3247H37.1177V9.78906Z",
    fill: "#FBAE64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.0968 9.81036H35.6123V11.282H37.0968V9.81036Z",
    fill: "#FBAE64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.1177 8.2962H35.5908V9.8318H37.1177V8.2962Z",
    fill: "#FBAE64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.0968 8.33881H35.6123V9.83174H37.0968V8.33881Z",
    fill: "#FBAE64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.1177 6.82465H35.5908V8.36024H37.1177V6.82465Z",
    fill: "#F8DB94"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.0968 6.8457H35.6123V8.33864H37.0968V6.8457Z",
    fill: "#F8DB94"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.1177 5.3316H35.5908V6.8672H37.1177V5.3316Z",
    fill: "#F8DB94"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.0968 5.35266H35.6123V6.8456H37.0968V5.35266Z",
    fill: "#F8DB94"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.6334 67.6295H34.1064V69.1651H35.6334V67.6295Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.6124 67.6511H34.1279V69.144H35.6124V67.6511Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.6334 66.158H34.1064V67.6936H35.6334V66.158Z",
    fill: "#E7E0D4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.6124 66.1793H34.1279V67.6509H35.6124V66.1793Z",
    fill: "#E7E0D4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.6334 64.6652H34.1064V66.2008H35.6334V64.6652Z",
    fill: "#416D6E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.6124 64.6867H34.1279V66.1796H35.6124V64.6867Z",
    fill: "#416D6E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.6334 61.7005H34.1064V63.2361H35.6334V61.7005Z",
    fill: "#416D6E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.6124 61.722H34.1279V63.215H35.6124V61.722Z",
    fill: "#416D6E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.6334 23.1404H34.1064V24.676H35.6334V23.1404Z",
    fill: "#686868"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.6124 23.1614H34.1279V24.6544H35.6124V23.1614Z",
    fill: "#686868"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.6334 21.6473H34.1064V23.1829H35.6334V21.6473Z",
    fill: "#BCBCBC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.6124 21.6688H34.1279V23.1618H35.6124V21.6688Z",
    fill: "#BCBCBC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.6334 20.176H34.1064V21.7116H35.6334V20.176Z",
    fill: "#BCBCBC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.6124 20.1968H34.1279V21.6684H35.6124V20.1968Z",
    fill: "#BCBCBC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.6334 18.6827H34.1064V20.2183H35.6334V18.6827Z",
    fill: "#BCBCBC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.6124 18.7042H34.1279V20.1972H35.6124V18.7042Z",
    fill: "#BCBCBC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.6334 11.2816H34.1064V12.8172H35.6334V11.2816Z",
    fill: "#F57E77"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.6124 11.3034H34.1279V12.7963H35.6124V11.3034Z",
    fill: "#F57E77"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.6334 9.78906H34.1064V11.3247H35.6334V9.78906Z",
    fill: "#FFE4CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.6124 9.81036H34.1279V11.282H35.6124V9.81036Z",
    fill: "#FFE4CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.6334 8.2962H34.1064V9.8318H35.6334V8.2962Z",
    fill: "#F8DB94"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.6124 8.33881H34.1279V9.83174H35.6124V8.33881Z",
    fill: "#F8DB94"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.17 67.6295H32.6431V69.1651H34.17V67.6295Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.1278 67.6511H32.6646V69.144H34.1278V67.6511Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.17 66.158H32.6431V67.6936H34.17V66.158Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.1278 66.1793H32.6646V67.6509H34.1278V66.1793Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.17 64.6652H32.6431V66.2008H34.17V64.6652Z",
    fill: "#E7E0D4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.1278 64.6867H32.6646V66.1796H34.1278V64.6867Z",
    fill: "#E7E0D4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.17 42.4205H32.6431V43.9561H34.17V42.4205Z",
    fill: "#FFE4CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.1278 42.442H32.6646V43.935H34.1278V42.442Z",
    fill: "#FFE4CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.17 40.9274H32.6431V42.4629H34.17V40.9274Z",
    fill: "#F57E77"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.1278 40.9489H32.6646V42.4418H34.1278V40.9489Z",
    fill: "#F57E77"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.17 26.1047H32.6431V27.6403H34.17V26.1047Z",
    fill: "#686868"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.1278 26.1258H32.6646V27.5974H34.1278V26.1258Z",
    fill: "#686868"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.17 24.6116H32.6431V26.1472H34.17V24.6116Z",
    fill: "#686868"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.1278 24.6545H32.6646V26.1474H34.1278V24.6545Z",
    fill: "#686868"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.17 23.1404H32.6431V24.676H34.17V23.1404Z",
    fill: "#BCBCBC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.1278 23.1614H32.6646V24.6544H34.1278V23.1614Z",
    fill: "#BCBCBC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.17 21.6473H32.6431V23.1829H34.17V21.6473Z",
    fill: "#BCBCBC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.1278 21.6688H32.6646V23.1618H34.1278V21.6688Z",
    fill: "#BCBCBC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.17 20.176H32.6431V21.7116H34.17V20.176Z",
    fill: "#BCBCBC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.1278 20.1968H32.6646V21.6684H34.1278V20.1968Z",
    fill: "#BCBCBC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.6856 67.6295H31.1587V69.1651H32.6856V67.6295Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.6642 67.6511H31.1797V69.144H32.6642V67.6511Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.6856 66.158H31.1587V67.6936H32.6856V66.158Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.6642 66.1793H31.1797V67.6509H32.6642V66.1793Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.6856 64.6652H31.1587V66.2008H32.6856V64.6652Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.6642 64.6867H31.1797V66.1796H32.6642V64.6867Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.6856 43.9135H31.1587V45.4491H32.6856V43.9135Z",
    fill: "#FFE4CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.6642 43.9346H31.1797V45.4062H32.6642V43.9346Z",
    fill: "#FFE4CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.6856 42.4205H31.1587V43.9561H32.6856V42.4205Z",
    fill: "#FFE4CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.6642 42.442H31.1797V43.935H32.6642V42.442Z",
    fill: "#FFE4CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.6856 40.9274H31.1587V42.4629H32.6856V40.9274Z",
    fill: "#FFE4CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.6642 40.9489H31.1797V42.4418H32.6642V40.9489Z",
    fill: "#FFE4CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.6856 39.4558H31.1587V40.9914H32.6856V39.4558Z",
    fill: "#F57E77"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.6642 39.4776H31.1797V40.9705H32.6642V39.4776Z",
    fill: "#F57E77"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.6856 37.9628H31.1587V39.4984H32.6856V37.9628Z",
    fill: "#F57E77"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.6642 37.984H31.1797V39.4556H32.6642V37.984Z",
    fill: "#F57E77"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.6856 36.491H31.1587V38.0266H32.6856V36.491Z",
    fill: "#F57E77"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.6642 36.5125H31.1797V38.0054H32.6642V36.5125Z",
    fill: "#F57E77"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.6856 34.9984H31.1587V36.5339H32.6856V34.9984Z",
    fill: "#F57E77"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.6642 35.0194H31.1797V36.5123H32.6642V35.0194Z",
    fill: "#F57E77"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.6856 33.5263H31.1587V35.0619H32.6856V33.5263Z",
    fill: "#F57E77"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.6642 33.5479H31.1797V35.0408H32.6642V33.5479Z",
    fill: "#F57E77"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.6856 32.0338H31.1587V33.5693H32.6856V32.0338Z",
    fill: "#F57E77"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.6642 32.0548H31.1797V33.5264H32.6642V32.0548Z",
    fill: "#F57E77"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.6856 30.5624H31.1587V32.098H32.6856V30.5624Z",
    fill: "#F57E77"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.6642 30.5835H31.1797V32.0764H32.6642V30.5835Z",
    fill: "#F57E77"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.6856 29.0693H31.1587V30.6049H32.6856V29.0693Z",
    fill: "#F57E77"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.6642 29.0904H31.1797V30.5833H32.6642V29.0904Z",
    fill: "#F57E77"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.6856 27.5763H31.1587V29.1119H32.6856V27.5763Z",
    fill: "#F57E77"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.6642 27.6189H31.1797V29.1118H32.6642V27.6189Z",
    fill: "#F57E77"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.6856 26.1047H31.1587V27.6403H32.6856V26.1047Z",
    fill: "#BCBCBC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.6642 26.1258H31.1797V27.5974H32.6642V26.1258Z",
    fill: "#BCBCBC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.6856 24.6116H31.1587V26.1472H32.6856V24.6116Z",
    fill: "#BCBCBC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.6642 24.6545H31.1797V26.1474H32.6642V24.6545Z",
    fill: "#BCBCBC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.6856 23.1404H31.1587V24.676H32.6856V23.1404Z",
    fill: "#BCBCBC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.6642 23.1614H31.1797V24.6544H32.6642V23.1614Z",
    fill: "#BCBCBC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.6856 21.6473H31.1587V23.1829H32.6856V21.6473Z",
    fill: "#BCBCBC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.6642 21.6688H31.1797V23.1618H32.6642V21.6688Z",
    fill: "#BCBCBC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.6856 20.176H31.1587V21.7116H32.6856V20.176Z",
    fill: "#BCBCBC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.6642 20.1968H31.1797V21.6684H32.6642V20.1968Z",
    fill: "#BCBCBC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.2222 67.6295H29.6953V69.1651H31.2222V67.6295Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.2013 67.6511H29.7168V69.144H31.2013V67.6511Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.2222 43.9135H29.6953V45.4491H31.2222V43.9135Z",
    fill: "#FFE4CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.2013 43.9346H29.7168V45.4062H31.2013V43.9346Z",
    fill: "#FFE4CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.2222 42.4205H29.6953V43.9561H31.2222V42.4205Z",
    fill: "#FFE4CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.2013 42.442H29.7168V43.935H31.2013V42.442Z",
    fill: "#FFE4CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.2222 40.9274H29.6953V42.4629H31.2222V40.9274Z",
    fill: "#FFE4CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.2013 40.9489H29.7168V42.4418H31.2013V40.9489Z",
    fill: "#FFE4CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.2222 39.4558H29.6953V40.9914H31.2222V39.4558Z",
    fill: "#FFE4CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.2013 39.4776H29.7168V40.9705H31.2013V39.4776Z",
    fill: "#FFE4CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.2222 37.9628H29.6953V39.4984H31.2222V37.9628Z",
    fill: "#FFE4CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.2013 37.984H29.7168V39.4556H31.2013V37.984Z",
    fill: "#FFE4CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.2222 36.491H29.6953V38.0266H31.2222V36.491Z",
    fill: "#FFE4CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.2013 36.5125H29.7168V38.0054H31.2013V36.5125Z",
    fill: "#FFE4CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.2222 34.9984H29.6953V36.5339H31.2222V34.9984Z",
    fill: "#FFE4CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.2013 35.0194H29.7168V36.5123H31.2013V35.0194Z",
    fill: "#FFE4CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.2222 33.5263H29.6953V35.0619H31.2222V33.5263Z",
    fill: "#FFE4CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.2013 33.5479H29.7168V35.0408H31.2013V33.5479Z",
    fill: "#FFE4CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.2222 32.0338H29.6953V33.5693H31.2222V32.0338Z",
    fill: "#FFE4CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.2013 32.0548H29.7168V33.5264H31.2013V32.0548Z",
    fill: "#FFE4CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.2222 30.5624H29.6953V32.098H31.2222V30.5624Z",
    fill: "#FFE4CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.2013 30.5835H29.7168V32.0764H31.2013V30.5835Z",
    fill: "#FFE4CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.2222 29.0693H29.6953V30.6049H31.2222V29.0693Z",
    fill: "#FFE4CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.2013 29.0904H29.7168V30.5833H31.2013V29.0904Z",
    fill: "#FFE4CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.2222 27.5763H29.6953V29.1119H31.2222V27.5763Z",
    fill: "#FFE4CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.2013 27.6189H29.7168V29.1118H31.2013V27.6189Z",
    fill: "#FFE4CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.2222 26.1047H29.6953V27.6403H31.2222V26.1047Z",
    fill: "#BCBCBC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.2013 26.1258H29.7168V27.5974H31.2013V26.1258Z",
    fill: "#BCBCBC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.2222 24.6116H29.6953V26.1472H31.2222V24.6116Z",
    fill: "#BCBCBC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.2013 24.6545H29.7168V26.1474H31.2013V24.6545Z",
    fill: "#BCBCBC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.2222 23.1404H29.6953V24.676H31.2222V23.1404Z",
    fill: "#BCBCBC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.2013 23.1614H29.7168V24.6544H31.2013V23.1614Z",
    fill: "#BCBCBC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.4202 43.6657H20.8765V45.2182H22.4202V43.6657Z",
    fill: "#FFE4CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.3769 43.687H20.8975V45.1748H22.3769V43.687Z",
    fill: "#FFE4CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.4202 42.157H20.8765V43.7095H22.4202V42.157Z",
    fill: "#FFE4CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.3769 42.178H20.8975V43.6874H22.3769V42.178Z",
    fill: "#FFE4CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.4202 40.6693H20.8765V42.2218H22.4202V40.6693Z",
    fill: "#FFE4CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.3769 40.691H20.8975V42.2004H22.3769V40.691Z",
    fill: "#FFE4CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.4202 39.1605H20.8765V40.713H22.4202V39.1605Z",
    fill: "#243454"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.3769 39.1821H20.8975V40.6915H22.3769V39.1821Z",
    fill: "#243454"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.4202 37.6733H20.8765V39.2259H22.4202V37.6733Z",
    fill: "#243454"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.3769 37.6951H20.8975V39.183H22.3769V37.6951Z",
    fill: "#243454"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.4202 36.1641H20.8765V37.7166H22.4202V36.1641Z",
    fill: "#243454"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.3769 36.1859H20.8975V37.6952H22.3769V36.1859Z",
    fill: "#243454"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.4202 34.6553H20.8765V36.2079H22.4202V34.6553Z",
    fill: "#243454"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.3769 34.6987H20.8975V36.2081H22.3769V34.6987Z",
    fill: "#243454"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.4202 33.1681H20.8765V34.7206H22.4202V33.1681Z",
    fill: "#243454"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.3769 33.1899H20.8975V34.6993H22.3769V33.1899Z",
    fill: "#243454"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.4202 31.6589H20.8765V33.2114H22.4202V31.6589Z",
    fill: "#243454"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.3769 31.7022H20.8975V33.19H22.3769V31.7022Z",
    fill: "#243454"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.4202 30.1717H20.8765V31.7242H22.4202V30.1717Z",
    fill: "#243454"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.3769 30.1935H20.8975V31.7029H22.3769V30.1935Z",
    fill: "#243454"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.4202 28.6629H20.8765V30.2154H22.4202V28.6629Z",
    fill: "#243454"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.3769 28.6844H20.8975V30.1938H22.3769V28.6844Z",
    fill: "#243454"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.4202 27.1757H20.8765V28.7282H22.4202V27.1757Z",
    fill: "#243454"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.3769 27.1975H20.8975V28.7069H22.3769V27.1975Z",
    fill: "#243454"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.4202 25.667H20.8765V27.2195H22.4202V25.667Z",
    fill: "#243454"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.3769 25.688H20.8975V27.1758H22.3769V25.688Z",
    fill: "#243454"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.4202 24.1793H20.8765V25.7318H22.4202V24.1793Z",
    fill: "#243454"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.3769 24.201H20.8975V25.7104H22.3769V24.201Z",
    fill: "#243454"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.4202 22.6705H20.8765V24.2231H22.4202V22.6705Z",
    fill: "#243454"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.3769 22.6921H20.8975V24.2015H22.3769V22.6921Z",
    fill: "#243454"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.4202 9.17694H20.8765V10.7295H22.4202V9.17694Z",
    fill: "#3D041F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.3769 9.198H20.8975V10.6858H22.3769V9.198Z",
    fill: "#3D041F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.4202 7.68927H20.8765V9.24179H22.4202V7.68927Z",
    fill: "#3D041F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.3769 7.71082H20.8975V9.22021H22.3769V7.71082Z",
    fill: "#3D041F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.4202 6.18054H20.8765V7.73307H22.4202V6.18054Z",
    fill: "#3D041F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.3769 6.20203H20.8975V7.71142H22.3769V6.20203Z",
    fill: "#3D041F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.9197 67.6353H19.376V69.1878H20.9197V67.6353Z",
    fill: "#382A4C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.8983 67.6571H19.3975V69.1665H20.8983V67.6571Z",
    fill: "#382A4C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.9197 43.6657H19.376V45.2182H20.9197V43.6657Z",
    fill: "#FFE4CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.8983 43.687H19.3975V45.1748H20.8983V43.687Z",
    fill: "#FFE4CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.9197 42.157H19.376V43.7095H20.9197V42.157Z",
    fill: "#FFE4CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.8983 42.178H19.3975V43.6874H20.8983V42.178Z",
    fill: "#FFE4CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.9197 40.6693H19.376V42.2218H20.9197V40.6693Z",
    fill: "#FFE4CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.8983 40.691H19.3975V42.2004H20.8983V40.691Z",
    fill: "#FFE4CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.9197 39.1605H19.376V40.713H20.9197V39.1605Z",
    fill: "#131E33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.8983 39.1821H19.3975V40.6915H20.8983V39.1821Z",
    fill: "#131E33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.9197 37.6733H19.376V39.2259H20.9197V37.6733Z",
    fill: "#131E33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.8983 37.6951H19.3975V39.183H20.8983V37.6951Z",
    fill: "#131E33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.9197 36.1641H19.376V37.7166H20.9197V36.1641Z",
    fill: "#131E33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.8983 36.1859H19.3975V37.6952H20.8983V36.1859Z",
    fill: "#131E33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.9197 34.6553H19.376V36.2079H20.9197V34.6553Z",
    fill: "#131E33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.8983 34.6987H19.3975V36.2081H20.8983V34.6987Z",
    fill: "#131E33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.9197 33.1681H19.376V34.7206H20.9197V33.1681Z",
    fill: "#131E33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.8983 33.1899H19.3975V34.6993H20.8983V33.1899Z",
    fill: "#131E33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.9197 31.6589H19.376V33.2114H20.9197V31.6589Z",
    fill: "#131E33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.8983 31.7022H19.3975V33.19H20.8983V31.7022Z",
    fill: "#131E33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.9197 30.1717H19.376V31.7242H20.9197V30.1717Z",
    fill: "#131E33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.8983 30.1935H19.3975V31.7029H20.8983V30.1935Z",
    fill: "#131E33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.9197 28.6629H19.376V30.2154H20.9197V28.6629Z",
    fill: "#131E33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.8983 28.6844H19.3975V30.1938H20.8983V28.6844Z",
    fill: "#131E33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.9197 27.1757H19.376V28.7282H20.9197V27.1757Z",
    fill: "#131E33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.8983 27.1975H19.3975V28.7069H20.8983V27.1975Z",
    fill: "#131E33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.9197 25.667H19.376V27.2195H20.9197V25.667Z",
    fill: "#131E33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.8983 25.688H19.3975V27.1758H20.8983V25.688Z",
    fill: "#131E33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.9197 24.1793H19.376V25.7318H20.9197V24.1793Z",
    fill: "#243454"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.8983 24.201H19.3975V25.7104H20.8983V24.201Z",
    fill: "#243454"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.9197 22.6705H19.376V24.2231H20.9197V22.6705Z",
    fill: "#243454"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.8983 22.6921H19.3975V24.2015H20.8983V22.6921Z",
    fill: "#243454"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.9197 21.1833H19.376V22.7358H20.9197V21.1833Z",
    fill: "#243454"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.8983 21.2046H19.3975V22.714H20.8983V21.2046Z",
    fill: "#243454"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.9197 7.68927H19.376V9.24179H20.9197V7.68927Z",
    fill: "#3D041F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.8983 7.71082H19.3975V9.22021H20.8983V7.71082Z",
    fill: "#3D041F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.9197 6.18054H19.376V7.73307H20.9197V6.18054Z",
    fill: "#3D041F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.8983 6.20203H19.3975V7.71142H20.8983V6.20203Z",
    fill: "#3D041F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.9197 4.69281H19.376V6.24533H20.9197V4.69281Z",
    fill: "#3D041F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.8983 4.71436H19.3975V6.22375H20.8983V4.71436Z",
    fill: "#3D041F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.9197 3.18457H19.376V4.73709H20.9197V3.18457Z",
    fill: "#3D041F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.8983 3.20563H19.3975V4.69346H20.8983V3.20563Z",
    fill: "#3D041F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.4407 67.6353H17.897V69.1878H19.4407V67.6353Z",
    fill: "#382A4C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.4193 67.6571H17.9185V69.1665H19.4193V67.6571Z",
    fill: "#382A4C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.4407 66.1481H17.897V67.7007H19.4407V66.1481Z",
    fill: "#F57E77"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.4193 66.1699H17.9185V67.6578H19.4193V66.1699Z",
    fill: "#382A4C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.4407 64.6394H17.897V66.1919H19.4407V64.6394Z",
    fill: "#382A4C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.4193 64.6611H17.9185V66.1705H19.4193V64.6611Z",
    fill: "#382A4C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.4407 42.157H17.897V43.7095H19.4407V42.157Z",
    fill: "#FFE4CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.4193 42.178H17.9185V43.6874H19.4193V42.178Z",
    fill: "#FFE4CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.4407 40.6693H17.897V42.2218H19.4407V40.6693Z",
    fill: "#F57E77"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.4193 40.691H17.9185V42.2004H19.4193V40.691Z",
    fill: "#F57E77"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.4407 24.1793H17.897V25.7318H19.4407V24.1793Z",
    fill: "#131E33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.4193 24.201H17.9185V25.7104H19.4193V24.201Z",
    fill: "#131E33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.4407 22.6705H17.897V24.2231H19.4407V22.6705Z",
    fill: "#131E33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.4193 22.6921H17.9185V24.2015H19.4193V22.6921Z",
    fill: "#131E33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.4407 21.1833H17.897V22.7358H19.4407V21.1833Z",
    fill: "#243454"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.4193 21.2046H17.9185V22.714H19.4193V21.2046Z",
    fill: "#243454"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.4407 19.6746H17.897V21.2271H19.4407V19.6746Z",
    fill: "#243454"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.4193 19.6961H17.9185V21.1839H19.4193V19.6961Z",
    fill: "#243454"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.4407 7.68927H17.897V9.24179H19.4407V7.68927Z",
    fill: "#3D041F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.4193 7.71082H17.9185V9.22021H19.4193V7.71082Z",
    fill: "#3D041F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.4407 6.18054H17.897V7.73307H19.4407V6.18054Z",
    fill: "#3D041F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.4193 6.20203H17.9185V7.71142H19.4193V6.20203Z",
    fill: "#3D041F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.4407 4.69281H17.897V6.24533H19.4407V4.69281Z",
    fill: "#3D041F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.4193 4.71436H17.9185V6.22375H19.4193V4.71436Z",
    fill: "#3D041F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.4407 3.18457H17.897V4.73709H19.4407V3.18457Z",
    fill: "#3D041F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.4193 3.20563H17.9185V4.69346H19.4193V3.20563Z",
    fill: "#3D041F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.4407 1.69684H17.897V3.24936H19.4407V1.69684Z",
    fill: "#3D041F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.4193 1.71838H17.9185V3.22778H19.4193V1.71838Z",
    fill: "#3D041F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.9402 67.6353H16.3965V69.1878H17.9402V67.6353Z",
    fill: "#382A4C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.9193 67.6571H16.4185V69.1665H17.9193V67.6571Z",
    fill: "#382A4C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.9402 66.1481H16.3965V67.7007H17.9402V66.1481Z",
    fill: "#382A4C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.9193 66.1699H16.4185V67.6578H17.9193V66.1699Z",
    fill: "#382A4C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.9402 64.6394H16.3965V66.1919H17.9402V64.6394Z",
    fill: "#FFE4CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.9193 64.6611H16.4185V66.1705H17.9193V64.6611Z",
    fill: "#FFE4CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.9402 40.6693H16.3965V42.2218H17.9402V40.6693Z",
    fill: "#2F143E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.9193 40.691H16.4185V42.2004H17.9193V40.691Z",
    fill: "#2F143E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.9402 39.1605H16.3965V40.713H17.9402V39.1605Z",
    fill: "#200C2B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.9193 39.1821H16.4185V40.6915H17.9193V39.1821Z",
    fill: "#200C2B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.9402 37.6733H16.3965V39.2259H17.9402V37.6733Z",
    fill: "#200C2B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.9193 37.6951H16.4185V39.183H17.9193V37.6951Z",
    fill: "#200C2B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.9402 36.1641H16.3965V37.7166H17.9402V36.1641Z",
    fill: "#200C2B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.9193 36.1859H16.4185V37.6952H17.9193V36.1859Z",
    fill: "#200C2B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.9402 34.6553H16.3965V36.2079H17.9402V34.6553Z",
    fill: "#131E33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.9193 34.6987H16.4185V36.2081H17.9193V34.6987Z",
    fill: "#131E33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.9402 22.6705H16.3965V24.2231H17.9402V22.6705Z",
    fill: "#131E33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.9193 22.6921H16.4185V24.2015H17.9193V22.6921Z",
    fill: "#131E33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.9402 21.1833H16.3965V22.7358H17.9402V21.1833Z",
    fill: "#243454"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.9193 21.2046H16.4185V22.714H17.9193V21.2046Z",
    fill: "#243454"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.9402 19.6746H16.3965V21.2271H17.9402V19.6746Z",
    fill: "#243454"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.9193 19.6961H16.4185V21.1839H17.9193V19.6961Z",
    fill: "#243454"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.9402 18.1869H16.3965V19.7394H17.9402V18.1869Z",
    fill: "#243454"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.9193 18.2087H16.4185V19.7181H17.9193V18.2087Z",
    fill: "#243454"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.9402 12.1729H16.3965V13.7254H17.9402V12.1729Z",
    fill: "#621931"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.9193 12.1945H16.4185V13.7039H17.9193V12.1945Z",
    fill: "#621931"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.9402 10.6857H16.3965V12.2383H17.9402V10.6857Z",
    fill: "#621931"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.9193 10.7073H16.4185V12.2167H17.9193V10.7073Z",
    fill: "#621931"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.9402 9.17694H16.3965V10.7295H17.9402V9.17694Z",
    fill: "#621931"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.9193 9.198H16.4185V10.6858H17.9193V9.198Z",
    fill: "#621931"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.9402 7.68927H16.3965V9.24179H17.9402V7.68927Z",
    fill: "#621931"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.9193 7.71082H16.4185V9.22021H17.9193V7.71082Z",
    fill: "#621931"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.9402 6.18054H16.3965V7.73307H17.9402V6.18054Z",
    fill: "#3D041F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.9193 6.20203H16.4185V7.71142H17.9193V6.20203Z",
    fill: "#3D041F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.9402 4.69281H16.3965V6.24533H17.9402V4.69281Z",
    fill: "#3D041F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.9193 4.71436H16.4185V6.22375H17.9193V4.71436Z",
    fill: "#3D041F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.9402 3.18457H16.3965V4.73709H17.9402V3.18457Z",
    fill: "#3D041F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.9193 3.20563H16.4185V4.69346H17.9193V3.20563Z",
    fill: "#3D041F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.9402 1.69684H16.3965V3.24936H17.9402V1.69684Z",
    fill: "#3D041F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.9193 1.71838H16.4185V3.22778H17.9193V1.71838Z",
    fill: "#3D041F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.9407 0.18811H16.397V1.74063H17.9407V0.18811Z",
    fill: "#3D041F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.9193 0.209595H16.4185V1.71899H17.9193V0.209595Z",
    fill: "#3D041F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.4617 67.6353H14.918V69.1878H16.4617V67.6353Z",
    fill: "#382A4C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.4189 67.6571H14.9395V69.1665H16.4189V67.6571Z",
    fill: "#382A4C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.4617 66.1481H14.918V67.7007H16.4617V66.1481Z",
    fill: "#FFE4CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.4189 66.1699H14.9395V67.6578H16.4189V66.1699Z",
    fill: "#FFE4CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.4617 64.6394H14.918V66.1919H16.4617V64.6394Z",
    fill: "#FFE4CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.4189 64.6611H14.9395V66.1705H16.4189V64.6611Z",
    fill: "#FFE4CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.4617 63.1517H14.918V64.7042H16.4617V63.1517Z",
    fill: "#FFE4CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.4189 63.1735H14.9395V64.6829H16.4189V63.1735Z",
    fill: "#FFE4CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.4617 46.6622H14.918V48.2147H16.4617V46.6622Z",
    fill: "#2F143E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.4189 46.6835H14.9395V48.1929H16.4189V46.6835Z",
    fill: "#2F143E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.4617 45.153H14.918V46.7055H16.4617V45.153Z",
    fill: "#2F143E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.4189 45.1744H14.9395V46.6838H16.4189V45.1744Z",
    fill: "#2F143E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.4617 43.6657H14.918V45.2182H16.4617V43.6657Z",
    fill: "#2F143E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.4189 43.687H14.9395V45.1748H16.4189V43.687Z",
    fill: "#2F143E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.4617 42.157H14.918V43.7095H16.4617V42.157Z",
    fill: "#2F143E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.4189 42.178H14.9395V43.6874H16.4189V42.178Z",
    fill: "#2F143E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.4617 40.6693H14.918V42.2218H16.4617V40.6693Z",
    fill: "#2F143E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.4189 40.691H14.9395V42.2004H16.4189V40.691Z",
    fill: "#2F143E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.4617 39.1605H14.918V40.713H16.4617V39.1605Z",
    fill: "#2F143E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.4189 39.1821H14.9395V40.6915H16.4189V39.1821Z",
    fill: "#2F143E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.4617 37.6733H14.918V39.2259H16.4617V37.6733Z",
    fill: "#2F143E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.4189 37.6951H14.9395V39.183H16.4189V37.6951Z",
    fill: "#2F143E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.4617 36.1641H14.918V37.7166H16.4617V36.1641Z",
    fill: "#200C2B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.4189 36.1859H14.9395V37.6952H16.4189V36.1859Z",
    fill: "#200C2B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.4617 34.6553H14.918V36.2079H16.4617V34.6553Z",
    fill: "#131E33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.4189 34.6987H14.9395V36.2081H16.4189V34.6987Z",
    fill: "#131E33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.4617 33.1681H14.918V34.7206H16.4617V33.1681Z",
    fill: "#131E33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.4189 33.1899H14.9395V34.6993H16.4189V33.1899Z",
    fill: "#131E33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.4617 31.6589H14.918V33.2114H16.4617V31.6589Z",
    fill: "#131E33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.4189 31.7022H14.9395V33.19H16.4189V31.7022Z",
    fill: "#131E33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.4617 25.667H14.918V27.2195H16.4617V25.667Z",
    fill: "#243454"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.4189 25.688H14.9395V27.1758H16.4189V25.688Z",
    fill: "#243454"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.4617 24.1793H14.918V25.7318H16.4617V24.1793Z",
    fill: "#243454"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.4189 24.201H14.9395V25.7104H16.4189V24.201Z",
    fill: "#243454"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.4617 22.6705H14.918V24.2231H16.4617V22.6705Z",
    fill: "#243454"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.4189 22.6921H14.9395V24.2015H16.4189V22.6921Z",
    fill: "#243454"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.4617 21.1833H14.918V22.7358H16.4617V21.1833Z",
    fill: "#243454"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.4189 21.2046H14.9395V22.714H16.4189V21.2046Z",
    fill: "#243454"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.4617 19.6746H14.918V21.2271H16.4617V19.6746Z",
    fill: "#243454"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.4189 19.6961H14.9395V21.1839H16.4189V19.6961Z",
    fill: "#243454"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.4617 18.1869H14.918V19.7394H16.4617V18.1869Z",
    fill: "#131E33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.4189 18.2087H14.9395V19.7181H16.4189V18.2087Z",
    fill: "#131E33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.4617 13.6816H14.918V15.2342H16.4617V13.6816Z",
    fill: "#3D041F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.4189 13.7032H14.9395V15.2126H16.4189V13.7032Z",
    fill: "#3D041F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.4617 12.1729H14.918V13.7254H16.4617V12.1729Z",
    fill: "#F57E77"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.4189 12.1945H14.9395V13.7039H16.4189V12.1945Z",
    fill: "#F57E77"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.4617 10.6857H14.918V12.2383H16.4617V10.6857Z",
    fill: "#FFE4CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.4189 10.7073H14.9395V12.2167H16.4189V10.7073Z",
    fill: "#FFE4CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.4617 9.17694H14.918V10.7295H16.4617V9.17694Z",
    fill: "#3D041F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.4189 9.198H14.9395V10.6858H16.4189V9.198Z",
    fill: "#3D041F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.4617 7.68927H14.918V9.24179H16.4617V7.68927Z",
    fill: "#3D041F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.4189 7.71082H14.9395V9.22021H16.4189V7.71082Z",
    fill: "#3D041F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.4617 6.18054H14.918V7.73307H16.4617V6.18054Z",
    fill: "#621931"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.4189 6.20203H14.9395V7.71142H16.4189V6.20203Z",
    fill: "#621931"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.4617 4.69281H14.918V6.24533H16.4617V4.69281Z",
    fill: "#621931"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.4189 4.71436H14.9395V6.22375H16.4189V4.71436Z",
    fill: "#621931"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.4617 3.18457H14.918V4.73709H16.4617V3.18457Z",
    fill: "#3D041F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.4189 3.20563H14.9395V4.69346H16.4189V3.20563Z",
    fill: "#3D041F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.4617 1.69684H14.918V3.24936H16.4617V1.69684Z",
    fill: "#3D041F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.4189 1.71838H14.9395V3.22778H16.4189V1.71838Z",
    fill: "#3D041F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.9612 67.6353H13.4175V69.1878H14.9612V67.6353Z",
    fill: "#382A4C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.9403 67.6571H13.4395V69.1665H14.9403V67.6571Z",
    fill: "#382A4C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.9612 66.1481H13.4175V67.7007H14.9612V66.1481Z",
    fill: "#FFE4CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.9403 66.1699H13.4395V67.6578H14.9403V66.1699Z",
    fill: "#FFE4CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.9612 64.6394H13.4175V66.1919H14.9612V64.6394Z",
    fill: "#FFE4CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.9403 64.6611H13.4395V66.1705H14.9403V64.6611Z",
    fill: "#FFE4CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.9612 63.1517H13.4175V64.7042H14.9612V63.1517Z",
    fill: "#FFE4CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.9403 63.1735H13.4395V64.6829H14.9403V63.1735Z",
    fill: "#FFE4CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.9612 61.6429H13.4175V63.1955H14.9612V61.6429Z",
    fill: "#FFE4CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.9403 61.6647H13.4395V63.1741H14.9403V61.6647Z",
    fill: "#FFE4CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.9612 60.1557H13.4175V61.7082H14.9612V60.1557Z",
    fill: "#FFE4CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.9403 60.1775H13.4395V61.6653H14.9403V60.1775Z",
    fill: "#FFE4CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.9612 58.647H13.4175V60.1995H14.9612V58.647Z",
    fill: "#FFE4CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.9403 58.6688H13.4395V60.1782H14.9403V58.6688Z",
    fill: "#FFE4CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.9612 57.1593H13.4175V58.7118H14.9612V57.1593Z",
    fill: "#FFE4CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.9403 57.1811H13.4395V58.6905H14.9403V57.1811Z",
    fill: "#FFE4CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.9612 55.6505H13.4175V57.203H14.9612V55.6505Z",
    fill: "#FFE4CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.9403 55.6723H13.4395V57.1817H14.9403V55.6723Z",
    fill: "#FFE4CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.9612 54.1633H13.4175V55.7159H14.9612V54.1633Z",
    fill: "#FFE4CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.9403 54.1851H13.4395V55.673H14.9403V54.1851Z",
    fill: "#FFE4CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.9612 52.6541H13.4175V54.2066H14.9612V52.6541Z",
    fill: "#FFE4CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.9403 52.6758H13.4395V54.1852H14.9403V52.6758Z",
    fill: "#FFE4CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.9612 51.1453H13.4175V52.6979H14.9612V51.1453Z",
    fill: "#FFE4CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.9403 51.1887H13.4395V52.6981H14.9403V51.1887Z",
    fill: "#FFE4CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.9612 49.6581H13.4175V51.2107H14.9612V49.6581Z",
    fill: "#FFE4CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.9403 49.6799H13.4395V51.1678H14.9403V49.6799Z",
    fill: "#FFE4CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.9612 48.1494H13.4175V49.7019H14.9612V48.1494Z",
    fill: "#FFE4CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.9403 48.1704H13.4395V49.6798H14.9403V48.1704Z",
    fill: "#FFE4CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.9612 46.6622H13.4175V48.2147H14.9612V46.6622Z",
    fill: "#2F143E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.9403 46.6835H13.4395V48.1929H14.9403V46.6835Z",
    fill: "#2F143E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.9612 45.153H13.4175V46.7055H14.9612V45.153Z",
    fill: "#2F143E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.9403 45.1744H13.4395V46.6838H14.9403V45.1744Z",
    fill: "#2F143E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.9612 43.6657H13.4175V45.2182H14.9612V43.6657Z",
    fill: "#2F143E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.9403 43.687H13.4395V45.1748H14.9403V43.687Z",
    fill: "#2F143E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.9612 42.157H13.4175V43.7095H14.9612V42.157Z",
    fill: "#2F143E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.9403 42.178H13.4395V43.6874H14.9403V42.178Z",
    fill: "#2F143E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.9612 40.6693H13.4175V42.2218H14.9612V40.6693Z",
    fill: "#2F143E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.9403 40.691H13.4395V42.2004H14.9403V40.691Z",
    fill: "#2F143E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.9612 39.1605H13.4175V40.713H14.9612V39.1605Z",
    fill: "#2F143E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.9403 39.1821H13.4395V40.6915H14.9403V39.1821Z",
    fill: "#2F143E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.9612 37.6733H13.4175V39.2259H14.9612V37.6733Z",
    fill: "#2F143E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.9403 37.6951H13.4395V39.183H14.9403V37.6951Z",
    fill: "#2F143E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.9612 36.1641H13.4175V37.7166H14.9612V36.1641Z",
    fill: "#2F143E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.9403 36.1859H13.4395V37.6952H14.9403V36.1859Z",
    fill: "#2F143E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.9612 34.6553H13.4175V36.2079H14.9612V34.6553Z",
    fill: "#131E33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.9403 34.6987H13.4395V36.2081H14.9403V34.6987Z",
    fill: "#131E33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.9612 33.1681H13.4175V34.7206H14.9612V33.1681Z",
    fill: "#243454"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.9403 33.1899H13.4395V34.6993H14.9403V33.1899Z",
    fill: "#243454"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.9612 31.6589H13.4175V33.2114H14.9612V31.6589Z",
    fill: "#243454"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.9403 31.7022H13.4395V33.19H14.9403V31.7022Z",
    fill: "#243454"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.9612 30.1717H13.4175V31.7242H14.9612V30.1717Z",
    fill: "#131E33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.9403 30.1935H13.4395V31.7029H14.9403V30.1935Z",
    fill: "#131E33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.9612 28.6629H13.4175V30.2154H14.9612V28.6629Z",
    fill: "#131E33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.9403 28.6844H13.4395V30.1938H14.9403V28.6844Z",
    fill: "#131E33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.9612 27.1757H13.4175V28.7282H14.9612V27.1757Z",
    fill: "#131E33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.9403 27.1975H13.4395V28.7069H14.9403V27.1975Z",
    fill: "#131E33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.9612 25.667H13.4175V27.2195H14.9612V25.667Z",
    fill: "#243454"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.9403 25.688H13.4395V27.1758H14.9403V25.688Z",
    fill: "#243454"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.9612 24.1793H13.4175V25.7318H14.9612V24.1793Z",
    fill: "#243454"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.9403 24.201H13.4395V25.7104H14.9403V24.201Z",
    fill: "#243454"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.9612 22.6705H13.4175V24.2231H14.9612V22.6705Z",
    fill: "#243454"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.9403 22.6921H13.4395V24.2015H14.9403V22.6921Z",
    fill: "#243454"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.9612 21.1833H13.4175V22.7358H14.9612V21.1833Z",
    fill: "#243454"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.9403 21.2046H13.4395V22.714H14.9403V21.2046Z",
    fill: "#243454"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.9612 19.6746H13.4175V21.2271H14.9612V19.6746Z",
    fill: "#F57E77"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.9403 19.6961H13.4395V21.1839H14.9403V19.6961Z",
    fill: "#F57E77"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.9612 18.1869H13.4175V19.7394H14.9612V18.1869Z",
    fill: "#F57E77"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.9403 18.2087H13.4395V19.7181H14.9403V18.2087Z",
    fill: "#F57E77"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.9612 13.6816H13.4175V15.2342H14.9612V13.6816Z",
    fill: "#F57E77"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.9403 13.7032H13.4395V15.2126H14.9403V13.7032Z",
    fill: "#F57E77"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.9612 12.1729H13.4175V13.7254H14.9612V12.1729Z",
    fill: "#FFE4CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.9403 12.1945H13.4395V13.7039H14.9403V12.1945Z",
    fill: "#FFE4CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.9612 10.6857H13.4175V12.2383H14.9612V10.6857Z",
    fill: "#FFE4CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.9403 10.7073H13.4395V12.2167H14.9403V10.7073Z",
    fill: "#FFE4CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.9612 9.17694H13.4175V10.7295H14.9612V9.17694Z",
    fill: "#FFE4CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.9403 9.198H13.4395V10.6858H14.9403V9.198Z",
    fill: "#FFE4CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.9612 7.68927H13.4175V9.24179H14.9612V7.68927Z",
    fill: "#3D041F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.9403 7.71082H13.4395V9.22021H14.9403V7.71082Z",
    fill: "#3D041F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.9612 6.18054H13.4175V7.73307H14.9612V6.18054Z",
    fill: "#3D041F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.9403 6.20203H13.4395V7.71142H14.9403V6.20203Z",
    fill: "#3D041F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.9612 4.69281H13.4175V6.24533H14.9612V4.69281Z",
    fill: "#621931"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.9403 4.71436H13.4395V6.22375H14.9403V4.71436Z",
    fill: "#621931"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.9612 3.18457H13.4175V4.73709H14.9612V3.18457Z",
    fill: "#621931"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.9403 3.20563H13.4395V4.69346H14.9403V3.20563Z",
    fill: "#621931"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4822 67.6353H11.9385V69.1878H13.4822V67.6353Z",
    fill: "#26031F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4608 67.6571H11.96V69.1665H13.4608V67.6571Z",
    fill: "#26031F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4822 66.1481H11.9385V67.7007H13.4822V66.1481Z",
    fill: "#F57E77"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4608 66.1699H11.96V67.6578H13.4608V66.1699Z",
    fill: "#F57E77"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4822 64.6394H11.9385V66.1919H13.4822V64.6394Z",
    fill: "#F57E77"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4608 64.6611H11.96V66.1705H13.4608V64.6611Z",
    fill: "#F57E77"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4822 63.1517H11.9385V64.7042H13.4822V63.1517Z",
    fill: "#F57E77"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4608 63.1735H11.96V64.6829H13.4608V63.1735Z",
    fill: "#F57E77"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4822 61.6429H11.9385V63.1955H13.4822V61.6429Z",
    fill: "#F57E77"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4608 61.6647H11.96V63.1741H13.4608V61.6647Z",
    fill: "#F57E77"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4822 60.1557H11.9385V61.7082H13.4822V60.1557Z",
    fill: "#F57E77"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4608 60.1775H11.96V61.6653H13.4608V60.1775Z",
    fill: "#F57E77"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4822 58.647H11.9385V60.1995H13.4822V58.647Z",
    fill: "#F57E77"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4608 58.6688H11.96V60.1782H13.4608V58.6688Z",
    fill: "#F57E77"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4822 57.1593H11.9385V58.7118H13.4822V57.1593Z",
    fill: "#F57E77"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4608 57.1811H11.96V58.6905H13.4608V57.1811Z",
    fill: "#F57E77"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4822 55.6505H11.9385V57.203H13.4822V55.6505Z",
    fill: "#F57E77"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4608 55.6723H11.96V57.1817H13.4608V55.6723Z",
    fill: "#F57E77"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4822 54.1633H11.9385V55.7159H13.4822V54.1633Z",
    fill: "#F57E77"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4608 54.1851H11.96V55.673H13.4608V54.1851Z",
    fill: "#F57E77"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4822 52.6541H11.9385V54.2066H13.4822V52.6541Z",
    fill: "#F57E77"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4608 52.6758H11.96V54.1852H13.4608V52.6758Z",
    fill: "#F57E77"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4822 51.1453H11.9385V52.6979H13.4822V51.1453Z",
    fill: "#F57E77"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4608 51.1887H11.96V52.6981H13.4608V51.1887Z",
    fill: "#F57E77"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4822 49.6581H11.9385V51.2107H13.4822V49.6581Z",
    fill: "#F57E77"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4608 49.6799H11.96V51.1678H13.4608V49.6799Z",
    fill: "#F57E77"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4822 48.1494H11.9385V49.7019H13.4822V48.1494Z",
    fill: "#F57E77"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4608 48.1704H11.96V49.6798H13.4608V48.1704Z",
    fill: "#F57E77"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4822 46.6622H11.9385V48.2147H13.4822V46.6622Z",
    fill: "#200C2B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4608 46.6835H11.96V48.1929H13.4608V46.6835Z",
    fill: "#200C2B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4822 45.153H11.9385V46.7055H13.4822V45.153Z",
    fill: "#200C2B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4608 45.1744H11.96V46.6838H13.4608V45.1744Z",
    fill: "#200C2B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4822 43.6657H11.9385V45.2182H13.4822V43.6657Z",
    fill: "#200C2B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4608 43.687H11.96V45.1748H13.4608V43.687Z",
    fill: "#200C2B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4822 42.157H11.9385V43.7095H13.4822V42.157Z",
    fill: "#200C2B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4608 42.178H11.96V43.6874H13.4608V42.178Z",
    fill: "#200C2B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4822 40.6693H11.9385V42.2218H13.4822V40.6693Z",
    fill: "#2F143E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4608 40.691H11.96V42.2004H13.4608V40.691Z",
    fill: "#2F143E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4822 39.1605H11.9385V40.713H13.4822V39.1605Z",
    fill: "#2F143E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4608 39.1821H11.96V40.6915H13.4608V39.1821Z",
    fill: "#2F143E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4822 37.6733H11.9385V39.2259H13.4822V37.6733Z",
    fill: "#2F143E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4608 37.6951H11.96V39.183H13.4608V37.6951Z",
    fill: "#2F143E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4822 36.1641H11.9385V37.7166H13.4822V36.1641Z",
    fill: "#2F143E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4608 36.1859H11.96V37.6952H13.4608V36.1859Z",
    fill: "#2F143E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4822 34.6553H11.9385V36.2079H13.4822V34.6553Z",
    fill: "#243454"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4608 34.6987H11.96V36.2081H13.4608V34.6987Z",
    fill: "#243454"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4822 33.1681H11.9385V34.7206H13.4822V33.1681Z",
    fill: "#243454"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4608 33.1899H11.96V34.6993H13.4608V33.1899Z",
    fill: "#243454"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4822 31.6589H11.9385V33.2114H13.4822V31.6589Z",
    fill: "#243454"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4608 31.7022H11.96V33.19H13.4608V31.7022Z",
    fill: "#243454"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4822 30.1717H11.9385V31.7242H13.4822V30.1717Z",
    fill: "#243454"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4608 30.1935H11.96V31.7029H13.4608V30.1935Z",
    fill: "#243454"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4822 28.6629H11.9385V30.2154H13.4822V28.6629Z",
    fill: "#243454"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4608 28.6844H11.96V30.1938H13.4608V28.6844Z",
    fill: "#243454"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4822 27.1757H11.9385V28.7282H13.4822V27.1757Z",
    fill: "#131E33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4608 27.1975H11.96V28.7069H13.4608V27.1975Z",
    fill: "#131E33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4822 25.667H11.9385V27.2195H13.4822V25.667Z",
    fill: "#243454"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4608 25.688H11.96V27.1758H13.4608V25.688Z",
    fill: "#243454"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4822 24.1793H11.9385V25.7318H13.4822V24.1793Z",
    fill: "#243454"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4608 24.201H11.96V25.7104H13.4608V24.201Z",
    fill: "#243454"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4822 22.6705H11.9385V24.2231H13.4822V22.6705Z",
    fill: "#243454"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4608 22.6921H11.96V24.2015H13.4608V22.6921Z",
    fill: "#243454"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4822 21.1833H11.9385V22.7358H13.4822V21.1833Z",
    fill: "#FFE4CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4608 21.2046H11.96V22.714H13.4608V21.2046Z",
    fill: "#FFE4CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4822 19.6746H11.9385V21.2271H13.4822V19.6746Z",
    fill: "#FFE4CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4608 19.6961H11.96V21.1839H13.4608V19.6961Z",
    fill: "#FFE4CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4822 18.1869H11.9385V19.7394H13.4822V18.1869Z",
    fill: "#F57E77"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4608 18.2087H11.96V19.7181H13.4608V18.2087Z",
    fill: "#F57E77"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4822 16.6781H11.9385V18.2306H13.4822V16.6781Z",
    fill: "#F57E77"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4608 16.6996H11.96V18.209H13.4608V16.6996Z",
    fill: "#F57E77"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4822 15.1694H11.9385V16.7219H13.4822V15.1694Z",
    fill: "#F57E77"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4608 15.2127H11.96V16.7005H13.4608V15.2127Z",
    fill: "#F57E77"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4822 13.6816H11.9385V15.2342H13.4822V13.6816Z",
    fill: "#FFE4CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4608 13.7032H11.96V15.2126H13.4608V13.7032Z",
    fill: "#FFE4CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4822 12.1729H11.9385V13.7254H13.4822V12.1729Z",
    fill: "#FFE4CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4608 12.1945H11.96V13.7039H13.4608V12.1945Z",
    fill: "#FFE4CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4822 10.6857H11.9385V12.2383H13.4822V10.6857Z",
    fill: "#FFE4CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4608 10.7073H11.96V12.2167H13.4608V10.7073Z",
    fill: "#FFE4CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4822 9.17694H11.9385V10.7295H13.4822V9.17694Z",
    fill: "#66667C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4608 9.198H11.96V10.6858H13.4608V9.198Z",
    fill: "#66667C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4822 7.68927H11.9385V9.24179H13.4822V7.68927Z",
    fill: "#FFE4CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4608 7.71082H11.96V9.22021H13.4608V7.71082Z",
    fill: "#FFE4CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4822 6.18054H11.9385V7.73307H13.4822V6.18054Z",
    fill: "#3D041F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4608 6.20203H11.96V7.71142H13.4608V6.20203Z",
    fill: "#3D041F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4822 4.69281H11.9385V6.24533H13.4822V4.69281Z",
    fill: "#621931"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4608 4.71436H11.96V6.22375H13.4608V4.71436Z",
    fill: "#621931"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4822 3.18457H11.9385V4.73709H13.4822V3.18457Z",
    fill: "#621931"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4608 3.20563H11.96V4.69346H13.4608V3.20563Z",
    fill: "#621931"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9822 40.6693H10.4385V42.2218H11.9822V40.6693Z",
    fill: "#200C2B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9608 40.691H10.46V42.2004H11.9608V40.691Z",
    fill: "#200C2B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9822 39.1605H10.4385V40.713H11.9822V39.1605Z",
    fill: "#200C2B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9608 39.1821H10.46V40.6915H11.9608V39.1821Z",
    fill: "#200C2B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9822 37.6733H10.4385V39.2259H11.9822V37.6733Z",
    fill: "#2F143E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9608 37.6951H10.46V39.183H11.9608V37.6951Z",
    fill: "#2F143E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9822 36.1641H10.4385V37.7166H11.9822V36.1641Z",
    fill: "#2F143E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9608 36.1859H10.46V37.6952H11.9608V36.1859Z",
    fill: "#2F143E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9822 34.6553H10.4385V36.2079H11.9822V34.6553Z",
    fill: "#243454"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9608 34.6987H10.46V36.2081H11.9608V34.6987Z",
    fill: "#243454"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9822 33.1681H10.4385V34.7206H11.9822V33.1681Z",
    fill: "#243454"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9608 33.1899H10.46V34.6993H11.9608V33.1899Z",
    fill: "#243454"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9822 31.6589H10.4385V33.2114H11.9822V31.6589Z",
    fill: "#243454"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9608 31.7022H10.46V33.19H11.9608V31.7022Z",
    fill: "#243454"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9822 30.1717H10.4385V31.7242H11.9822V30.1717Z",
    fill: "#243454"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9608 30.1935H10.46V31.7029H11.9608V30.1935Z",
    fill: "#243454"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9822 28.6629H10.4385V30.2154H11.9822V28.6629Z",
    fill: "#243454"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9608 28.6844H10.46V30.1938H11.9608V28.6844Z",
    fill: "#243454"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9822 27.1757H10.4385V28.7282H11.9822V27.1757Z",
    fill: "#243454"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9608 27.1975H10.46V28.7069H11.9608V27.1975Z",
    fill: "#243454"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9822 25.667H10.4385V27.2195H11.9822V25.667Z",
    fill: "#131E33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9608 25.688H10.46V27.1758H11.9608V25.688Z",
    fill: "#131E33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9822 24.1793H10.4385V25.7318H11.9822V24.1793Z",
    fill: "#243454"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9608 24.201H10.46V25.7104H11.9608V24.201Z",
    fill: "#243454"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9822 22.6705H10.4385V24.2231H11.9822V22.6705Z",
    fill: "#243454"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9608 22.6921H10.46V24.2015H11.9608V22.6921Z",
    fill: "#243454"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9822 21.1833H10.4385V22.7358H11.9822V21.1833Z",
    fill: "#FFE4CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9608 21.2046H10.46V22.714H11.9608V21.2046Z",
    fill: "#FFE4CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9822 19.6746H10.4385V21.2271H11.9822V19.6746Z",
    fill: "#FFE4CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9608 19.6961H10.46V21.1839H11.9608V19.6961Z",
    fill: "#FFE4CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9822 18.1869H10.4385V19.7394H11.9822V18.1869Z",
    fill: "#FFE4CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9608 18.2087H10.46V19.7181H11.9608V18.2087Z",
    fill: "#FFE4CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9822 16.6781H10.4385V18.2306H11.9822V16.6781Z",
    fill: "#FFE4CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9608 16.6996H10.46V18.209H11.9608V16.6996Z",
    fill: "#FFE4CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9822 15.1694H10.4385V16.7219H11.9822V15.1694Z",
    fill: "#F57E77"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9608 15.2127H10.46V16.7005H11.9608V15.2127Z",
    fill: "#F57E77"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9822 13.6816H10.4385V15.2342H11.9822V13.6816Z",
    fill: "#FFE4CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9608 13.7032H10.46V15.2126H11.9608V13.7032Z",
    fill: "#FFE4CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9822 12.1729H10.4385V13.7254H11.9822V12.1729Z",
    fill: "#FFE4CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9608 12.1945H10.46V13.7039H11.9608V12.1945Z",
    fill: "#FFE4CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9822 10.6857H10.4385V12.2383H11.9822V10.6857Z",
    fill: "#FFE4CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9608 10.7073H10.46V12.2167H11.9608V10.7073Z",
    fill: "#FFE4CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9822 9.17694H10.4385V10.7295H11.9822V9.17694Z",
    fill: "#FFE4CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9608 9.198H10.46V10.6858H11.9608V9.198Z",
    fill: "#FFE4CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9822 7.68927H10.4385V9.24179H11.9822V7.68927Z",
    fill: "#3D041F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9608 7.71082H10.46V9.22021H11.9608V7.71082Z",
    fill: "#3D041F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9822 6.18054H10.4385V7.73307H11.9822V6.18054Z",
    fill: "#3D041F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9608 6.20203H10.46V7.71142H11.9608V6.20203Z",
    fill: "#3D041F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9822 4.69281H10.4385V6.24533H11.9822V4.69281Z",
    fill: "#621931"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9608 4.71436H10.46V6.22375H11.9608V4.71436Z",
    fill: "#621931"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9822 3.18457H10.4385V4.73709H11.9822V3.18457Z",
    fill: "#621931"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9608 3.20563H10.46V4.69346H11.9608V3.20563Z",
    fill: "#621931"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5027 67.6353H8.95898V69.1878H10.5027V67.6353Z",
    fill: "#26031F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.4599 67.6571H8.98047V69.1665H10.4599V67.6571Z",
    fill: "#26031F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5027 66.1481H8.95898V67.7007H10.5027V66.1481Z",
    fill: "#F57E77"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.4599 66.1699H8.98047V67.6578H10.4599V66.1699Z",
    fill: "#F57E77"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5027 64.6394H8.95898V66.1919H10.5027V64.6394Z",
    fill: "#F57E77"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.4599 64.6611H8.98047V66.1705H10.4599V64.6611Z",
    fill: "#F57E77"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5027 63.1517H8.95898V64.7042H10.5027V63.1517Z",
    fill: "#F57E77"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.4599 63.1735H8.98047V64.6829H10.4599V63.1735Z",
    fill: "#F57E77"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5027 61.6429H8.95898V63.1955H10.5027V61.6429Z",
    fill: "#F57E77"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.4599 61.6647H8.98047V63.1741H10.4599V61.6647Z",
    fill: "#F57E77"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5027 60.1557H8.95898V61.7082H10.5027V60.1557Z",
    fill: "#F57E77"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.4599 60.1775H8.98047V61.6653H10.4599V60.1775Z",
    fill: "#F57E77"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5027 58.647H8.95898V60.1995H10.5027V58.647Z",
    fill: "#F57E77"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.4599 58.6688H8.98047V60.1782H10.4599V58.6688Z",
    fill: "#F57E77"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5027 57.1593H8.95898V58.7118H10.5027V57.1593Z",
    fill: "#F57E77"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.4599 57.1811H8.98047V58.6905H10.4599V57.1811Z",
    fill: "#F57E77"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5027 55.6505H8.95898V57.203H10.5027V55.6505Z",
    fill: "#F57E77"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.4599 55.6723H8.98047V57.1817H10.4599V55.6723Z",
    fill: "#F57E77"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5027 54.1633H8.95898V55.7159H10.5027V54.1633Z",
    fill: "#F57E77"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.4599 54.1851H8.98047V55.673H10.4599V54.1851Z",
    fill: "#F57E77"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5027 52.6541H8.95898V54.2066H10.5027V52.6541Z",
    fill: "#F57E77"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.4599 52.6758H8.98047V54.1852H10.4599V52.6758Z",
    fill: "#F57E77"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5027 51.1453H8.95898V52.6979H10.5027V51.1453Z",
    fill: "#F57E77"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.4599 51.1887H8.98047V52.6981H10.4599V51.1887Z",
    fill: "#F57E77"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5027 49.6581H8.95898V51.2107H10.5027V49.6581Z",
    fill: "#F57E77"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.4599 49.6799H8.98047V51.1678H10.4599V49.6799Z",
    fill: "#F57E77"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5027 48.1494H8.95898V49.7019H10.5027V48.1494Z",
    fill: "#F57E77"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.4599 48.1704H8.98047V49.6798H10.4599V48.1704Z",
    fill: "#F57E77"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5027 46.6622H8.95898V48.2147H10.5027V46.6622Z",
    fill: "#200C2B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5027 45.153H8.95898V46.7055H10.5027V45.153Z",
    fill: "#200C2B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.4599 45.1744H8.98047V46.6838H10.4599V45.1744Z",
    fill: "#2F143E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5027 43.6657H8.95898V45.2182H10.5027V43.6657Z",
    fill: "#200C2B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.4599 43.687H8.98047V45.1748H10.4599V43.687Z",
    fill: "#2F143E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5027 42.157H8.95898V43.7095H10.5027V42.157Z",
    fill: "#200C2B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.4599 42.178H8.98047V43.6874H10.4599V42.178Z",
    fill: "#2F143E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5027 40.6693H8.95898V42.2218H10.5027V40.6693Z",
    fill: "#2F143E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.4599 40.691H8.98047V42.2004H10.4599V40.691Z",
    fill: "#2F143E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5027 39.1605H8.95898V40.713H10.5027V39.1605Z",
    fill: "#2F143E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.4599 39.1821H8.98047V40.6915H10.4599V39.1821Z",
    fill: "#2F143E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5027 37.6733H8.95898V39.2259H10.5027V37.6733Z",
    fill: "#2F143E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.4599 37.6951H8.98047V39.183H10.4599V37.6951Z",
    fill: "#2F143E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5027 36.1641H8.95898V37.7166H10.5027V36.1641Z",
    fill: "#2F143E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.4599 36.1859H8.98047V37.6952H10.4599V36.1859Z",
    fill: "#2F143E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5027 34.6553H8.95898V36.2079H10.5027V34.6553Z",
    fill: "#243454"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.4599 34.6987H8.98047V36.2081H10.4599V34.6987Z",
    fill: "#243454"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5027 33.1681H8.95898V34.7206H10.5027V33.1681Z",
    fill: "#243454"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.4599 33.1899H8.98047V34.6993H10.4599V33.1899Z",
    fill: "#243454"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5027 31.6589H8.95898V33.2114H10.5027V31.6589Z",
    fill: "#243454"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.4599 31.7022H8.98047V33.19H10.4599V31.7022Z",
    fill: "#243454"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5027 30.1717H8.95898V31.7242H10.5027V30.1717Z",
    fill: "#243454"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.4599 30.1935H8.98047V31.7029H10.4599V30.1935Z",
    fill: "#243454"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5027 28.6629H8.95898V30.2154H10.5027V28.6629Z",
    fill: "#243454"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.4599 28.6844H8.98047V30.1938H10.4599V28.6844Z",
    fill: "#243454"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5027 27.1757H8.95898V28.7282H10.5027V27.1757Z",
    fill: "#131E33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.4599 27.1975H8.98047V28.7069H10.4599V27.1975Z",
    fill: "#131E33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5027 25.667H8.95898V27.2195H10.5027V25.667Z",
    fill: "#243454"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.4599 25.688H8.98047V27.1758H10.4599V25.688Z",
    fill: "#243454"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5027 24.1793H8.95898V25.7318H10.5027V24.1793Z",
    fill: "#243454"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.4599 24.201H8.98047V25.7104H10.4599V24.201Z",
    fill: "#243454"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5027 22.6705H8.95898V24.2231H10.5027V22.6705Z",
    fill: "#243454"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.4599 22.6921H8.98047V24.2015H10.4599V22.6921Z",
    fill: "#243454"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5027 21.1833H8.95898V22.7358H10.5027V21.1833Z",
    fill: "#FFE4CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.4599 21.2046H8.98047V22.714H10.4599V21.2046Z",
    fill: "#FFE4CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5027 19.6746H8.95898V21.2271H10.5027V19.6746Z",
    fill: "#FFE4CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.4599 19.6961H8.98047V21.1839H10.4599V19.6961Z",
    fill: "#FFE4CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5027 18.1869H8.95898V19.7394H10.5027V18.1869Z",
    fill: "#FFE4CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.4599 18.2087H8.98047V19.7181H10.4599V18.2087Z",
    fill: "#FFE4CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5027 16.6781H8.95898V18.2306H10.5027V16.6781Z",
    fill: "#FFE4CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.4599 16.6996H8.98047V18.209H10.4599V16.6996Z",
    fill: "#FFE4CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5027 15.1694H8.95898V16.7219H10.5027V15.1694Z",
    fill: "#F57E77"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.4599 15.2127H8.98047V16.7005H10.4599V15.2127Z",
    fill: "#F57E77"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5027 13.6816H8.95898V15.2342H10.5027V13.6816Z",
    fill: "#FFE4CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.4599 13.7032H8.98047V15.2126H10.4599V13.7032Z",
    fill: "#FFE4CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5027 12.1729H8.95898V13.7254H10.5027V12.1729Z",
    fill: "#FFE4CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.4599 12.1945H8.98047V13.7039H10.4599V12.1945Z",
    fill: "#FFE4CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5027 10.6857H8.95898V12.2383H10.5027V10.6857Z",
    fill: "#FFE4CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.4599 10.7073H8.98047V12.2167H10.4599V10.7073Z",
    fill: "#FFE4CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5027 9.17694H8.95898V10.7295H10.5027V9.17694Z",
    fill: "#66667C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.4599 9.198H8.98047V10.6858H10.4599V9.198Z",
    fill: "#66667C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5027 7.68927H8.95898V9.24179H10.5027V7.68927Z",
    fill: "#FFE4CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.4599 7.71082H8.98047V9.22021H10.4599V7.71082Z",
    fill: "#FFE4CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5027 6.18054H8.95898V7.73307H10.5027V6.18054Z",
    fill: "#3D041F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.4599 6.20203H8.98047V7.71142H10.4599V6.20203Z",
    fill: "#3D041F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5027 4.69281H8.95898V6.24533H10.5027V4.69281Z",
    fill: "#621931"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.4599 4.71436H8.98047V6.22375H10.4599V4.71436Z",
    fill: "#621931"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5027 3.18457H8.95898V4.73709H10.5027V3.18457Z",
    fill: "#621931"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.4599 3.20563H8.98047V4.69346H10.4599V3.20563Z",
    fill: "#621931"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.00273 67.6353H7.45898V69.1878H9.00273V67.6353Z",
    fill: "#382A4C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.98133 67.6571H7.48047V69.1665H8.98133V67.6571Z",
    fill: "#382A4C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.00273 66.1481H7.45898V67.7007H9.00273V66.1481Z",
    fill: "#FFE4CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.98133 66.1699H7.48047V67.6578H8.98133V66.1699Z",
    fill: "#FFE4CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.00273 64.6394H7.45898V66.1919H9.00273V64.6394Z",
    fill: "#FFE4CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.98133 64.6611H7.48047V66.1705H8.98133V64.6611Z",
    fill: "#FFE4CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.00273 63.1517H7.45898V64.7042H9.00273V63.1517Z",
    fill: "#FFE4CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.98133 63.1735H7.48047V64.6829H8.98133V63.1735Z",
    fill: "#FFE4CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.00273 61.6429H7.45898V63.1955H9.00273V61.6429Z",
    fill: "#FFE4CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.98133 61.6647H7.48047V63.1741H8.98133V61.6647Z",
    fill: "#FFE4CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.00273 60.1557H7.45898V61.7082H9.00273V60.1557Z",
    fill: "#FFE4CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.98133 60.1775H7.48047V61.6653H8.98133V60.1775Z",
    fill: "#FFE4CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.00273 58.647H7.45898V60.1995H9.00273V58.647Z",
    fill: "#FFE4CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.98133 58.6688H7.48047V60.1782H8.98133V58.6688Z",
    fill: "#FFE4CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.00273 57.1593H7.45898V58.7118H9.00273V57.1593Z",
    fill: "#FFE4CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.98133 57.1811H7.48047V58.6905H8.98133V57.1811Z",
    fill: "#FFE4CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.00273 55.6505H7.45898V57.203H9.00273V55.6505Z",
    fill: "#FFE4CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.98133 55.6723H7.48047V57.1817H8.98133V55.6723Z",
    fill: "#FFE4CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.00273 54.1633H7.45898V55.7159H9.00273V54.1633Z",
    fill: "#FFE4CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.98133 54.1851H7.48047V55.673H8.98133V54.1851Z",
    fill: "#FFE4CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.00273 52.6541H7.45898V54.2066H9.00273V52.6541Z",
    fill: "#FFE4CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.98133 52.6758H7.48047V54.1852H8.98133V52.6758Z",
    fill: "#FFE4CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.00273 51.1453H7.45898V52.6979H9.00273V51.1453Z",
    fill: "#FFE4CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.98133 51.1887H7.48047V52.6981H8.98133V51.1887Z",
    fill: "#FFE4CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.00273 49.6581H7.45898V51.2107H9.00273V49.6581Z",
    fill: "#FFE4CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.98133 49.6799H7.48047V51.1678H8.98133V49.6799Z",
    fill: "#FFE4CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.00273 48.1494H7.45898V49.7019H9.00273V48.1494Z",
    fill: "#FFE4CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.98133 48.1704H7.48047V49.6798H8.98133V48.1704Z",
    fill: "#FFE4CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.00273 46.6622H7.45898V48.2147H9.00273V46.6622Z",
    fill: "#2F143E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.98133 46.6835H7.48047V48.1929H8.98133V46.6835Z",
    fill: "#2F143E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.00273 45.153H7.45898V46.7055H9.00273V45.153Z",
    fill: "#2F143E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.98133 45.1744H7.48047V46.6838H8.98133V45.1744Z",
    fill: "#2F143E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.00273 43.6657H7.45898V45.2182H9.00273V43.6657Z",
    fill: "#2F143E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.98133 43.687H7.48047V45.1748H8.98133V43.687Z",
    fill: "#2F143E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.00273 42.157H7.45898V43.7095H9.00273V42.157Z",
    fill: "#2F143E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.98133 42.178H7.48047V43.6874H8.98133V42.178Z",
    fill: "#2F143E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.00273 40.6693H7.45898V42.2218H9.00273V40.6693Z",
    fill: "#2F143E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.98133 40.691H7.48047V42.2004H8.98133V40.691Z",
    fill: "#2F143E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.00273 39.1605H7.45898V40.713H9.00273V39.1605Z",
    fill: "#2F143E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.98133 39.1821H7.48047V40.6915H8.98133V39.1821Z",
    fill: "#2F143E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.00273 37.6733H7.45898V39.2259H9.00273V37.6733Z",
    fill: "#2F143E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.98133 37.6951H7.48047V39.183H8.98133V37.6951Z",
    fill: "#2F143E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.00273 36.1641H7.45898V37.7166H9.00273V36.1641Z",
    fill: "#2F143E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.98133 36.1859H7.48047V37.6952H8.98133V36.1859Z",
    fill: "#2F143E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.00273 34.6553H7.45898V36.2079H9.00273V34.6553Z",
    fill: "#243454"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.98133 34.6987H7.48047V36.2081H8.98133V34.6987Z",
    fill: "#243454"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.00273 33.1681H7.45898V34.7206H9.00273V33.1681Z",
    fill: "#243454"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.98133 33.1899H7.48047V34.6993H8.98133V33.1899Z",
    fill: "#243454"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.00273 31.6589H7.45898V33.2114H9.00273V31.6589Z",
    fill: "#243454"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.98133 31.7022H7.48047V33.19H8.98133V31.7022Z",
    fill: "#243454"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.00273 30.1717H7.45898V31.7242H9.00273V30.1717Z",
    fill: "#243454"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.98133 30.1935H7.48047V31.7029H8.98133V30.1935Z",
    fill: "#243454"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.00273 28.6629H7.45898V30.2154H9.00273V28.6629Z",
    fill: "#243454"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.98133 28.6844H7.48047V30.1938H8.98133V28.6844Z",
    fill: "#243454"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.00273 27.1757H7.45898V28.7282H9.00273V27.1757Z",
    fill: "#131E33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.98133 27.1975H7.48047V28.7069H8.98133V27.1975Z",
    fill: "#131E33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.00273 25.667H7.45898V27.2195H9.00273V25.667Z",
    fill: "#243454"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.98133 25.688H7.48047V27.1758H8.98133V25.688Z",
    fill: "#243454"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.00273 24.1793H7.45898V25.7318H9.00273V24.1793Z",
    fill: "#243454"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.98133 24.201H7.48047V25.7104H8.98133V24.201Z",
    fill: "#243454"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.00273 22.6705H7.45898V24.2231H9.00273V22.6705Z",
    fill: "#243454"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.98133 22.6921H7.48047V24.2015H8.98133V22.6921Z",
    fill: "#243454"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.00273 21.1833H7.45898V22.7358H9.00273V21.1833Z",
    fill: "#243454"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.98133 21.2046H7.48047V22.714H8.98133V21.2046Z",
    fill: "#243454"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.00273 19.6746H7.45898V21.2271H9.00273V19.6746Z",
    fill: "#FFE4CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.98133 19.6961H7.48047V21.1839H8.98133V19.6961Z",
    fill: "#FFE4CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.00273 18.1869H7.45898V19.7394H9.00273V18.1869Z",
    fill: "#FFE4CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.98133 18.2087H7.48047V19.7181H8.98133V18.2087Z",
    fill: "#FFE4CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.00273 13.6816H7.45898V15.2342H9.00273V13.6816Z",
    fill: "#FFE4CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.98133 13.7032H7.48047V15.2126H8.98133V13.7032Z",
    fill: "#FFE4CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.00273 12.1729H7.45898V13.7254H9.00273V12.1729Z",
    fill: "#FFE4CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.98133 12.1945H7.48047V13.7039H8.98133V12.1945Z",
    fill: "#FFE4CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.00273 10.6857H7.45898V12.2383H9.00273V10.6857Z",
    fill: "#FFE4CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.98133 10.7073H7.48047V12.2167H8.98133V10.7073Z",
    fill: "#FFE4CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.00273 9.17694H7.45898V10.7295H9.00273V9.17694Z",
    fill: "#FFE4CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.98133 9.198H7.48047V10.6858H8.98133V9.198Z",
    fill: "#FFE4CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.00273 7.68927H7.45898V9.24179H9.00273V7.68927Z",
    fill: "#3D041F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.98133 7.71082H7.48047V9.22021H8.98133V7.71082Z",
    fill: "#3D041F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.00273 6.18054H7.45898V7.73307H9.00273V6.18054Z",
    fill: "#3D041F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.98133 6.20203H7.48047V7.71142H8.98133V6.20203Z",
    fill: "#3D041F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.00273 4.69281H7.45898V6.24533H9.00273V4.69281Z",
    fill: "#621931"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.98133 4.71436H7.48047V6.22375H8.98133V4.71436Z",
    fill: "#621931"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.00273 3.18457H7.45898V4.73709H9.00273V3.18457Z",
    fill: "#621931"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.98133 3.20563H7.48047V4.69346H8.98133V3.20563Z",
    fill: "#621931"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.50225 67.6353H5.9585V69.1878H7.50225V67.6353Z",
    fill: "#382A4C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.48085 67.6571H5.97998V69.1665H7.48085V67.6571Z",
    fill: "#382A4C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.50225 66.1481H5.9585V67.7007H7.50225V66.1481Z",
    fill: "#FFE4CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.48085 66.1699H5.97998V67.6578H7.48085V66.1699Z",
    fill: "#FFE4CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.50225 64.6394H5.9585V66.1919H7.50225V64.6394Z",
    fill: "#FFE4CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.48085 64.6611H5.97998V66.1705H7.48085V64.6611Z",
    fill: "#FFE4CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.50225 63.1517H5.9585V64.7042H7.50225V63.1517Z",
    fill: "#FFE4CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.48085 63.1735H5.97998V64.6829H7.48085V63.1735Z",
    fill: "#FFE4CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.50225 46.6622H5.9585V48.2147H7.50225V46.6622Z",
    fill: "#2F143E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.48085 46.6835H5.97998V48.1929H7.48085V46.6835Z",
    fill: "#2F143E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.50225 45.153H5.9585V46.7055H7.50225V45.153Z",
    fill: "#2F143E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.48085 45.1744H5.97998V46.6838H7.48085V45.1744Z",
    fill: "#2F143E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.50225 43.6657H5.9585V45.2182H7.50225V43.6657Z",
    fill: "#2F143E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.48085 43.687H5.97998V45.1748H7.48085V43.687Z",
    fill: "#2F143E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.50225 42.157H5.9585V43.7095H7.50225V42.157Z",
    fill: "#2F143E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.48085 42.178H5.97998V43.6874H7.48085V42.178Z",
    fill: "#2F143E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.50225 40.6693H5.9585V42.2218H7.50225V40.6693Z",
    fill: "#2F143E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.48085 40.691H5.97998V42.2004H7.48085V40.691Z",
    fill: "#2F143E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.50225 39.1605H5.9585V40.713H7.50225V39.1605Z",
    fill: "#2F143E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.48085 39.1821H5.97998V40.6915H7.48085V39.1821Z",
    fill: "#2F143E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.50225 37.6733H5.9585V39.2259H7.50225V37.6733Z",
    fill: "#2F143E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.48085 37.6951H5.97998V39.183H7.48085V37.6951Z",
    fill: "#2F143E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.50225 36.1641H5.9585V37.7166H7.50225V36.1641Z",
    fill: "#200C2B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.48085 36.1859H5.97998V37.6952H7.48085V36.1859Z",
    fill: "#200C2B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.50225 34.6553H5.9585V36.2079H7.50225V34.6553Z",
    fill: "#243454"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.48085 34.6987H5.97998V36.2081H7.48085V34.6987Z",
    fill: "#243454"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.50225 33.1681H5.9585V34.7206H7.50225V33.1681Z",
    fill: "#131E33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.48085 33.1899H5.97998V34.6993H7.48085V33.1899Z",
    fill: "#131E33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.50225 31.6589H5.9585V33.2114H7.50225V31.6589Z",
    fill: "#131E33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.48085 31.7022H5.97998V33.19H7.48085V31.7022Z",
    fill: "#131E33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.50225 25.667H5.9585V27.2195H7.50225V25.667Z",
    fill: "#243454"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.48085 25.688H5.97998V27.1758H7.48085V25.688Z",
    fill: "#243454"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.50225 24.1793H5.9585V25.7318H7.50225V24.1793Z",
    fill: "#243454"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.48085 24.201H5.97998V25.7104H7.48085V24.201Z",
    fill: "#243454"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.50225 22.6705H5.9585V24.2231H7.50225V22.6705Z",
    fill: "#243454"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.48085 22.6921H5.97998V24.2015H7.48085V22.6921Z",
    fill: "#243454"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.50225 21.1833H5.9585V22.7358H7.50225V21.1833Z",
    fill: "#243454"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.48085 21.2046H5.97998V22.714H7.48085V21.2046Z",
    fill: "#243454"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.50225 19.6746H5.9585V21.2271H7.50225V19.6746Z",
    fill: "#243454"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.48085 19.6961H5.97998V21.1839H7.48085V19.6961Z",
    fill: "#243454"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.50225 18.1869H5.9585V19.7394H7.50225V18.1869Z",
    fill: "#131E33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.48085 18.2087H5.97998V19.7181H7.48085V18.2087Z",
    fill: "#131E33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.50225 13.6816H5.9585V15.2342H7.50225V13.6816Z",
    fill: "#3D041F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.48085 13.7032H5.97998V15.2126H7.48085V13.7032Z",
    fill: "#3D041F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.50225 12.1729H5.9585V13.7254H7.50225V12.1729Z",
    fill: "#F57E77"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.48085 12.1945H5.97998V13.7039H7.48085V12.1945Z",
    fill: "#F57E77"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.50225 10.6857H5.9585V12.2383H7.50225V10.6857Z",
    fill: "#FFE4CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.48085 10.7073H5.97998V12.2167H7.48085V10.7073Z",
    fill: "#FFE4CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.50225 9.17694H5.9585V10.7295H7.50225V9.17694Z",
    fill: "#3D041F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.48085 9.198H5.97998V10.6858H7.48085V9.198Z",
    fill: "#3D041F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.50225 7.68927H5.9585V9.24179H7.50225V7.68927Z",
    fill: "#3D041F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.48085 7.71082H5.97998V9.22021H7.48085V7.71082Z",
    fill: "#3D041F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.50225 6.18054H5.9585V7.73307H7.50225V6.18054Z",
    fill: "#621931"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.48085 6.20203H5.97998V7.71142H7.48085V6.20203Z",
    fill: "#621931"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.50225 4.69281H5.9585V6.24533H7.50225V4.69281Z",
    fill: "#621931"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.48085 4.71436H5.97998V6.22375H7.48085V4.71436Z",
    fill: "#621931"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.02324 67.6353H4.47949V69.1878H6.02324V67.6353Z",
    fill: "#382A4C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.00184 67.6571H4.50098V69.1665H6.00184V67.6571Z",
    fill: "#382A4C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.02324 66.1481H4.47949V67.7007H6.02324V66.1481Z",
    fill: "#382A4C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.02324 64.6394H4.47949V66.1919H6.02324V64.6394Z",
    fill: "#FFE4CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.00184 64.6611H4.50098V66.1705H6.00184V64.6611Z",
    fill: "#FFE4CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.02324 40.6693H4.47949V42.2218H6.02324V40.6693Z",
    fill: "#2F143E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.00184 40.691H4.50098V42.2004H6.00184V40.691Z",
    fill: "#2F143E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.02324 39.1605H4.47949V40.713H6.02324V39.1605Z",
    fill: "#200C2B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.00184 39.1821H4.50098V40.6915H6.00184V39.1821Z",
    fill: "#200C2B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.02324 37.6733H4.47949V39.2259H6.02324V37.6733Z",
    fill: "#200C2B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.00184 37.6951H4.50098V39.183H6.00184V37.6951Z",
    fill: "#200C2B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.02324 36.1641H4.47949V37.7166H6.02324V36.1641Z",
    fill: "#200C2B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.00184 36.1859H4.50098V37.6952H6.00184V36.1859Z",
    fill: "#200C2B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.02324 34.6553H4.47949V36.2079H6.02324V34.6553Z",
    fill: "#131E33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.00184 34.6987H4.50098V36.2081H6.00184V34.6987Z",
    fill: "#131E33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.02324 22.6705H4.47949V24.2231H6.02324V22.6705Z",
    fill: "#131E33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.00184 22.6921H4.50098V24.2015H6.00184V22.6921Z",
    fill: "#131E33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.02324 21.1833H4.47949V22.7358H6.02324V21.1833Z",
    fill: "#243454"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.00184 21.2046H4.50098V22.714H6.00184V21.2046Z",
    fill: "#243454"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.02324 19.6746H4.47949V21.2271H6.02324V19.6746Z",
    fill: "#243454"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.00184 19.6961H4.50098V21.1839H6.00184V19.6961Z",
    fill: "#243454"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.02324 18.1869H4.47949V19.7394H6.02324V18.1869Z",
    fill: "#243454"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.00184 18.2087H4.50098V19.7181H6.00184V18.2087Z",
    fill: "#243454"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.02324 12.1729H4.47949V13.7254H6.02324V12.1729Z",
    fill: "#621931"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.00184 12.1945H4.50098V13.7039H6.00184V12.1945Z",
    fill: "#621931"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.02324 10.6857H4.47949V12.2383H6.02324V10.6857Z",
    fill: "#621931"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.00184 10.7073H4.50098V12.2167H6.00184V10.7073Z",
    fill: "#621931"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.02324 9.17694H4.47949V10.7295H6.02324V9.17694Z",
    fill: "#621931"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.00184 9.198H4.50098V10.6858H6.00184V9.198Z",
    fill: "#621931"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.02324 7.68927H4.47949V9.24179H6.02324V7.68927Z",
    fill: "#621931"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.00184 7.71082H4.50098V9.22021H6.00184V7.71082Z",
    fill: "#621931"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.52324 67.6353H2.97949V69.1878H4.52324V67.6353Z",
    fill: "#382A4C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.4804 67.6571H3.00098V69.1665H4.4804V67.6571Z",
    fill: "#382A4C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.52324 66.1481H2.97949V67.7007H4.52324V66.1481Z",
    fill: "#F57E77"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.52324 64.6394H2.97949V66.1919H4.52324V64.6394Z",
    fill: "#382A4C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.4804 64.6611H3.00098V66.1705H4.4804V64.6611Z",
    fill: "#382A4C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.52324 42.157H2.97949V43.7095H4.52324V42.157Z",
    fill: "#FFE4CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.4804 42.178H3.00098V43.6874H4.4804V42.178Z",
    fill: "#FFE4CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.52324 40.6693H2.97949V42.2218H4.52324V40.6693Z",
    fill: "#F57E77"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.4804 40.691H3.00098V42.2004H4.4804V40.691Z",
    fill: "#F57E77"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.52324 24.1793H2.97949V25.7318H4.52324V24.1793Z",
    fill: "#131E33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.4804 24.201H3.00098V25.7104H4.4804V24.201Z",
    fill: "#131E33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.52324 22.6705H2.97949V24.2231H4.52324V22.6705Z",
    fill: "#131E33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.4804 22.6921H3.00098V24.2015H4.4804V22.6921Z",
    fill: "#131E33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.52324 21.1833H2.97949V22.7358H4.52324V21.1833Z",
    fill: "#243454"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.4804 21.2046H3.00098V22.714H4.4804V21.2046Z",
    fill: "#243454"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.52324 19.6746H2.97949V21.2271H4.52324V19.6746Z",
    fill: "#243454"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.4804 19.6961H3.00098V21.1839H4.4804V19.6961Z",
    fill: "#243454"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.04423 67.6353H1.50049V69.1878H3.04423V67.6353Z",
    fill: "#382A4C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.02284 67.6571H1.52197V69.1665H3.02284V67.6571Z",
    fill: "#382A4C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.04423 43.6657H1.50049V45.2182H3.04423V43.6657Z",
    fill: "#FFE4CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.02284 43.687H1.52197V45.1748H3.02284V43.687Z",
    fill: "#FFE4CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.04423 42.157H1.50049V43.7095H3.04423V42.157Z",
    fill: "#FFE4CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.02284 42.178H1.52197V43.6874H3.02284V42.178Z",
    fill: "#FFE4CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.04423 40.6693H1.50049V42.2218H3.04423V40.6693Z",
    fill: "#FFE4CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.02284 40.691H1.52197V42.2004H3.02284V40.691Z",
    fill: "#FFE4CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.04423 39.1605H1.50049V40.713H3.04423V39.1605Z",
    fill: "#F57E77"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.02284 39.1821H1.52197V40.6915H3.02284V39.1821Z",
    fill: "#F57E77"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.04423 37.6733H1.50049V39.2259H3.04423V37.6733Z",
    fill: "#131E33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.02284 37.6951H1.52197V39.183H3.02284V37.6951Z",
    fill: "#131E33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.04423 36.1641H1.50049V37.7166H3.04423V36.1641Z",
    fill: "#131E33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.02284 36.1859H1.52197V37.6952H3.02284V36.1859Z",
    fill: "#131E33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.04423 34.6553H1.50049V36.2079H3.04423V34.6553Z",
    fill: "#131E33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.02284 34.6987H1.52197V36.2081H3.02284V34.6987Z",
    fill: "#131E33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.04423 33.1681H1.50049V34.7206H3.04423V33.1681Z",
    fill: "#131E33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.02284 33.1899H1.52197V34.6993H3.02284V33.1899Z",
    fill: "#131E33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.04423 31.6589H1.50049V33.2114H3.04423V31.6589Z",
    fill: "#131E33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.02284 31.7022H1.52197V33.19H3.02284V31.7022Z",
    fill: "#131E33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.04423 30.1717H1.50049V31.7242H3.04423V30.1717Z",
    fill: "#131E33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.02284 30.1935H1.52197V31.7029H3.02284V30.1935Z",
    fill: "#131E33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.04423 28.6629H1.50049V30.2154H3.04423V28.6629Z",
    fill: "#131E33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.02284 28.6844H1.52197V30.1938H3.02284V28.6844Z",
    fill: "#131E33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.04423 27.1757H1.50049V28.7282H3.04423V27.1757Z",
    fill: "#131E33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.02284 27.1975H1.52197V28.7069H3.02284V27.1975Z",
    fill: "#131E33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.04423 25.667H1.50049V27.2195H3.04423V25.667Z",
    fill: "#131E33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.02284 25.688H1.52197V27.1758H3.02284V25.688Z",
    fill: "#131E33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.04423 24.1793H1.50049V25.7318H3.04423V24.1793Z",
    fill: "#243454"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.02284 24.201H1.52197V25.7104H3.02284V24.201Z",
    fill: "#243454"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.04423 22.6705H1.50049V24.2231H3.04423V22.6705Z",
    fill: "#243454"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.02284 22.6921H1.52197V24.2015H3.02284V22.6921Z",
    fill: "#243454"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.04423 21.1833H1.50049V22.7358H3.04423V21.1833Z",
    fill: "#243454"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.02284 21.2046H1.52197V22.714H3.02284V21.2046Z",
    fill: "#243454"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.54375 43.6657H0V45.2182H1.54375V43.6657Z",
    fill: "#FFE4CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.52235 43.687H0.0214844V45.1748H1.52235V43.687Z",
    fill: "#FFE4CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.54375 42.157H0V43.7095H1.54375V42.157Z",
    fill: "#FFE4CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.52235 42.178H0.0214844V43.6874H1.52235V42.178Z",
    fill: "#FFE4CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.54375 40.6693H0V42.2218H1.54375V40.6693Z",
    fill: "#FFE4CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.52235 40.691H0.0214844V42.2004H1.52235V40.691Z",
    fill: "#FFE4CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.54375 39.1605H0V40.713H1.54375V39.1605Z",
    fill: "#FFE4CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.52235 39.1821H0.0214844V40.6915H1.52235V39.1821Z",
    fill: "#FFE4CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.54375 37.6733H0V39.2259H1.54375V37.6733Z",
    fill: "#243454"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.52235 37.6951H0.0214844V39.183H1.52235V37.6951Z",
    fill: "#243454"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.54375 36.1641H0V37.7166H1.54375V36.1641Z",
    fill: "#243454"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.52235 36.1859H0.0214844V37.6952H1.52235V36.1859Z",
    fill: "#243454"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.54375 34.6553H0V36.2079H1.54375V34.6553Z",
    fill: "#243454"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.52235 34.6987H0.0214844V36.2081H1.52235V34.6987Z",
    fill: "#243454"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.54375 33.1681H0V34.7206H1.54375V33.1681Z",
    fill: "#243454"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.52235 33.1899H0.0214844V34.6993H1.52235V33.1899Z",
    fill: "#243454"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.54375 31.6589H0V33.2114H1.54375V31.6589Z",
    fill: "#243454"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.52235 31.7022H0.0214844V33.19H1.52235V31.7022Z",
    fill: "#243454"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.54375 30.1717H0V31.7242H1.54375V30.1717Z",
    fill: "#243454"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.52235 30.1935H0.0214844V31.7029H1.52235V30.1935Z",
    fill: "#243454"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.54375 28.6629H0V30.2154H1.54375V28.6629Z",
    fill: "#243454"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.52235 28.6844H0.0214844V30.1938H1.52235V28.6844Z",
    fill: "#243454"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.54375 27.1757H0V28.7282H1.54375V27.1757Z",
    fill: "#243454"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.52235 27.1975H0.0214844V28.7069H1.52235V27.1975Z",
    fill: "#243454"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.54375 25.667H0V27.2195H1.54375V25.667Z",
    fill: "#243454"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.52235 25.688H0.0214844V27.1758H1.52235V25.688Z",
    fill: "#243454"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.54375 24.1793H0V25.7318H1.54375V24.1793Z",
    fill: "#243454"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.52235 24.201H0.0214844V25.7104H1.52235V24.201Z",
    fill: "#243454"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.54375 22.6705H0V24.2231H1.54375V22.6705Z",
    fill: "#243454"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.52235 22.6921H0.0214844V24.2015H1.52235V22.6921Z",
    fill: "#243454"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.1405 38.8325H8.44922V48.1928H14.1405V38.8325Z",
    fill: "#2F143E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.8985 66.1699H17.8301V68.0668H20.8985V66.1699Z",
    fill: "#382A4C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.4804 66.1699H3.00098V68.0671H4.4804V66.1699Z",
    fill: "#382A4C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.02284 66.1699H1.52197V68.0671H3.02284V66.1699Z",
    fill: "#382A4C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.00192 66.1699H3.6084V67.944H6.00192V66.1699Z",
    fill: "#382A4C"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLevel3Clothes);
export default __webpack_public_path__ + "static/media/level3Clothes.b6c1087fa13034b36337ff128826ef9a.svg";
export { ForwardRef as ReactComponent };